/* tslint:disable */
/* eslint-disable */
/**
 * GUD.WorkshopPortal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddressInformationModel
 */
export interface AddressInformationModel {
    /**
     * 
     * @type {string}
     * @memberof AddressInformationModel
     */
    'street1': string;
    /**
     * 
     * @type {string}
     * @memberof AddressInformationModel
     */
    'street2': string;
    /**
     * 
     * @type {string}
     * @memberof AddressInformationModel
     */
    'suburb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressInformationModel
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof AddressInformationModel
     */
    'region': string;
    /**
     * 
     * @type {string}
     * @memberof AddressInformationModel
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof AddressInformationModel
     */
    'telephone': string;
}
/**
 * 
 * @export
 * @interface AdvanceWorkshopViewModel
 */
export interface AdvanceWorkshopViewModel {
    /**
     * 
     * @type {string}
     * @memberof AdvanceWorkshopViewModel
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof AdvanceWorkshopViewModel
     */
    'balance': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ApplicationClaimType = {
    ManageProducts: 'ManageProducts',
    ManageUsers: 'ManageUsers',
    ManageWorkshops: 'ManageWorkshops',
    ManageClaims: 'ManageClaims',
    AdvanceSystemUser: 'AdvanceSystemUser',
    ManageReturns: 'ManageReturns',
    ViewReturns: 'ViewReturns',
    ViewProducts: 'ViewProducts',
    ViewUsers: 'ViewUsers',
    ViewWorkshops: 'ViewWorkshops',
    ViewClaims: 'ViewClaims',
    ViewAuditLogs: 'ViewAuditLogs',
    ViewBulletins: 'ViewBulletins',
    ManageBulletins: 'ManageBulletins',
    ViewRewardsStore: 'ViewRewardsStore',
    ManageQuoteSettings: 'ManageQuoteSettings',
    ManageQuotes: 'ManageQuotes'
} as const;

export type ApplicationClaimType = typeof ApplicationClaimType[keyof typeof ApplicationClaimType];


/**
 * 
 * @export
 * @interface AuditLogDto
 */
export interface AuditLogDto {
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    'field': string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    'oldValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    'newValue': string;
    /**
     * 
     * @type {AuditTypes}
     * @memberof AuditLogDto
     */
    'auditLogTypesId': AuditTypes;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    'workshopId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    'typePrimaryKey': string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    'workshopName': string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    'createdDate': string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    'createdByUserDisplayName': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AuditTypes = {
    User: 'User',
    ApplicationUserRole: 'ApplicationUserRole',
    Workshop: 'Workshop',
    LoyaltyPointsTransaction: 'LoyaltyPointsTransaction',
    WorkshopUser: 'WorkshopUser',
    LoyaltyPointsClaim: 'LoyaltyPointsClaim',
    QuoteRequest: 'QuoteRequest',
    QuoteResponse: 'QuoteResponse',
    Booking: 'Booking'
} as const;

export type AuditTypes = typeof AuditTypes[keyof typeof AuditTypes];


/**
 * 
 * @export
 * @interface BookingPublicViewModel
 */
export interface BookingPublicViewModel {
    /**
     * 
     * @type {string}
     * @memberof BookingPublicViewModel
     */
    'id': string;
    /**
     * 
     * @type {BookingStatusEnum}
     * @memberof BookingPublicViewModel
     */
    'bookingStatusId': BookingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BookingPublicViewModel
     */
    'quoteResponseId': string;
    /**
     * 
     * @type {string}
     * @memberof BookingPublicViewModel
     */
    'additionalComments'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BookingPublicViewModel
     */
    'bookingRescheduleDates': Array<string>;
}
/**
 * 
 * @export
 * @interface BookingReviewViewModel
 */
export interface BookingReviewViewModel {
    /**
     * 
     * @type {string}
     * @memberof BookingReviewViewModel
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof BookingReviewViewModel
     */
    'workshopTenantId': number;
    /**
     * 
     * @type {number}
     * @memberof BookingReviewViewModel
     */
    'bookingTenantId': number;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewViewModel
     */
    'bookingId': string;
    /**
     * 
     * @type {number}
     * @memberof BookingReviewViewModel
     */
    'rating': number;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewViewModel
     */
    'submissionDate': string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewViewModel
     */
    'additionalFeedback'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewViewModel
     */
    'response'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewViewModel
     */
    'workshopName': string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewViewModel
     */
    'quoteRequestCustomerFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewViewModel
     */
    'quoteRequestCustomerLastName': string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewViewModel
     */
    'quoteRequestId': string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewViewModel
     */
    'quoteRequestReferenceNumber': string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewViewModel
     */
    'quoteResponseId': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const BookingStatusEnum = {
    Pending: 'Pending',
    AwaitingDateConfirmationByWorkshop: 'AwaitingDateConfirmationByWorkshop',
    AwaitingDateConfirmationByCustomer: 'AwaitingDateConfirmationByCustomer',
    Completed: 'Completed',
    Cancelled: 'Cancelled'
} as const;

export type BookingStatusEnum = typeof BookingStatusEnum[keyof typeof BookingStatusEnum];


/**
 * 
 * @export
 * @interface BookingWorkshopViewModel
 */
export interface BookingWorkshopViewModel {
    /**
     * 
     * @type {string}
     * @memberof BookingWorkshopViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BookingWorkshopViewModel
     */
    'date': string;
    /**
     * 
     * @type {BookingStatusEnum}
     * @memberof BookingWorkshopViewModel
     */
    'bookingStatusId': BookingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BookingWorkshopViewModel
     */
    'additionalComments'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BookingWorkshopViewModel
     */
    'bookingRescheduleDates': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BookingWorkshopViewModel
     */
    'bookingReviewId'?: string | null;
}
/**
 * 
 * @export
 * @interface BulkImportProductsCommand
 */
export interface BulkImportProductsCommand {
    /**
     * 
     * @type {string}
     * @memberof BulkImportProductsCommand
     */
    'fileRelativeUrl': string;
}
/**
 * 
 * @export
 * @interface BulkImportProductsSkuAliasesCommand
 */
export interface BulkImportProductsSkuAliasesCommand {
    /**
     * 
     * @type {string}
     * @memberof BulkImportProductsSkuAliasesCommand
     */
    'fileRelativeUrl': string;
}
/**
 * 
 * @export
 * @interface BulkReviewLoyaltyPointsClaimAdminCommand
 */
export interface BulkReviewLoyaltyPointsClaimAdminCommand {
    /**
     * 
     * @type {string}
     * @memberof BulkReviewLoyaltyPointsClaimAdminCommand
     */
    'searchText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BulkReviewLoyaltyPointsClaimAdminCommand
     */
    'workshopId'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof BulkReviewLoyaltyPointsClaimAdminCommand
     */
    'sortDirection': SortDirection;
    /**
     * 
     * @type {boolean}
     * @memberof BulkReviewLoyaltyPointsClaimAdminCommand
     */
    'isFullMatch'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof BulkReviewLoyaltyPointsClaimAdminCommand
     */
    'dateSubmittedStartDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BulkReviewLoyaltyPointsClaimAdminCommand
     */
    'dateSubmittedEndDate'?: string | null;
    /**
     * 
     * @type {LoyaltyPointClaimStatus}
     * @memberof BulkReviewLoyaltyPointsClaimAdminCommand
     */
    'reviewStatusId': LoyaltyPointClaimStatus;
    /**
     * 
     * @type {string}
     * @memberof BulkReviewLoyaltyPointsClaimAdminCommand
     */
    'reviewComment'?: string | null;
}
/**
 * 
 * @export
 * @interface BulletinDto
 */
export interface BulletinDto {
    /**
     * 
     * @type {string}
     * @memberof BulletinDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BulletinDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof BulletinDto
     */
    'thumbnailRelativeUrl': string;
    /**
     * 
     * @type {string}
     * @memberof BulletinDto
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BulletinDto
     */
    'contentRelativeUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BulletinDto
     */
    'publishDate': string;
    /**
     * 
     * @type {BulletinType}
     * @memberof BulletinDto
     */
    'bulletinTypesId': BulletinType;
    /**
     * 
     * @type {boolean}
     * @memberof BulletinDto
     */
    'isRead': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const BulletinType = {
    Bulletin: 'Bulletin',
    Promotion: 'Promotion'
} as const;

export type BulletinType = typeof BulletinType[keyof typeof BulletinType];


/**
 * 
 * @export
 * @interface BulletinTypeCountDto
 */
export interface BulletinTypeCountDto {
    /**
     * 
     * @type {number}
     * @memberof BulletinTypeCountDto
     */
    'unreadBulletinCount': number;
    /**
     * 
     * @type {number}
     * @memberof BulletinTypeCountDto
     */
    'unreadPromotionCount': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const BusinessDayOfWeekEnum = {
    Sunday: 'Sunday',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    PublicHoliday: 'PublicHoliday'
} as const;

export type BusinessDayOfWeekEnum = typeof BusinessDayOfWeekEnum[keyof typeof BusinessDayOfWeekEnum];


/**
 * 
 * @export
 * @interface CancelBookingCommand
 */
export interface CancelBookingCommand {
    /**
     * 
     * @type {string}
     * @memberof CancelBookingCommand
     */
    'bookingId': string;
}
/**
 * 
 * @export
 * @interface CancelBookingPublicCommand
 */
export interface CancelBookingPublicCommand {
    /**
     * 
     * @type {string}
     * @memberof CancelBookingPublicCommand
     */
    'bookingId': string;
}
/**
 * 
 * @export
 * @interface ClaimListViewModel
 */
export interface ClaimListViewModel {
    /**
     * 
     * @type {ApplicationClaimType}
     * @memberof ClaimListViewModel
     */
    'id': ApplicationClaimType;
    /**
     * 
     * @type {string}
     * @memberof ClaimListViewModel
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CompleteBookingBulkCommand
 */
export interface CompleteBookingBulkCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof CompleteBookingBulkCommand
     */
    'bookingIds': Array<string>;
}
/**
 * 
 * @export
 * @interface CompleteBookingCommand
 */
export interface CompleteBookingCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteBookingCommand
     */
    'bookingId': string;
}
/**
 * 
 * @export
 * @interface ConfirmEmailDto
 */
export interface ConfirmEmailDto {
    /**
     * 
     * @type {string}
     * @memberof ConfirmEmailDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfirmEmailDto
     */
    'code'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateBookingCommand
 */
export interface CreateBookingCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateBookingCommand
     */
    'quoteRequestId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingCommand
     */
    'quoteResponseId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBookingCommand
     */
    'rescheduleDates': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingCommand
     */
    'additionalComments'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateBookingReviewCommand
 */
export interface CreateBookingReviewCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateBookingReviewCommand
     */
    'bookingId': string;
    /**
     * 
     * @type {number}
     * @memberof CreateBookingReviewCommand
     */
    'rating': number;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingReviewCommand
     */
    'additionalFeedback'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateBulletinCommand
 */
export interface CreateBulletinCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateBulletinCommand
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBulletinCommand
     */
    'thumbnailRelativeUrl': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBulletinCommand
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBulletinCommand
     */
    'contentRelativeUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBulletinCommand
     */
    'publishDate': string;
    /**
     * 
     * @type {BulletinType}
     * @memberof CreateBulletinCommand
     */
    'bulletinTypesId': BulletinType;
}
/**
 * 
 * @export
 * @interface CreateLoyaltyPointsManualTransactionCommand
 */
export interface CreateLoyaltyPointsManualTransactionCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateLoyaltyPointsManualTransactionCommand
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLoyaltyPointsManualTransactionCommand
     */
    'workshopId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLoyaltyPointsManualTransactionCommand
     */
    'referenceNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateLoyaltyPointsManualTransactionCommand
     */
    'total': number;
    /**
     * 
     * @type {string}
     * @memberof CreateLoyaltyPointsManualTransactionCommand
     */
    'trackingNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateProductCommand
 */
export interface CreateProductCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateProductCommand
     */
    'sku': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductCommand
     */
    'name': string;
    /**
     * 
     * @type {Array<ProductLoyaltyPointValueCreateUpdateModel>}
     * @memberof CreateProductCommand
     */
    'productLoyaltyPointValues': Array<ProductLoyaltyPointValueCreateUpdateModel>;
    /**
     * 
     * @type {Array<ProductSkuAliasCreateUpdateViewModel>}
     * @memberof CreateProductCommand
     */
    'productSkuAliases': Array<ProductSkuAliasCreateUpdateViewModel>;
}
/**
 * 
 * @export
 * @interface CreatePublicHolidayCommand
 */
export interface CreatePublicHolidayCommand {
    /**
     * 
     * @type {string}
     * @memberof CreatePublicHolidayCommand
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePublicHolidayCommand
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateQuoteOfferedServiceCommand
 */
export interface CreateQuoteOfferedServiceCommand {
    /**
     * 
     * @type {QuoteOfferedServiceTypeEnum}
     * @memberof CreateQuoteOfferedServiceCommand
     */
    'quoteServiceTypeId': QuoteOfferedServiceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteOfferedServiceCommand
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateRoleCommand
 */
export interface CreateRoleCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateRoleCommand
     */
    'name': string;
    /**
     * 
     * @type {Array<ApplicationClaimType>}
     * @memberof CreateRoleCommand
     */
    'claims': Array<ApplicationClaimType>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRoleCommand
     */
    'isWorkshopRole': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateRoleCommand
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateUserCommand
 */
export interface CreateUserCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateUserCommand
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCommand
     */
    'email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUserCommand
     */
    'roleIds': Array<string>;
    /**
     * 
     * @type {Array<WorkshopUserRoleCreateUpdateModel>}
     * @memberof CreateUserCommand
     */
    'workshopRoles': Array<WorkshopUserRoleCreateUpdateModel>;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCommand
     */
    'cellNumber': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserCommand
     */
    'acceptedPrivicyPolicy': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCommand
     */
    'workshopName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCommand
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCommand
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCommand
     */
    'skynamoReferenceCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserCommand
     */
    'isGlobalUser'?: boolean | null;
}
/**
 * 
 * @export
 * @interface CreateWorkshopCommand
 */
export interface CreateWorkshopCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateWorkshopCommand
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkshopCommand
     */
    'advanceUserEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkshopCommand
     */
    'skynamoId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkshopCommand
     */
    'relativeImageUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface CustomerListViewModel
 */
export interface CustomerListViewModel {
    /**
     * 
     * @type {string}
     * @memberof CustomerListViewModel
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerListViewModel
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerListViewModel
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerListViewModel
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerListViewModel
     */
    'firstQuoteDate': string;
    /**
     * 
     * @type {number}
     * @memberof CustomerListViewModel
     */
    'quoteCount': number;
}
/**
 * 
 * @export
 * @interface DelinquentWorkshopListViewModel
 */
export interface DelinquentWorkshopListViewModel {
    /**
     * 
     * @type {string}
     * @memberof DelinquentWorkshopListViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DelinquentWorkshopListViewModel
     */
    'dateTimeStamp': string;
    /**
     * 
     * @type {string}
     * @memberof DelinquentWorkshopListViewModel
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof DelinquentWorkshopListViewModel
     */
    'workshopId': string;
    /**
     * 
     * @type {string}
     * @memberof DelinquentWorkshopListViewModel
     */
    'quoteResponseId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DelinquentWorkshopListViewModel
     */
    'bookingReviewId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DelinquentWorkshopListViewModel
     */
    'workshopName': string;
    /**
     * 
     * @type {string}
     * @memberof DelinquentWorkshopListViewModel
     */
    'referenceNumber': string;
}
/**
 * 
 * @export
 * @interface ExtractedLineItemListViewModel
 */
export interface ExtractedLineItemListViewModel {
    /**
     * 
     * @type {number}
     * @memberof ExtractedLineItemListViewModel
     */
    'confidence': number;
    /**
     * 
     * @type {string}
     * @memberof ExtractedLineItemListViewModel
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedLineItemListViewModel
     */
    'productCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExtractedLineItemListViewModel
     */
    'quantity'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExtractedLineItemListViewModel
     */
    'unitPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractedLineItemListViewModel
     */
    'loyaltyPointsClaimExtractedDataDocumentId': string;
    /**
     * 
     * @type {string}
     * @memberof ExtractedLineItemListViewModel
     */
    'id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExtractedLineItemListViewModel
     */
    'matchedProductSkus': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ExtractedLineItemListViewModel
     */
    'totalPrice'?: number | null;
}
/**
 * 
 * @export
 * @interface FilePath
 */
export interface FilePath {
    /**
     * 
     * @type {string}
     * @memberof FilePath
     */
    'relativePath': string;
    /**
     * 
     * @type {boolean}
     * @memberof FilePath
     */
    'absolutePath': boolean;
}
/**
 * 
 * @export
 * @interface ForgotPasswordDto
 */
export interface ForgotPasswordDto {
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordDto
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface ImportDto
 */
export interface ImportDto {
    /**
     * 
     * @type {string}
     * @memberof ImportDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ImportDto
     */
    'fileRelativeUrl': string;
    /**
     * 
     * @type {ImportStatusEnum}
     * @memberof ImportDto
     */
    'importStatusId': ImportStatusEnum;
    /**
     * 
     * @type {Array<ImportImportErrorDto>}
     * @memberof ImportDto
     */
    'importErrors': Array<ImportImportErrorDto>;
    /**
     * 
     * @type {ImportTypeEnum}
     * @memberof ImportDto
     */
    'importTypeId': ImportTypeEnum;
}
/**
 * 
 * @export
 * @interface ImportImportErrorDto
 */
export interface ImportImportErrorDto {
    /**
     * 
     * @type {string}
     * @memberof ImportImportErrorDto
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof ImportImportErrorDto
     */
    'exception'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportImportErrorDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ImportImportErrorDto
     */
    'importId': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ImportStatusEnum = {
    New: 'New',
    Pending: 'Pending',
    InProgress: 'InProgress',
    Complete: 'Complete',
    Error: 'Error'
} as const;

export type ImportStatusEnum = typeof ImportStatusEnum[keyof typeof ImportStatusEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const ImportTypeEnum = {
    Product: 'Product',
    SkuAlias: 'SkuAlias'
} as const;

export type ImportTypeEnum = typeof ImportTypeEnum[keyof typeof ImportTypeEnum];


/**
 * 
 * @export
 * @interface ImportWorkshopsCommand
 */
export interface ImportWorkshopsCommand {
    /**
     * 
     * @type {string}
     * @memberof ImportWorkshopsCommand
     */
    'relativeFileUrl': string;
}
/**
 * 
 * @export
 * @interface InfoResponseDto
 */
export interface InfoResponseDto {
    /**
     * 
     * @type {string}
     * @memberof InfoResponseDto
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface JsonResponseOfDecimal
 */
export interface JsonResponseOfDecimal {
    /**
     * 
     * @type {number}
     * @memberof JsonResponseOfDecimal
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface JsonResponseOfGuid
 */
export interface JsonResponseOfGuid {
    /**
     * 
     * @type {string}
     * @memberof JsonResponseOfGuid
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface JsonResponseOfListOfString
 */
export interface JsonResponseOfListOfString {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonResponseOfListOfString
     */
    'value'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface JsonResponseOfString
 */
export interface JsonResponseOfString {
    /**
     * 
     * @type {string}
     * @memberof JsonResponseOfString
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface LoginDto
 */
export interface LoginDto {
    /**
     * 
     * @type {string}
     * @memberof LoginDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginDto
     */
    'password'?: string | null;
}
/**
 * 
 * @export
 * @interface LoyaltyPointClaimListViewModel
 */
export interface LoyaltyPointClaimListViewModel {
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimListViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimListViewModel
     */
    'invoiceNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimListViewModel
     */
    'invoiceDate'?: string | null;
    /**
     * 
     * @type {LoyaltyPointClaimStatus}
     * @memberof LoyaltyPointClaimListViewModel
     */
    'loyaltyPointsClaimStatusId': LoyaltyPointClaimStatus;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimListViewModel
     */
    'loyaltyPointsClaimStatusName': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimListViewModel
     */
    'workshopName': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimListViewModel
     */
    'dateSubmitted': string;
    /**
     * 
     * @type {boolean}
     * @memberof LoyaltyPointClaimListViewModel
     */
    'isFullMatch': boolean;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimListViewModel
     */
    'companyName'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const LoyaltyPointClaimStatus = {
    Pending: 'Pending',
    Approved: 'Approved',
    Rejected: 'Rejected',
    AwaitingResubmission: 'AwaitingResubmission',
    AwaitingDataExtraction: 'AwaitingDataExtraction'
} as const;

export type LoyaltyPointClaimStatus = typeof LoyaltyPointClaimStatus[keyof typeof LoyaltyPointClaimStatus];


/**
 * 
 * @export
 * @interface LoyaltyPointClaimViewModel
 */
export interface LoyaltyPointClaimViewModel {
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimViewModel
     */
    'invoiceRelativeUrl': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimViewModel
     */
    'invoiceNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimViewModel
     */
    'invoiceDate'?: string | null;
    /**
     * 
     * @type {LoyaltyPointClaimStatus}
     * @memberof LoyaltyPointClaimViewModel
     */
    'loyaltyPointsClaimStatusId': LoyaltyPointClaimStatus;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimViewModel
     */
    'reviewComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimViewModel
     */
    'reviewedByUserId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimViewModel
     */
    'reviewedDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimViewModel
     */
    'workshopId': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimViewModel
     */
    'submittedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimViewModel
     */
    'loyaltyPointsClaimStatusName': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimViewModel
     */
    'reviewedByUserDisplayName': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimViewModel
     */
    'submittedByUserDisplayName': string;
    /**
     * 
     * @type {Array<LoyaltyPointUpdateProductListViewModel>}
     * @memberof LoyaltyPointClaimViewModel
     */
    'products': Array<LoyaltyPointUpdateProductListViewModel>;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimViewModel
     */
    'workshopName': string;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyPointClaimViewModel
     */
    'totalValue': number;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimViewModel
     */
    'dateSubmitted': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof LoyaltyPointClaimViewModel
     */
    'pageNumbers': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimViewModel
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointClaimViewModel
     */
    'trackingNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface LoyaltyPointTransactionListViewModel
 */
export interface LoyaltyPointTransactionListViewModel {
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointTransactionListViewModel
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyPointTransactionListViewModel
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyPointTransactionListViewModel
     */
    'spent'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointTransactionListViewModel
     */
    'expiryDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointTransactionListViewModel
     */
    'dateAdded': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointTransactionListViewModel
     */
    'loyaltyPointsUpdateReferenceNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LoyaltyPointTransactionListViewModel
     */
    'isClaim': boolean;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointTransactionListViewModel
     */
    'loyaltyPointsUpdateId': string;
    /**
     * 
     * @type {ReturnsStatus}
     * @memberof LoyaltyPointTransactionListViewModel
     */
    'loyaltyPointsTranactionReturnsStatusId': ReturnsStatus;
    /**
     * 
     * @type {boolean}
     * @memberof LoyaltyPointTransactionListViewModel
     */
    'loyaltyPointsUpdateCanReturn': boolean;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointTransactionListViewModel
     */
    'loyaltyPointsTransactionTrackingNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface LoyaltyPointUpdateProductListViewModel
 */
export interface LoyaltyPointUpdateProductListViewModel {
    /**
     * 
     * @type {number}
     * @memberof LoyaltyPointUpdateProductListViewModel
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyPointUpdateProductListViewModel
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointUpdateProductListViewModel
     */
    'productSku': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointUpdateProductListViewModel
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointUpdateProductListViewModel
     */
    'productId'?: string | null;
    /**
     * 
     * @type {ExtractedLineItemListViewModel}
     * @memberof LoyaltyPointUpdateProductListViewModel
     */
    'loyaltyPointsClaimExtractedDataDocumentLineItem': ExtractedLineItemListViewModel;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointUpdateProductListViewModel
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface LoyaltyPointsClaimProductCreateUpdateModel
 */
export interface LoyaltyPointsClaimProductCreateUpdateModel {
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsClaimProductCreateUpdateModel
     */
    'id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyPointsClaimProductCreateUpdateModel
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsClaimProductCreateUpdateModel
     */
    'productId': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsClaimProductCreateUpdateModel
     */
    'extractedLineItemId'?: string | null;
}
/**
 * 
 * @export
 * @interface LoyaltyPointsManualTransactionViewModel
 */
export interface LoyaltyPointsManualTransactionViewModel {
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsManualTransactionViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsManualTransactionViewModel
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsManualTransactionViewModel
     */
    'workshopId': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsManualTransactionViewModel
     */
    'submittedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsManualTransactionViewModel
     */
    'referenceNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyPointsManualTransactionViewModel
     */
    'totalValue': number;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsManualTransactionViewModel
     */
    'workshopName': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsManualTransactionViewModel
     */
    'submittedByUserDisplayName': string;
    /**
     * 
     * @type {Array<PurchasedProductViewModel>}
     * @memberof LoyaltyPointsManualTransactionViewModel
     */
    'loyaltyPointsUpdateLoyaltyPointUpdatePurchasedProducts': Array<PurchasedProductViewModel>;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsManualTransactionViewModel
     */
    'invoiceHtml'?: string | null;
    /**
     * 
     * @type {ReturnsStatus}
     * @memberof LoyaltyPointsManualTransactionViewModel
     */
    'loyaltyPointsTranactionReturnsStatusId': ReturnsStatus;
    /**
     * 
     * @type {boolean}
     * @memberof LoyaltyPointsManualTransactionViewModel
     */
    'canReturn': boolean;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsManualTransactionViewModel
     */
    'trackingNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface LoyaltyPointsTranactionReturnDto
 */
export interface LoyaltyPointsTranactionReturnDto {
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsTranactionReturnDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsTranactionReturnDto
     */
    'loyaltyPointsUpdateId': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsTranactionReturnDto
     */
    'returnReason': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsTranactionReturnDto
     */
    'workshopId': string;
    /**
     * 
     * @type {ReturnsStatus}
     * @memberof LoyaltyPointsTranactionReturnDto
     */
    'returnsStatusId': ReturnsStatus;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsTranactionReturnDto
     */
    'skynamoId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsTranactionReturnDto
     */
    'submittedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsTranactionReturnDto
     */
    'workshopName': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsTranactionReturnDto
     */
    'submittedByUserDisplayName': string;
    /**
     * 
     * @type {string}
     * @memberof LoyaltyPointsTranactionReturnDto
     */
    'createdDate': string;
    /**
     * 
     * @type {number}
     * @memberof LoyaltyPointsTranactionReturnDto
     */
    'taskId': number;
}
/**
 * 
 * @export
 * @interface OrderCreatedCommand
 */
export interface OrderCreatedCommand {
    /**
     * 
     * @type {string}
     * @memberof OrderCreatedCommand
     */
    'userEmail': string;
    /**
     * 
     * @type {string}
     * @memberof OrderCreatedCommand
     */
    'userFirstName': string;
    /**
     * 
     * @type {number}
     * @memberof OrderCreatedCommand
     */
    'loyaltyPointsUsed': number;
    /**
     * 
     * @type {Array<PurchasedProductCreateModel>}
     * @memberof OrderCreatedCommand
     */
    'products': Array<PurchasedProductCreateModel>;
    /**
     * 
     * @type {string}
     * @memberof OrderCreatedCommand
     */
    'orderReferenceNumber': string;
    /**
     * 
     * @type {string}
     * @memberof OrderCreatedCommand
     */
    'shippingMethodCode': string;
    /**
     * 
     * @type {AddressInformationModel}
     * @memberof OrderCreatedCommand
     */
    'addressInformation': AddressInformationModel;
    /**
     * 
     * @type {string}
     * @memberof OrderCreatedCommand
     */
    'orderInstruction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrderCreatedCommand
     */
    'isDelivery': boolean;
    /**
     * 
     * @type {number}
     * @memberof OrderCreatedCommand
     */
    'deliveryFee'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderCreatedCommand
     */
    'orderTotal': number;
    /**
     * 
     * @type {string}
     * @memberof OrderCreatedCommand
     */
    'orderPlacementDate': string;
    /**
     * 
     * @type {string}
     * @memberof OrderCreatedCommand
     */
    'invoiceHtml': string;
}
/**
 * 
 * @export
 * @interface PagedResultOfAuditLogDto
 */
export interface PagedResultOfAuditLogDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfAuditLogDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfAuditLogDto
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfAuditLogDto
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfAuditLogDto
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<AuditLogDto>}
     * @memberof PagedResultOfAuditLogDto
     */
    'data': Array<AuditLogDto>;
}
/**
 * 
 * @export
 * @interface PagedResultOfBookingReviewViewModel
 */
export interface PagedResultOfBookingReviewViewModel {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfBookingReviewViewModel
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfBookingReviewViewModel
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfBookingReviewViewModel
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfBookingReviewViewModel
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<BookingReviewViewModel>}
     * @memberof PagedResultOfBookingReviewViewModel
     */
    'data': Array<BookingReviewViewModel>;
}
/**
 * 
 * @export
 * @interface PagedResultOfBulletinDto
 */
export interface PagedResultOfBulletinDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfBulletinDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfBulletinDto
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfBulletinDto
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfBulletinDto
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<BulletinDto>}
     * @memberof PagedResultOfBulletinDto
     */
    'data': Array<BulletinDto>;
}
/**
 * 
 * @export
 * @interface PagedResultOfClaimListViewModel
 */
export interface PagedResultOfClaimListViewModel {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfClaimListViewModel
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfClaimListViewModel
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfClaimListViewModel
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfClaimListViewModel
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<ClaimListViewModel>}
     * @memberof PagedResultOfClaimListViewModel
     */
    'data': Array<ClaimListViewModel>;
}
/**
 * 
 * @export
 * @interface PagedResultOfCustomerListViewModel
 */
export interface PagedResultOfCustomerListViewModel {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfCustomerListViewModel
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfCustomerListViewModel
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfCustomerListViewModel
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfCustomerListViewModel
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<CustomerListViewModel>}
     * @memberof PagedResultOfCustomerListViewModel
     */
    'data': Array<CustomerListViewModel>;
}
/**
 * 
 * @export
 * @interface PagedResultOfDelinquentWorkshopListViewModel
 */
export interface PagedResultOfDelinquentWorkshopListViewModel {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfDelinquentWorkshopListViewModel
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfDelinquentWorkshopListViewModel
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfDelinquentWorkshopListViewModel
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfDelinquentWorkshopListViewModel
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<DelinquentWorkshopListViewModel>}
     * @memberof PagedResultOfDelinquentWorkshopListViewModel
     */
    'data': Array<DelinquentWorkshopListViewModel>;
}
/**
 * 
 * @export
 * @interface PagedResultOfImportDto
 */
export interface PagedResultOfImportDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfImportDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfImportDto
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfImportDto
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfImportDto
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<ImportDto>}
     * @memberof PagedResultOfImportDto
     */
    'data': Array<ImportDto>;
}
/**
 * 
 * @export
 * @interface PagedResultOfLoyaltyPointClaimListViewModel
 */
export interface PagedResultOfLoyaltyPointClaimListViewModel {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLoyaltyPointClaimListViewModel
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLoyaltyPointClaimListViewModel
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLoyaltyPointClaimListViewModel
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLoyaltyPointClaimListViewModel
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<LoyaltyPointClaimListViewModel>}
     * @memberof PagedResultOfLoyaltyPointClaimListViewModel
     */
    'data': Array<LoyaltyPointClaimListViewModel>;
}
/**
 * 
 * @export
 * @interface PagedResultOfLoyaltyPointTransactionListViewModel
 */
export interface PagedResultOfLoyaltyPointTransactionListViewModel {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLoyaltyPointTransactionListViewModel
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLoyaltyPointTransactionListViewModel
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLoyaltyPointTransactionListViewModel
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLoyaltyPointTransactionListViewModel
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<LoyaltyPointTransactionListViewModel>}
     * @memberof PagedResultOfLoyaltyPointTransactionListViewModel
     */
    'data': Array<LoyaltyPointTransactionListViewModel>;
}
/**
 * 
 * @export
 * @interface PagedResultOfLoyaltyPointsTranactionReturnDto
 */
export interface PagedResultOfLoyaltyPointsTranactionReturnDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLoyaltyPointsTranactionReturnDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLoyaltyPointsTranactionReturnDto
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLoyaltyPointsTranactionReturnDto
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLoyaltyPointsTranactionReturnDto
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<LoyaltyPointsTranactionReturnDto>}
     * @memberof PagedResultOfLoyaltyPointsTranactionReturnDto
     */
    'data': Array<LoyaltyPointsTranactionReturnDto>;
}
/**
 * 
 * @export
 * @interface PagedResultOfProductListViewModel
 */
export interface PagedResultOfProductListViewModel {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfProductListViewModel
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfProductListViewModel
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfProductListViewModel
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfProductListViewModel
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<ProductListViewModel>}
     * @memberof PagedResultOfProductListViewModel
     */
    'data': Array<ProductListViewModel>;
}
/**
 * 
 * @export
 * @interface PagedResultOfPublicHolidayViewModel
 */
export interface PagedResultOfPublicHolidayViewModel {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfPublicHolidayViewModel
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfPublicHolidayViewModel
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfPublicHolidayViewModel
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfPublicHolidayViewModel
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<PublicHolidayViewModel>}
     * @memberof PagedResultOfPublicHolidayViewModel
     */
    'data': Array<PublicHolidayViewModel>;
}
/**
 * 
 * @export
 * @interface PagedResultOfQuoteOfferedServiceTypeViewModel
 */
export interface PagedResultOfQuoteOfferedServiceTypeViewModel {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfQuoteOfferedServiceTypeViewModel
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfQuoteOfferedServiceTypeViewModel
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfQuoteOfferedServiceTypeViewModel
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfQuoteOfferedServiceTypeViewModel
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<QuoteOfferedServiceTypeViewModel>}
     * @memberof PagedResultOfQuoteOfferedServiceTypeViewModel
     */
    'data': Array<QuoteOfferedServiceTypeViewModel>;
}
/**
 * 
 * @export
 * @interface PagedResultOfQuoteOfferedServiceViewModel
 */
export interface PagedResultOfQuoteOfferedServiceViewModel {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfQuoteOfferedServiceViewModel
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfQuoteOfferedServiceViewModel
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfQuoteOfferedServiceViewModel
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfQuoteOfferedServiceViewModel
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<QuoteOfferedServiceViewModel>}
     * @memberof PagedResultOfQuoteOfferedServiceViewModel
     */
    'data': Array<QuoteOfferedServiceViewModel>;
}
/**
 * 
 * @export
 * @interface PagedResultOfQuoteRequestListViewModel
 */
export interface PagedResultOfQuoteRequestListViewModel {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfQuoteRequestListViewModel
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfQuoteRequestListViewModel
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfQuoteRequestListViewModel
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfQuoteRequestListViewModel
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<QuoteRequestListViewModel>}
     * @memberof PagedResultOfQuoteRequestListViewModel
     */
    'data': Array<QuoteRequestListViewModel>;
}
/**
 * 
 * @export
 * @interface PagedResultOfQuoteResponseWorkshopViewModel
 */
export interface PagedResultOfQuoteResponseWorkshopViewModel {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfQuoteResponseWorkshopViewModel
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfQuoteResponseWorkshopViewModel
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfQuoteResponseWorkshopViewModel
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfQuoteResponseWorkshopViewModel
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<QuoteResponseWorkshopViewModel>}
     * @memberof PagedResultOfQuoteResponseWorkshopViewModel
     */
    'data': Array<QuoteResponseWorkshopViewModel>;
}
/**
 * 
 * @export
 * @interface PagedResultOfRoleListViewModel
 */
export interface PagedResultOfRoleListViewModel {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfRoleListViewModel
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfRoleListViewModel
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfRoleListViewModel
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfRoleListViewModel
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<RoleListViewModel>}
     * @memberof PagedResultOfRoleListViewModel
     */
    'data': Array<RoleListViewModel>;
}
/**
 * 
 * @export
 * @interface PagedResultOfServiceAuditLogListViewModel
 */
export interface PagedResultOfServiceAuditLogListViewModel {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfServiceAuditLogListViewModel
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfServiceAuditLogListViewModel
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfServiceAuditLogListViewModel
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfServiceAuditLogListViewModel
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<ServiceAuditLogListViewModel>}
     * @memberof PagedResultOfServiceAuditLogListViewModel
     */
    'data': Array<ServiceAuditLogListViewModel>;
}
/**
 * 
 * @export
 * @interface PagedResultOfUserViewModel
 */
export interface PagedResultOfUserViewModel {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfUserViewModel
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfUserViewModel
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfUserViewModel
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfUserViewModel
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<UserViewModel>}
     * @memberof PagedResultOfUserViewModel
     */
    'data': Array<UserViewModel>;
}
/**
 * 
 * @export
 * @interface PagedResultOfWorkshopUserViewModel
 */
export interface PagedResultOfWorkshopUserViewModel {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfWorkshopUserViewModel
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfWorkshopUserViewModel
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfWorkshopUserViewModel
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfWorkshopUserViewModel
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<WorkshopUserViewModel>}
     * @memberof PagedResultOfWorkshopUserViewModel
     */
    'data': Array<WorkshopUserViewModel>;
}
/**
 * 
 * @export
 * @interface PagedResultOfWorkshopViewModel
 */
export interface PagedResultOfWorkshopViewModel {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfWorkshopViewModel
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfWorkshopViewModel
     */
    'pageCount': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfWorkshopViewModel
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfWorkshopViewModel
     */
    'pageNumber': number;
    /**
     * 
     * @type {Array<WorkshopViewModel>}
     * @memberof PagedResultOfWorkshopViewModel
     */
    'data': Array<WorkshopViewModel>;
}
/**
 * 
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetails
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'instance'?: string | null;
}
/**
 * 
 * @export
 * @interface ProductListViewModel
 */
export interface ProductListViewModel {
    /**
     * 
     * @type {string}
     * @memberof ProductListViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductListViewModel
     */
    'sku': string;
    /**
     * 
     * @type {string}
     * @memberof ProductListViewModel
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ProductListViewModel
     */
    'currentLoyaltyPointValue'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductListViewModel
     */
    'canDelete': boolean;
}
/**
 * 
 * @export
 * @interface ProductLoyaltyPointValueCreateUpdateModel
 */
export interface ProductLoyaltyPointValueCreateUpdateModel {
    /**
     * 
     * @type {number}
     * @memberof ProductLoyaltyPointValueCreateUpdateModel
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof ProductLoyaltyPointValueCreateUpdateModel
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLoyaltyPointValueCreateUpdateModel
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLoyaltyPointValueCreateUpdateModel
     */
    'id'?: string | null;
}
/**
 * 
 * @export
 * @interface ProductLoyaltyPointValueViewModel
 */
export interface ProductLoyaltyPointValueViewModel {
    /**
     * 
     * @type {number}
     * @memberof ProductLoyaltyPointValueViewModel
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof ProductLoyaltyPointValueViewModel
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLoyaltyPointValueViewModel
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLoyaltyPointValueViewModel
     */
    'productId': string;
    /**
     * 
     * @type {string}
     * @memberof ProductLoyaltyPointValueViewModel
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface ProductSkuAliasCreateUpdateViewModel
 */
export interface ProductSkuAliasCreateUpdateViewModel {
    /**
     * 
     * @type {string}
     * @memberof ProductSkuAliasCreateUpdateViewModel
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductSkuAliasCreateUpdateViewModel
     */
    'aliasName': string;
}
/**
 * 
 * @export
 * @interface ProductSkuAliasViewModel
 */
export interface ProductSkuAliasViewModel {
    /**
     * 
     * @type {string}
     * @memberof ProductSkuAliasViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductSkuAliasViewModel
     */
    'aliasName': string;
}
/**
 * 
 * @export
 * @interface ProductViewModel
 */
export interface ProductViewModel {
    /**
     * 
     * @type {string}
     * @memberof ProductViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductViewModel
     */
    'sku': string;
    /**
     * 
     * @type {string}
     * @memberof ProductViewModel
     */
    'name': string;
    /**
     * 
     * @type {Array<ProductLoyaltyPointValueViewModel>}
     * @memberof ProductViewModel
     */
    'productLoyaltyPointValues': Array<ProductLoyaltyPointValueViewModel>;
    /**
     * 
     * @type {Array<ProductSkuAliasViewModel>}
     * @memberof ProductViewModel
     */
    'productSkuAliases': Array<ProductSkuAliasViewModel>;
}
/**
 * 
 * @export
 * @interface PublicHolidayViewModel
 */
export interface PublicHolidayViewModel {
    /**
     * 
     * @type {string}
     * @memberof PublicHolidayViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PublicHolidayViewModel
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof PublicHolidayViewModel
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PurchasedProductCreateModel
 */
export interface PurchasedProductCreateModel {
    /**
     * 
     * @type {string}
     * @memberof PurchasedProductCreateModel
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof PurchasedProductCreateModel
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof PurchasedProductCreateModel
     */
    'sku': string;
    /**
     * 
     * @type {number}
     * @memberof PurchasedProductCreateModel
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface PurchasedProductViewModel
 */
export interface PurchasedProductViewModel {
    /**
     * 
     * @type {number}
     * @memberof PurchasedProductViewModel
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof PurchasedProductViewModel
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof PurchasedProductViewModel
     */
    'sku': string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedProductViewModel
     */
    'name': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const QuoteOfferedServiceTypeEnum = {
    Vehicle: 'Vehicle',
    Customer: 'Customer'
} as const;

export type QuoteOfferedServiceTypeEnum = typeof QuoteOfferedServiceTypeEnum[keyof typeof QuoteOfferedServiceTypeEnum];


/**
 * 
 * @export
 * @interface QuoteOfferedServiceTypeViewModel
 */
export interface QuoteOfferedServiceTypeViewModel {
    /**
     * 
     * @type {QuoteOfferedServiceTypeEnum}
     * @memberof QuoteOfferedServiceTypeViewModel
     */
    'id': QuoteOfferedServiceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof QuoteOfferedServiceTypeViewModel
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface QuoteOfferedServiceViewModel
 */
export interface QuoteOfferedServiceViewModel {
    /**
     * 
     * @type {string}
     * @memberof QuoteOfferedServiceViewModel
     */
    'id': string;
    /**
     * 
     * @type {QuoteOfferedServiceTypeEnum}
     * @memberof QuoteOfferedServiceViewModel
     */
    'quoteServiceTypeId': QuoteOfferedServiceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof QuoteOfferedServiceViewModel
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface QuoteRequestAdminViewModel
 */
export interface QuoteRequestAdminViewModel {
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestAdminViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestAdminViewModel
     */
    'vehicleManufacturer': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestAdminViewModel
     */
    'vehicleModel': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestAdminViewModel
     */
    'vehicleYear': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestAdminViewModel
     */
    'vehicleSpecification': string;
    /**
     * 
     * @type {ServiceTypeEnum}
     * @memberof QuoteRequestAdminViewModel
     */
    'serviceTypeId': ServiceTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof QuoteRequestAdminViewModel
     */
    'vehicleMileage': number;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestAdminViewModel
     */
    'additionalInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestAdminViewModel
     */
    'referenceNumber': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestAdminViewModel
     */
    'expiryDate': string;
    /**
     * 
     * @type {Array<QuoteResponsePublicViewModel>}
     * @memberof QuoteRequestAdminViewModel
     */
    'quoteResponses': Array<QuoteResponsePublicViewModel>;
    /**
     * 
     * @type {BookingPublicViewModel}
     * @memberof QuoteRequestAdminViewModel
     */
    'booking': BookingPublicViewModel;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestAdminViewModel
     */
    'customerFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestAdminViewModel
     */
    'customerLastName': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestAdminViewModel
     */
    'customerEmail': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestAdminViewModel
     */
    'customerPhoneNumber': string;
    /**
     * 
     * @type {QuoteRequestStatusEnum}
     * @memberof QuoteRequestAdminViewModel
     */
    'status': QuoteRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestAdminViewModel
     */
    'bookingReviewId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuoteRequestAdminViewModel
     */
    'quoteRequestDates': Array<string>;
}
/**
 * 
 * @export
 * @interface QuoteRequestListViewModel
 */
export interface QuoteRequestListViewModel {
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestListViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestListViewModel
     */
    'referenceNumber': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestListViewModel
     */
    'submissionDate': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestListViewModel
     */
    'customerName': string;
    /**
     * 
     * @type {number}
     * @memberof QuoteRequestListViewModel
     */
    'workshopsFound': number;
    /**
     * 
     * @type {number}
     * @memberof QuoteRequestListViewModel
     */
    'responses': number;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestListViewModel
     */
    'lastActioned': string;
    /**
     * 
     * @type {QuoteRequestStatusEnum}
     * @memberof QuoteRequestListViewModel
     */
    'status': QuoteRequestStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuoteRequestListViewModel
     */
    'quoteRequestDates': Array<string>;
}
/**
 * 
 * @export
 * @interface QuoteRequestPublicViewModel
 */
export interface QuoteRequestPublicViewModel {
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestPublicViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestPublicViewModel
     */
    'vehicleManufacturer': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestPublicViewModel
     */
    'vehicleModel': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestPublicViewModel
     */
    'vehicleYear': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestPublicViewModel
     */
    'vehicleSpecification': string;
    /**
     * 
     * @type {ServiceTypeEnum}
     * @memberof QuoteRequestPublicViewModel
     */
    'serviceTypeId': ServiceTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof QuoteRequestPublicViewModel
     */
    'vehicleMileage': number;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestPublicViewModel
     */
    'additionalInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestPublicViewModel
     */
    'referenceNumber': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestPublicViewModel
     */
    'expiryDate': string;
    /**
     * 
     * @type {Array<QuoteResponsePublicViewModel>}
     * @memberof QuoteRequestPublicViewModel
     */
    'quoteResponses': Array<QuoteResponsePublicViewModel>;
    /**
     * 
     * @type {BookingPublicViewModel}
     * @memberof QuoteRequestPublicViewModel
     */
    'booking': BookingPublicViewModel;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestPublicViewModel
     */
    'customerFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestPublicViewModel
     */
    'customerLastName': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestPublicViewModel
     */
    'customerEmail': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestPublicViewModel
     */
    'customerPhoneNumber': string;
    /**
     * 
     * @type {QuoteRequestStatusEnum}
     * @memberof QuoteRequestPublicViewModel
     */
    'status': QuoteRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestPublicViewModel
     */
    'bookingReviewId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuoteRequestPublicViewModel
     */
    'quoteRequestDates': Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const QuoteRequestSourceEnum = {
    Customer: 'Customer',
    Adhoc: 'Adhoc'
} as const;

export type QuoteRequestSourceEnum = typeof QuoteRequestSourceEnum[keyof typeof QuoteRequestSourceEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const QuoteRequestStatusEnum = {
    ResponseOutstanding: 'ResponseOutstanding',
    ResponseTimeExpiringSoon: 'ResponseTimeExpiringSoon',
    QuoteExpiringSoon: 'QuoteExpiringSoon',
    QuoteProvided: 'QuoteProvided',
    ReschedulePending: 'ReschedulePending',
    Completed: 'Completed',
    Booked: 'Booked',
    BookingCancelled: 'BookingCancelled',
    NoWorkshopsFound: 'NoWorkshopsFound'
} as const;

export type QuoteRequestStatusEnum = typeof QuoteRequestStatusEnum[keyof typeof QuoteRequestStatusEnum];


/**
 * 
 * @export
 * @interface QuoteRequestWorkshopViewModel
 */
export interface QuoteRequestWorkshopViewModel {
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestWorkshopViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestWorkshopViewModel
     */
    'vehicleManufacturer': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestWorkshopViewModel
     */
    'vehicleModel': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestWorkshopViewModel
     */
    'vehicleYear': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestWorkshopViewModel
     */
    'vehicleSpecification': string;
    /**
     * 
     * @type {ServiceTypeEnum}
     * @memberof QuoteRequestWorkshopViewModel
     */
    'serviceTypeId': ServiceTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof QuoteRequestWorkshopViewModel
     */
    'vehicleMileage': number;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestWorkshopViewModel
     */
    'additionalInfo'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof QuoteRequestWorkshopViewModel
     */
    'allowFlexibleDates': boolean;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestWorkshopViewModel
     */
    'customerFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestWorkshopViewModel
     */
    'customerLastName': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestWorkshopViewModel
     */
    'customerEmail': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestWorkshopViewModel
     */
    'customerPhoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestWorkshopViewModel
     */
    'referenceNumber': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestWorkshopViewModel
     */
    'firstUpdateSendDate': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequestWorkshopViewModel
     */
    'expiryDate': string;
    /**
     * 
     * @type {QuoteRequestSourceEnum}
     * @memberof QuoteRequestWorkshopViewModel
     */
    'quoteRequestSourceId': QuoteRequestSourceEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuoteRequestWorkshopViewModel
     */
    'quoteRequestDates': Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const QuoteResponseDiscountTypeEnum = {
    None: 'None',
    Percentage: 'Percentage',
    Fixed: 'Fixed'
} as const;

export type QuoteResponseDiscountTypeEnum = typeof QuoteResponseDiscountTypeEnum[keyof typeof QuoteResponseDiscountTypeEnum];


/**
 * 
 * @export
 * @interface QuoteResponseLineItemUpdateModel
 */
export interface QuoteResponseLineItemUpdateModel {
    /**
     * 
     * @type {string}
     * @memberof QuoteResponseLineItemUpdateModel
     */
    'partNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuoteResponseLineItemUpdateModel
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof QuoteResponseLineItemUpdateModel
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof QuoteResponseLineItemUpdateModel
     */
    'unitPrice': number;
}
/**
 * 
 * @export
 * @interface QuoteResponseLineItemViewModel
 */
export interface QuoteResponseLineItemViewModel {
    /**
     * 
     * @type {string}
     * @memberof QuoteResponseLineItemViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuoteResponseLineItemViewModel
     */
    'partNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuoteResponseLineItemViewModel
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof QuoteResponseLineItemViewModel
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof QuoteResponseLineItemViewModel
     */
    'unitPrice': number;
}
/**
 * 
 * @export
 * @interface QuoteResponsePublicViewModel
 */
export interface QuoteResponsePublicViewModel {
    /**
     * 
     * @type {string}
     * @memberof QuoteResponsePublicViewModel
     */
    'id': string;
    /**
     * 
     * @type {QuoteResponseStatusEnum}
     * @memberof QuoteResponsePublicViewModel
     */
    'quoteResponseStatusId': QuoteResponseStatusEnum;
    /**
     * 
     * @type {QuoteResponseDiscountTypeEnum}
     * @memberof QuoteResponsePublicViewModel
     */
    'quoteResponseDiscountTypeId': QuoteResponseDiscountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof QuoteResponsePublicViewModel
     */
    'discountValue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof QuoteResponsePublicViewModel
     */
    'serviceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof QuoteResponsePublicViewModel
     */
    'totalExcludingVat'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof QuoteResponsePublicViewModel
     */
    'vatTotal'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof QuoteResponsePublicViewModel
     */
    'submissionDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof QuoteResponsePublicViewModel
     */
    'distanceInKilometers'?: number | null;
    /**
     * 
     * @type {WorkshopPublicViewModel}
     * @memberof QuoteResponsePublicViewModel
     */
    'workshop': WorkshopPublicViewModel;
    /**
     * 
     * @type {string}
     * @memberof QuoteResponsePublicViewModel
     */
    'bookingReviewId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuoteResponsePublicViewModel
     */
    'quoteRequestDates': Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const QuoteResponseStatusEnum = {
    ResponseOutstanding: 'ResponseOutstanding',
    QuoteProvided: 'QuoteProvided',
    Accepted: 'Accepted',
    WorkshopDeclined: 'WorkshopDeclined',
    QuoteResponseExpired: 'QuoteResponseExpired'
} as const;

export type QuoteResponseStatusEnum = typeof QuoteResponseStatusEnum[keyof typeof QuoteResponseStatusEnum];


/**
 * 
 * @export
 * @interface QuoteResponseWorkshopViewModel
 */
export interface QuoteResponseWorkshopViewModel {
    /**
     * 
     * @type {string}
     * @memberof QuoteResponseWorkshopViewModel
     */
    'id': string;
    /**
     * 
     * @type {QuoteResponseStatusEnum}
     * @memberof QuoteResponseWorkshopViewModel
     */
    'quoteResponseStatusId': QuoteResponseStatusEnum;
    /**
     * 
     * @type {QuoteResponseDiscountTypeEnum}
     * @memberof QuoteResponseWorkshopViewModel
     */
    'quoteResponseDiscountTypeId': QuoteResponseDiscountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof QuoteResponseWorkshopViewModel
     */
    'discountValue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof QuoteResponseWorkshopViewModel
     */
    'serviceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof QuoteResponseWorkshopViewModel
     */
    'totalExcludingVat'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof QuoteResponseWorkshopViewModel
     */
    'vatTotal'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof QuoteResponseWorkshopViewModel
     */
    'submissionDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuoteResponseWorkshopViewModel
     */
    'expiryDate': string;
    /**
     * 
     * @type {number}
     * @memberof QuoteResponseWorkshopViewModel
     */
    'distanceInKilometers'?: number | null;
    /**
     * 
     * @type {BookingWorkshopViewModel}
     * @memberof QuoteResponseWorkshopViewModel
     */
    'booking': BookingWorkshopViewModel;
    /**
     * 
     * @type {QuoteRequestWorkshopViewModel}
     * @memberof QuoteResponseWorkshopViewModel
     */
    'quoteRequest': QuoteRequestWorkshopViewModel;
    /**
     * 
     * @type {Array<QuoteResponseLineItemViewModel>}
     * @memberof QuoteResponseWorkshopViewModel
     */
    'quoteResponseLineItems': Array<QuoteResponseLineItemViewModel>;
}
/**
 * 
 * @export
 * @interface QuoteSettingsViewModel
 */
export interface QuoteSettingsViewModel {
    /**
     * 
     * @type {number}
     * @memberof QuoteSettingsViewModel
     */
    'quoteDelayBeforeFirstCustomerUpdateInBusinessHours': number;
    /**
     * 
     * @type {number}
     * @memberof QuoteSettingsViewModel
     */
    'quoteWorkshopResponseCutoffInBusinessHours': number;
    /**
     * 
     * @type {number}
     * @memberof QuoteSettingsViewModel
     */
    'quoteCustomerWorkshopSelectionCutoffInBusinessDays': number;
    /**
     * 
     * @type {number}
     * @memberof QuoteSettingsViewModel
     */
    'vatPercentage': number;
    /**
     *
     * @type {number}
     * @memberof QuoteSettingsViewModel
     */
    'defaultQuoteResponseBatchSize': number;
}
/**
 * 
 * @export
 * @interface RegisterAccountCommand
 */
export interface RegisterAccountCommand {
    /**
     * 
     * @type {string}
     * @memberof RegisterAccountCommand
     */
    'workshopId': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterAccountCommand
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface RegisterDto
 */
export interface RegisterDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'cellNumber': string;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterDto
     */
    'acceptedPrivicyPolicy'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'workshopName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'skynamoReferenceCode'?: string | null;
}
/**
 * 
 * @export
 * @interface RescheduleBookingCommand
 */
export interface RescheduleBookingCommand {
    /**
     * 
     * @type {string}
     * @memberof RescheduleBookingCommand
     */
    'bookingId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RescheduleBookingCommand
     */
    'rescheduleDates': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RescheduleBookingCommand
     */
    'additionalComments'?: string | null;
}
/**
 * 
 * @export
 * @interface RescheduleBookingPublicCommand
 */
export interface RescheduleBookingPublicCommand {
    /**
     * 
     * @type {string}
     * @memberof RescheduleBookingPublicCommand
     */
    'bookingId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RescheduleBookingPublicCommand
     */
    'rescheduleDates': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RescheduleBookingPublicCommand
     */
    'additionalComments'?: string | null;
}
/**
 * 
 * @export
 * @interface ReselectQuoteCommand
 */
export interface ReselectQuoteCommand {
    /**
     * 
     * @type {string}
     * @memberof ReselectQuoteCommand
     */
    'quoteRequestId': string;
}
/**
 * 
 * @export
 * @interface ResetPasswordDto
 */
export interface ResetPasswordDto {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'resetCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'newPassword'?: string | null;
}
/**
 * 
 * @export
 * @interface RestartQuoteRequestCommand
 */
export interface RestartQuoteRequestCommand {
    /**
     * 
     * @type {string}
     * @memberof RestartQuoteRequestCommand
     */
    'quoteRequestId': string;
}
/**
 * 
 * @export
 * @interface ResubmitLoyaltyPointsClaimCommand
 */
export interface ResubmitLoyaltyPointsClaimCommand {
    /**
     * 
     * @type {string}
     * @memberof ResubmitLoyaltyPointsClaimCommand
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ResubmitLoyaltyPointsClaimCommand
     */
    'invoiceRelativeUrl': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ReturnsStatus = {
    Pending: 'Pending',
    Approved: 'Approved',
    Rejected: 'Rejected'
} as const;

export type ReturnsStatus = typeof ReturnsStatus[keyof typeof ReturnsStatus];


/**
 * 
 * @export
 * @interface ReviewLoyaltyPointsClaimAdminCommand
 */
export interface ReviewLoyaltyPointsClaimAdminCommand {
    /**
     * 
     * @type {string}
     * @memberof ReviewLoyaltyPointsClaimAdminCommand
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ReviewLoyaltyPointsClaimAdminCommand
     */
    'invoiceDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReviewLoyaltyPointsClaimAdminCommand
     */
    'invoiceNumber'?: string | null;
    /**
     * 
     * @type {LoyaltyPointClaimStatus}
     * @memberof ReviewLoyaltyPointsClaimAdminCommand
     */
    'loyaltyPointsClaimStatusId': LoyaltyPointClaimStatus;
    /**
     * 
     * @type {string}
     * @memberof ReviewLoyaltyPointsClaimAdminCommand
     */
    'reviewComment'?: string | null;
    /**
     * 
     * @type {Array<LoyaltyPointsClaimProductCreateUpdateModel>}
     * @memberof ReviewLoyaltyPointsClaimAdminCommand
     */
    'products': Array<LoyaltyPointsClaimProductCreateUpdateModel>;
    /**
     * 
     * @type {number}
     * @memberof ReviewLoyaltyPointsClaimAdminCommand
     */
    'totalOverrideValue'?: number | null;
}
/**
 * 
 * @export
 * @interface RoleListViewModel
 */
export interface RoleListViewModel {
    /**
     * 
     * @type {string}
     * @memberof RoleListViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RoleListViewModel
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof RoleListViewModel
     */
    'isWorkshopRole': boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleListViewModel
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface RoleViewModel
 */
export interface RoleViewModel {
    /**
     * 
     * @type {string}
     * @memberof RoleViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RoleViewModel
     */
    'name': string;
    /**
     * 
     * @type {Array<ApplicationClaimType>}
     * @memberof RoleViewModel
     */
    'claims': Array<ApplicationClaimType>;
    /**
     * 
     * @type {boolean}
     * @memberof RoleViewModel
     */
    'isWorkshopRole': boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleViewModel
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface ServiceAuditLogListViewModel
 */
export interface ServiceAuditLogListViewModel {
    /**
     * 
     * @type {string}
     * @memberof ServiceAuditLogListViewModel
     */
    'quoteResponseId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceAuditLogListViewModel
     */
    'bookingId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceAuditLogListViewModel
     */
    'dateTimeStamp': string;
    /**
     * 
     * @type {ServiceAuditTypesEnum}
     * @memberof ServiceAuditLogListViewModel
     */
    'serviceAuditLogTypeId': ServiceAuditTypesEnum;
    /**
     * 
     * @type {string}
     * @memberof ServiceAuditLogListViewModel
     */
    'createdByUserDisplayName': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAuditLogListViewModel
     */
    'userType': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAuditLogListViewModel
     */
    'quoteRequestReferenceNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAuditLogListViewModel
     */
    'bookingReviewId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceAuditLogListViewModel
     */
    'workshopName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceAuditLogListViewModel
     */
    'quoteRequestId': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ServiceAuditTypesEnum = {
    CustomerReschedule: 'CustomerReschedule',
    CustomerReview: 'CustomerReview',
    ServiceCompleted: 'ServiceCompleted',
    WorkshopBookingConfirmed: 'WorkshopBookingConfirmed',
    CustomerBookingSet: 'CustomerBookingSet',
    QuoteSupplied: 'QuoteSupplied',
    InitialQuoteResponseSent: 'InitialQuoteResponseSent',
    WorkshopReschedule: 'WorkshopReschedule',
    WorkshopResponseExpired: 'WorkshopResponseExpired',
    RequestCreation: 'RequestCreation',
    InitialQuoteResponseWarning: 'InitialQuoteResponseWarning',
    QuoteRequestCancelled: 'QuoteRequestCancelled',
    CustomerBookingResponseExpired: 'CustomerBookingResponseExpired',
    BookingCancelled: 'BookingCancelled',
    RequestRemovedFromWorkshop: 'RequestRemovedFromWorkshop'
} as const;

export type ServiceAuditTypesEnum = typeof ServiceAuditTypesEnum[keyof typeof ServiceAuditTypesEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const ServiceTypeEnum = {
    Mileage: 'Mileage',
    Interval: 'Interval'
} as const;

export type ServiceTypeEnum = typeof ServiceTypeEnum[keyof typeof ServiceTypeEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const SortDirection = {
    Asc: 'Asc',
    Desc: 'Desc'
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];


/**
 * 
 * @export
 * @interface SubmitAdhocQuoteRequest
 */
export interface SubmitAdhocQuoteRequest {
    /**
     * 
     * @type {string}
     * @memberof SubmitAdhocQuoteRequest
     */
    'vehicleManufacturer': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitAdhocQuoteRequest
     */
    'vehicleModel': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitAdhocQuoteRequest
     */
    'vehicleYear': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitAdhocQuoteRequest
     */
    'vehicleSpecification': string;
    /**
     * 
     * @type {ServiceTypeEnum}
     * @memberof SubmitAdhocQuoteRequest
     */
    'serviceTypeId': ServiceTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SubmitAdhocQuoteRequest
     */
    'vehicleMileage': number;
    /**
     * 
     * @type {string}
     * @memberof SubmitAdhocQuoteRequest
     */
    'additionalInfo'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubmitAdhocQuoteRequest
     */
    'allowFlexibleDates': boolean;
    /**
     * 
     * @type {number}
     * @memberof SubmitAdhocQuoteRequest
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof SubmitAdhocQuoteRequest
     */
    'longitude': number;
    /**
     * 
     * @type {number}
     * @memberof SubmitAdhocQuoteRequest
     */
    'maxTravelDistanceInKilometers': number;
    /**
     * 
     * @type {string}
     * @memberof SubmitAdhocQuoteRequest
     */
    'customerFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitAdhocQuoteRequest
     */
    'customerLastName': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitAdhocQuoteRequest
     */
    'customerEmail': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitAdhocQuoteRequest
     */
    'customerPhoneNumber': string;
    /**
     * 
     * @type {boolean}
     * @memberof SubmitAdhocQuoteRequest
     */
    'termsAndConditionsAccepted': boolean;
    /**
     * 
     * @type {string}
     * @memberof SubmitAdhocQuoteRequest
     */
    'workshopId': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitAdhocQuoteRequest
     */
    'bookingDate': string;
    /**
     * 
     * @type {Array<QuoteResponseLineItemUpdateModel>}
     * @memberof SubmitAdhocQuoteRequest
     */
    'quoteResponseLineItems': Array<QuoteResponseLineItemUpdateModel>;
    /**
     * 
     * @type {QuoteResponseDiscountTypeEnum}
     * @memberof SubmitAdhocQuoteRequest
     */
    'quoteResponseDiscountTypeId': QuoteResponseDiscountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SubmitAdhocQuoteRequest
     */
    'discountValue'?: number | null;
}
/**
 * 
 * @export
 * @interface SubmitLoyaltyPointsClaimAdminCommand
 */
export interface SubmitLoyaltyPointsClaimAdminCommand {
    /**
     * 
     * @type {string}
     * @memberof SubmitLoyaltyPointsClaimAdminCommand
     */
    'invoiceRelativeUrl': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitLoyaltyPointsClaimAdminCommand
     */
    'invoiceNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitLoyaltyPointsClaimAdminCommand
     */
    'invoiceDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitLoyaltyPointsClaimAdminCommand
     */
    'workshopId': string;
    /**
     * 
     * @type {Array<LoyaltyPointsClaimProductCreateUpdateModel>}
     * @memberof SubmitLoyaltyPointsClaimAdminCommand
     */
    'products': Array<LoyaltyPointsClaimProductCreateUpdateModel>;
    /**
     * 
     * @type {number}
     * @memberof SubmitLoyaltyPointsClaimAdminCommand
     */
    'totalOverrideValue'?: number | null;
}
/**
 * 
 * @export
 * @interface SubmitLoyaltyPointsClaimCommand
 */
export interface SubmitLoyaltyPointsClaimCommand {
    /**
     * 
     * @type {string}
     * @memberof SubmitLoyaltyPointsClaimCommand
     */
    'invoiceRelativeUrl': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitLoyaltyPointsClaimCommand
     */
    'workshopId': string;
}
/**
 * 
 * @export
 * @interface SubmitLoyaltyPointsReturnCommand
 */
export interface SubmitLoyaltyPointsReturnCommand {
    /**
     * 
     * @type {string}
     * @memberof SubmitLoyaltyPointsReturnCommand
     */
    'returnReason': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitLoyaltyPointsReturnCommand
     */
    'workshopId': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitLoyaltyPointsReturnCommand
     */
    'loyaltyPointsUpdateId': string;
}
/**
 * 
 * @export
 * @interface SubmitQuoteRequest
 */
export interface SubmitQuoteRequest {
    /**
     * 
     * @type {string}
     * @memberof SubmitQuoteRequest
     */
    'vehicleManufacturer': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitQuoteRequest
     */
    'vehicleModel': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitQuoteRequest
     */
    'vehicleYear': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitQuoteRequest
     */
    'vehicleSpecification': string;
    /**
     * 
     * @type {ServiceTypeEnum}
     * @memberof SubmitQuoteRequest
     */
    'serviceTypeId': ServiceTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SubmitQuoteRequest
     */
    'vehicleMileage': number;
    /**
     * 
     * @type {string}
     * @memberof SubmitQuoteRequest
     */
    'additionalInfo'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubmitQuoteRequest
     */
    'allowFlexibleDates': boolean;
    /**
     * 
     * @type {number}
     * @memberof SubmitQuoteRequest
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof SubmitQuoteRequest
     */
    'longitude': number;
    /**
     * 
     * @type {number}
     * @memberof SubmitQuoteRequest
     */
    'maxTravelDistanceInKilometers': number;
    /**
     * 
     * @type {string}
     * @memberof SubmitQuoteRequest
     */
    'customerFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitQuoteRequest
     */
    'customerLastName': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitQuoteRequest
     */
    'customerEmail': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitQuoteRequest
     */
    'customerPhoneNumber': string;
    /**
     * 
     * @type {boolean}
     * @memberof SubmitQuoteRequest
     */
    'termsAndConditionsAccepted': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubmitQuoteRequest
     */
    'requestedDates': Array<string>;
}
/**
 * 
 * @export
 * @interface SubmitQuoteResponse
 */
export interface SubmitQuoteResponse {
    /**
     * 
     * @type {string}
     * @memberof SubmitQuoteResponse
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof SubmitQuoteResponse
     */
    'discountValue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitQuoteResponse
     */
    'serviceDate'?: string | null;
    /**
     * 
     * @type {Array<QuoteResponseLineItemUpdateModel>}
     * @memberof SubmitQuoteResponse
     */
    'quoteResponseLineItems': Array<QuoteResponseLineItemUpdateModel>;
    /**
     * 
     * @type {QuoteResponseDiscountTypeEnum}
     * @memberof SubmitQuoteResponse
     */
    'quoteResponseDiscountTypeId': QuoteResponseDiscountTypeEnum;
}
/**
 *
 * @export
 * @interface SubmitQuoteResponseResultModel
 */
export interface SubmitQuoteResponseResultModel {
    /**
     *
     * @type {number}
     * @memberof SubmitQuoteResponseResultModel
     */
    'responseOrder': number;
    /**
     *
     * @type {boolean}
     * @memberof SubmitQuoteResponseResultModel
     */
    'inInitialResponseBatch': boolean;
}
/**
 *
 * @export
 * @interface TokenResultDto
 */
export interface TokenResultDto {
    /**
     * 
     * @type {string}
     * @memberof TokenResultDto
     */
    'tokenType': string;
    /**
     * 
     * @type {string}
     * @memberof TokenResultDto
     */
    'authenticationToken'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TokenResultDto
     */
    'expiresIn': number;
    /**
     * 
     * @type {string}
     * @memberof TokenResultDto
     */
    'refreshToken'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateBookingReviewCommand
 */
export interface UpdateBookingReviewCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateBookingReviewCommand
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBookingReviewCommand
     */
    'response'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateBulletinCommand
 */
export interface UpdateBulletinCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateBulletinCommand
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBulletinCommand
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBulletinCommand
     */
    'thumbnailRelativeUrl': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBulletinCommand
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBulletinCommand
     */
    'contentRelativeUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBulletinCommand
     */
    'publishDate': string;
    /**
     * 
     * @type {BulletinType}
     * @memberof UpdateBulletinCommand
     */
    'bulletinTypesId': BulletinType;
}
/**
 * 
 * @export
 * @interface UpdateInfoDto
 */
export interface UpdateInfoDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateInfoDto
     */
    'newEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateInfoDto
     */
    'newPassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateInfoDto
     */
    'oldPassword'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateLoyaltyPointsTranactionReturnCommand
 */
export interface UpdateLoyaltyPointsTranactionReturnCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateLoyaltyPointsTranactionReturnCommand
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoyaltyPointsTranactionReturnCommand
     */
    'returnReason': string;
    /**
     * 
     * @type {ReturnsStatus}
     * @memberof UpdateLoyaltyPointsTranactionReturnCommand
     */
    'returnsStatusId': ReturnsStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoyaltyPointsTranactionReturnCommand
     */
    'skynamoId'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateLoyaltyPointsTransactionTrackingNumber
 */
export interface UpdateLoyaltyPointsTransactionTrackingNumber {
    /**
     * 
     * @type {string}
     * @memberof UpdateLoyaltyPointsTransactionTrackingNumber
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoyaltyPointsTransactionTrackingNumber
     */
    'trackingNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateProductCommand
 */
export interface UpdateProductCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductCommand
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductCommand
     */
    'sku': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductCommand
     */
    'name': string;
    /**
     * 
     * @type {Array<ProductLoyaltyPointValueCreateUpdateModel>}
     * @memberof UpdateProductCommand
     */
    'productLoyaltyPointValues': Array<ProductLoyaltyPointValueCreateUpdateModel>;
    /**
     * 
     * @type {Array<ProductSkuAliasCreateUpdateViewModel>}
     * @memberof UpdateProductCommand
     */
    'productSkuAliases': Array<ProductSkuAliasCreateUpdateViewModel>;
}
/**
 * 
 * @export
 * @interface UpdatePublicHolidayCommand
 */
export interface UpdatePublicHolidayCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdatePublicHolidayCommand
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePublicHolidayCommand
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePublicHolidayCommand
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface UpdateQuoteOfferedServiceCommand
 */
export interface UpdateQuoteOfferedServiceCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteOfferedServiceCommand
     */
    'id': string;
    /**
     * 
     * @type {QuoteOfferedServiceTypeEnum}
     * @memberof UpdateQuoteOfferedServiceCommand
     */
    'quoteServiceTypeId': QuoteOfferedServiceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteOfferedServiceCommand
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface UpdateQuoteSettingsCommand
 */
export interface UpdateQuoteSettingsCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateQuoteSettingsCommand
     */
    'quoteDelayBeforeFirstCustomerUpdateInBusinessHours': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateQuoteSettingsCommand
     */
    'quoteWorkshopResponseCutoffInBusinessHours': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateQuoteSettingsCommand
     */
    'quoteCustomerWorkshopSelectionCutoffInBusinessDays': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateQuoteSettingsCommand
     */
    'vatPercentage': number;
    /**
     *
     * @type {number}
     * @memberof UpdateQuoteSettingsCommand
     */
    'defaultQuoteResponseBatchSize': number;
}
/**
 * 
 * @export
 * @interface UpdateRoleCommand
 */
export interface UpdateRoleCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleCommand
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleCommand
     */
    'name': string;
    /**
     * 
     * @type {Array<ApplicationClaimType>}
     * @memberof UpdateRoleCommand
     */
    'claims': Array<ApplicationClaimType>;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleCommand
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateUserCommand
 */
export interface UpdateUserCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserCommand
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserCommand
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserCommand
     */
    'email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserCommand
     */
    'roleIds': Array<string>;
    /**
     * 
     * @type {Array<WorkshopUserRoleCreateUpdateModel>}
     * @memberof UpdateUserCommand
     */
    'workshopRoles': Array<WorkshopUserRoleCreateUpdateModel>;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserCommand
     */
    'cellNumber': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserCommand
     */
    'isEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserCommand
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserCommand
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserCommand
     */
    'isVerified'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserCommand
     */
    'skynamoReferenceCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserCommand
     */
    'isGlobalUser'?: boolean | null;
}
/**
 * 
 * @export
 * @interface UpdateWorkshopCommand
 */
export interface UpdateWorkshopCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkshopCommand
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkshopCommand
     */
    'name': string;
    /**
     * 
     * @type {WorkshopStatus}
     * @memberof UpdateWorkshopCommand
     */
    'workshopStatusId': WorkshopStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkshopCommand
     */
    'advanceUserEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkshopCommand
     */
    'skynamoId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkshopCommand
     */
    'relativeImageUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateWorkshopQuoteSettingsCommand
 */
export interface UpdateWorkshopQuoteSettingsCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkshopQuoteSettingsCommand
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkshopQuoteSettingsCommand
     */
    'vatRegistration'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkshopQuoteSettingsCommand
     */
    'address'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkshopQuoteSettingsCommand
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkshopQuoteSettingsCommand
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWorkshopQuoteSettingsCommand
     */
    'canReceiveQuotes': boolean;
    /**
     * 
     * @type {Array<WorkshopBusinessDayUpdateModel>}
     * @memberof UpdateWorkshopQuoteSettingsCommand
     */
    'workshopBusinessDays': Array<WorkshopBusinessDayUpdateModel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateWorkshopQuoteSettingsCommand
     */
    'workshopEmailContacts': Array<string>;
    /**
     * 
     * @type {Array<WorkshopOfferedServicesUpdateModel>}
     * @memberof UpdateWorkshopQuoteSettingsCommand
     */
    'workshopOfferedServices': Array<WorkshopOfferedServicesUpdateModel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateWorkshopQuoteSettingsCommand
     */
    'workshopPhoneContacts': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkshopQuoteSettingsCommand
     */
    'googlePlacesId'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateWorkshopUserCommand
 */
export interface UpdateWorkshopUserCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkshopUserCommand
     */
    'workshopId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateWorkshopUserCommand
     */
    'roleIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkshopUserCommand
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface UserViewModel
 */
export interface UserViewModel {
    /**
     * 
     * @type {string}
     * @memberof UserViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserViewModel
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof UserViewModel
     */
    'email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserViewModel
     */
    'roleIds': Array<string>;
    /**
     * 
     * @type {Array<WorkshopUserRoleViewModel>}
     * @memberof UserViewModel
     */
    'workshopRoles': Array<WorkshopUserRoleViewModel>;
    /**
     * 
     * @type {string}
     * @memberof UserViewModel
     */
    'cellNumber': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserViewModel
     */
    'acceptedPrivicyPolicy': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserViewModel
     */
    'isEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserViewModel
     */
    'workshopName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserViewModel
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserViewModel
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserViewModel
     */
    'isWorkshopUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserViewModel
     */
    'isVerified'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserViewModel
     */
    'skynamoReferenceCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserViewModel
     */
    'isGlobalUser': boolean;
}
/**
 * 
 * @export
 * @interface WorkshopBalanceViewModel
 */
export interface WorkshopBalanceViewModel {
    /**
     * 
     * @type {number}
     * @memberof WorkshopBalanceViewModel
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopBalanceViewModel
     */
    'totalExpiringSoon': number;
}
/**
 * 
 * @export
 * @interface WorkshopBusinessDayUpdateModel
 */
export interface WorkshopBusinessDayUpdateModel {
    /**
     * 
     * @type {BusinessDayOfWeekEnum}
     * @memberof WorkshopBusinessDayUpdateModel
     */
    'businessDayOfWeekId': BusinessDayOfWeekEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkshopBusinessDayUpdateModel
     */
    'openingTime': string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopBusinessDayUpdateModel
     */
    'closingTime': string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkshopBusinessDayUpdateModel
     */
    'isClosed': boolean;
}
/**
 * 
 * @export
 * @interface WorkshopBusinessDayViewModel
 */
export interface WorkshopBusinessDayViewModel {
    /**
     * 
     * @type {BusinessDayOfWeekEnum}
     * @memberof WorkshopBusinessDayViewModel
     */
    'businessDayOfWeekId': BusinessDayOfWeekEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkshopBusinessDayViewModel
     */
    'openingTime': string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopBusinessDayViewModel
     */
    'closingTime': string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkshopBusinessDayViewModel
     */
    'isClosed': boolean;
}
/**
 * 
 * @export
 * @interface WorkshopOfferedServiceViewModel
 */
export interface WorkshopOfferedServiceViewModel {
    /**
     * 
     * @type {string}
     * @memberof WorkshopOfferedServiceViewModel
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopOfferedServiceViewModel
     */
    'quoteOfferedServiceId'?: string | null;
    /**
     * 
     * @type {QuoteOfferedServiceTypeEnum}
     * @memberof WorkshopOfferedServiceViewModel
     */
    'quoteOfferedServiceTypeId': QuoteOfferedServiceTypeEnum;
    /**
     * 
     * @type {QuoteOfferedServiceViewModel}
     * @memberof WorkshopOfferedServiceViewModel
     */
    'quoteOfferedService': QuoteOfferedServiceViewModel;
}
/**
 * 
 * @export
 * @interface WorkshopOfferedServicesUpdateModel
 */
export interface WorkshopOfferedServicesUpdateModel {
    /**
     * 
     * @type {string}
     * @memberof WorkshopOfferedServicesUpdateModel
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopOfferedServicesUpdateModel
     */
    'quoteOfferedServiceId'?: string | null;
    /**
     * 
     * @type {QuoteOfferedServiceTypeEnum}
     * @memberof WorkshopOfferedServicesUpdateModel
     */
    'quoteOfferedServiceTypeId': QuoteOfferedServiceTypeEnum;
}
/**
 * 
 * @export
 * @interface WorkshopPublicViewModel
 */
export interface WorkshopPublicViewModel {
    /**
     * 
     * @type {string}
     * @memberof WorkshopPublicViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopPublicViewModel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopPublicViewModel
     */
    'relativeImageUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopPublicViewModel
     */
    'address'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorkshopPublicViewModel
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WorkshopPublicViewModel
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopPublicViewModel
     */
    'googlePlacesId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkshopPublicViewModel
     */
    'workshopEmailContacts': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkshopPublicViewModel
     */
    'workshopPhoneContacts': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof WorkshopPublicViewModel
     */
    'averageCustomerRating': number;
    /**
     * 
     * @type {Array<WorkshopWorkshopOfferedServiceViewModel>}
     * @memberof WorkshopPublicViewModel
     */
    'workshopOfferedServices': Array<WorkshopWorkshopOfferedServiceViewModel>;
}
/**
 * 
 * @export
 * @interface WorkshopQuoteProgrammeHistoryViewModel
 */
export interface WorkshopQuoteProgrammeHistoryViewModel {
    /**
     * 
     * @type {string}
     * @memberof WorkshopQuoteProgrammeHistoryViewModel
     */
    'dateTimeStamp': string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopQuoteProgrammeHistoryViewModel
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopQuoteProgrammeHistoryViewModel
     */
    'userDisplayName': string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkshopQuoteProgrammeHistoryViewModel
     */
    'canRecieveQuotes': boolean;
}
/**
 * 
 * @export
 * @interface WorkshopQuoteSettingsViewModel
 */
export interface WorkshopQuoteSettingsViewModel {
    /**
     * 
     * @type {string}
     * @memberof WorkshopQuoteSettingsViewModel
     */
    'vatRegistration'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopQuoteSettingsViewModel
     */
    'address'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorkshopQuoteSettingsViewModel
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WorkshopQuoteSettingsViewModel
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkshopQuoteSettingsViewModel
     */
    'canReceiveQuotes': boolean;
    /**
     * 
     * @type {Array<WorkshopBusinessDayViewModel>}
     * @memberof WorkshopQuoteSettingsViewModel
     */
    'workshopBusinessDays': Array<WorkshopBusinessDayViewModel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkshopQuoteSettingsViewModel
     */
    'workshopEmailContacts': Array<string>;
    /**
     * 
     * @type {Array<WorkshopOfferedServiceViewModel>}
     * @memberof WorkshopQuoteSettingsViewModel
     */
    'workshopOfferedServices': Array<WorkshopOfferedServiceViewModel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkshopQuoteSettingsViewModel
     */
    'workshopPhoneContacts': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WorkshopQuoteSettingsViewModel
     */
    'googlePlacesId'?: string | null;
    /**
     * 
     * @type {Array<WorkshopQuoteProgrammeHistoryViewModel>}
     * @memberof WorkshopQuoteSettingsViewModel
     */
    'workshopQuoteProgrammeHistories': Array<WorkshopQuoteProgrammeHistoryViewModel>;
}
/**
 * 
 * @export
 * @interface WorkshopQuoteStatisticsViewModel
 */
export interface WorkshopQuoteStatisticsViewModel {
    /**
     * 
     * @type {number}
     * @memberof WorkshopQuoteStatisticsViewModel
     */
    'averageReviewRating': number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopQuoteStatisticsViewModel
     */
    'reviewCount': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof WorkshopQuoteStatisticsViewModel
     */
    'reviewScoreCounts': { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof WorkshopQuoteStatisticsViewModel
     */
    'quotesAwaitingResponseCount': number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopQuoteStatisticsViewModel
     */
    'monthlyAverageBookingValue': number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopQuoteStatisticsViewModel
     */
    'monthlyTotalBookingValue': number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopQuoteStatisticsViewModel
     */
    'monthlyBookingCount': number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopQuoteStatisticsViewModel
     */
    'totalBookingCount': number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopQuoteStatisticsViewModel
     */
    'monthlyDelinquentActionsCount': number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopQuoteStatisticsViewModel
     */
    'monthlyDelinquentWorkshopsCount'?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const WorkshopStatus = {
    New: 'New',
    Active: 'Active',
    Inactive: 'Inactive'
} as const;

export type WorkshopStatus = typeof WorkshopStatus[keyof typeof WorkshopStatus];


/**
 * 
 * @export
 * @interface WorkshopUserRoleCreateUpdateModel
 */
export interface WorkshopUserRoleCreateUpdateModel {
    /**
     * 
     * @type {string}
     * @memberof WorkshopUserRoleCreateUpdateModel
     */
    'workshopId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopUserRoleCreateUpdateModel
     */
    'roleId': string;
}
/**
 * 
 * @export
 * @interface WorkshopUserRoleViewModel
 */
export interface WorkshopUserRoleViewModel {
    /**
     * 
     * @type {string}
     * @memberof WorkshopUserRoleViewModel
     */
    'workshopId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopUserRoleViewModel
     */
    'roleId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopUserRoleViewModel
     */
    'workshopName': string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopUserRoleViewModel
     */
    'roleName': string;
}
/**
 * 
 * @export
 * @interface WorkshopUserViewModel
 */
export interface WorkshopUserViewModel {
    /**
     * 
     * @type {string}
     * @memberof WorkshopUserViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopUserViewModel
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopUserViewModel
     */
    'email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkshopUserViewModel
     */
    'roleIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WorkshopUserViewModel
     */
    'cellNumber': string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopUserViewModel
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopUserViewModel
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkshopUserViewModel
     */
    'isVerified'?: boolean | null;
}
/**
 * 
 * @export
 * @interface WorkshopUserWorkshopViewModel
 */
export interface WorkshopUserWorkshopViewModel {
    /**
     * 
     * @type {string}
     * @memberof WorkshopUserWorkshopViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopUserWorkshopViewModel
     */
    'roleName': string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopUserWorkshopViewModel
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopUserWorkshopViewModel
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface WorkshopViewModel
 */
export interface WorkshopViewModel {
    /**
     * 
     * @type {string}
     * @memberof WorkshopViewModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopViewModel
     */
    'name': string;
    /**
     * 
     * @type {WorkshopStatus}
     * @memberof WorkshopViewModel
     */
    'workshopStatusId': WorkshopStatus;
    /**
     * 
     * @type {string}
     * @memberof WorkshopViewModel
     */
    'advanceUserEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopViewModel
     */
    'skynamoId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopViewModel
     */
    'relativeImageUrl'?: string | null;
    /**
     * 
     * @type {Array<WorkshopUserWorkshopViewModel>}
     * @memberof WorkshopViewModel
     */
    'workshopUsers': Array<WorkshopUserWorkshopViewModel>;
    /**
     * 
     * @type {string}
     * @memberof WorkshopViewModel
     */
    'updatedDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopViewModel
     */
    'activatedDate'?: string | null;
    /**
     * 
     * @type {Array<WorkshopQuoteProgrammeHistoryViewModel>}
     * @memberof WorkshopViewModel
     */
    'workshopQuoteProgrammeHistories': Array<WorkshopQuoteProgrammeHistoryViewModel>;
}
/**
 * 
 * @export
 * @interface WorkshopWorkshopOfferedServiceViewModel
 */
export interface WorkshopWorkshopOfferedServiceViewModel {
    /**
     * 
     * @type {string}
     * @memberof WorkshopWorkshopOfferedServiceViewModel
     */
    'name'?: string | null;
    /**
     * 
     * @type {QuoteOfferedServiceTypeEnum}
     * @memberof WorkshopWorkshopOfferedServiceViewModel
     */
    'quoteOfferedServiceTypeId': QuoteOfferedServiceTypeEnum;
}

/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ConfirmEmailDto} [confirmEmailDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountConfirmEmailPost: async (confirmEmailDto?: ConfirmEmailDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Account/ConfirmEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmEmailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ForgotPasswordDto} [forgotPasswordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountForgotPasswordPost: async (forgotPasswordDto?: ForgotPasswordDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Account/forgotPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forgotPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginDto} [loginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountLoginPost: async (loginDto?: LoginDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Account/Login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountLogoutPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Account/Logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountManageInfoGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Account/manage/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateInfoDto} [updateInfoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountManageInfoPost: async (updateInfoDto?: UpdateInfoDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Account/manage/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInfoDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [authenticationToken] 
         * @param {string} [refreshToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountRefreshPost: async (authenticationToken?: string, refreshToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Account/Refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authenticationToken !== undefined) {
                localVarQueryParameter['authenticationToken'] = authenticationToken;
            }

            if (refreshToken !== undefined) {
                localVarQueryParameter['refreshToken'] = refreshToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TokenResultDto} [tokenResultDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountRefreshTokenPost: async (tokenResultDto?: TokenResultDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Account/RefreshToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenResultDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterDto} [registerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountRegisterPost: async (registerDto?: RegisterDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Account/Register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [emailAddress] 
         * @param {string} [passwordResetToken] 
         * @param {string} [newPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountResetForgotPasswordPost: async (emailAddress?: string, passwordResetToken?: string, newPassword?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Account/ResetForgotPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (emailAddress !== undefined) {
                localVarQueryParameter['emailAddress'] = emailAddress;
            }

            if (passwordResetToken !== undefined) {
                localVarQueryParameter['passwordResetToken'] = passwordResetToken;
            }

            if (newPassword !== undefined) {
                localVarQueryParameter['newPassword'] = newPassword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResetPasswordDto} [resetPasswordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountResetPasswordPost: async (resetPasswordDto?: ResetPasswordDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Account/resetPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ConfirmEmailDto} [confirmEmailDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountConfirmEmailPost(confirmEmailDto?: ConfirmEmailDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountConfirmEmailPost(confirmEmailDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ForgotPasswordDto} [forgotPasswordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountForgotPasswordPost(forgotPasswordDto?: ForgotPasswordDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountForgotPasswordPost(forgotPasswordDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LoginDto} [loginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountLoginPost(loginDto?: LoginDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountLoginPost(loginDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountLogoutPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountLogoutPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountManageInfoGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InfoResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountManageInfoGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateInfoDto} [updateInfoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountManageInfoPost(updateInfoDto?: UpdateInfoDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InfoResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountManageInfoPost(updateInfoDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [authenticationToken] 
         * @param {string} [refreshToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountRefreshPost(authenticationToken?: string, refreshToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountRefreshPost(authenticationToken, refreshToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TokenResultDto} [tokenResultDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountRefreshTokenPost(tokenResultDto?: TokenResultDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountRefreshTokenPost(tokenResultDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RegisterDto} [registerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountRegisterPost(registerDto?: RegisterDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountRegisterPost(registerDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [emailAddress] 
         * @param {string} [passwordResetToken] 
         * @param {string} [newPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountResetForgotPasswordPost(emailAddress?: string, passwordResetToken?: string, newPassword?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountResetForgotPasswordPost(emailAddress, passwordResetToken, newPassword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ResetPasswordDto} [resetPasswordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountResetPasswordPost(resetPasswordDto?: ResetPasswordDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountResetPasswordPost(resetPasswordDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * 
         * @param {ConfirmEmailDto} [confirmEmailDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountConfirmEmailPost(confirmEmailDto?: ConfirmEmailDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiAccountConfirmEmailPost(confirmEmailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ForgotPasswordDto} [forgotPasswordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountForgotPasswordPost(forgotPasswordDto?: ForgotPasswordDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiAccountForgotPasswordPost(forgotPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoginDto} [loginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountLoginPost(loginDto?: LoginDto, options?: any): AxiosPromise<TokenResultDto> {
            return localVarFp.apiAccountLoginPost(loginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountLogoutPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiAccountLogoutPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountManageInfoGet(options?: any): AxiosPromise<InfoResponseDto> {
            return localVarFp.apiAccountManageInfoGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateInfoDto} [updateInfoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountManageInfoPost(updateInfoDto?: UpdateInfoDto, options?: any): AxiosPromise<InfoResponseDto> {
            return localVarFp.apiAccountManageInfoPost(updateInfoDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [authenticationToken] 
         * @param {string} [refreshToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountRefreshPost(authenticationToken?: string, refreshToken?: string, options?: any): AxiosPromise<TokenResultDto> {
            return localVarFp.apiAccountRefreshPost(authenticationToken, refreshToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TokenResultDto} [tokenResultDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountRefreshTokenPost(tokenResultDto?: TokenResultDto, options?: any): AxiosPromise<TokenResultDto> {
            return localVarFp.apiAccountRefreshTokenPost(tokenResultDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegisterDto} [registerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountRegisterPost(registerDto?: RegisterDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiAccountRegisterPost(registerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [emailAddress] 
         * @param {string} [passwordResetToken] 
         * @param {string} [newPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountResetForgotPasswordPost(emailAddress?: string, passwordResetToken?: string, newPassword?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAccountResetForgotPasswordPost(emailAddress, passwordResetToken, newPassword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResetPasswordDto} [resetPasswordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountResetPasswordPost(resetPasswordDto?: ResetPasswordDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiAccountResetPasswordPost(resetPasswordDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @param {ConfirmEmailDto} [confirmEmailDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiAccountConfirmEmailPost(confirmEmailDto?: ConfirmEmailDto, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiAccountConfirmEmailPost(confirmEmailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ForgotPasswordDto} [forgotPasswordDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiAccountForgotPasswordPost(forgotPasswordDto?: ForgotPasswordDto, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiAccountForgotPasswordPost(forgotPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoginDto} [loginDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiAccountLoginPost(loginDto?: LoginDto, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiAccountLoginPost(loginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiAccountLogoutPost(options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiAccountLogoutPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiAccountManageInfoGet(options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiAccountManageInfoGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateInfoDto} [updateInfoDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiAccountManageInfoPost(updateInfoDto?: UpdateInfoDto, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiAccountManageInfoPost(updateInfoDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [authenticationToken] 
     * @param {string} [refreshToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiAccountRefreshPost(authenticationToken?: string, refreshToken?: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiAccountRefreshPost(authenticationToken, refreshToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TokenResultDto} [tokenResultDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiAccountRefreshTokenPost(tokenResultDto?: TokenResultDto, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiAccountRefreshTokenPost(tokenResultDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegisterDto} [registerDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiAccountRegisterPost(registerDto?: RegisterDto, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiAccountRegisterPost(registerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [emailAddress] 
     * @param {string} [passwordResetToken] 
     * @param {string} [newPassword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiAccountResetForgotPasswordPost(emailAddress?: string, passwordResetToken?: string, newPassword?: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiAccountResetForgotPasswordPost(emailAddress, passwordResetToken, newPassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResetPasswordDto} [resetPasswordDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiAccountResetPasswordPost(resetPasswordDto?: ResetPasswordDto, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiAccountResetPasswordPost(resetPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdvanceApi - axios parameter creator
 * @export
 */
export const AdvanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [advanceUserEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdvanceGet: async (advanceUserEmail?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/advance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (advanceUserEmail !== undefined) {
                localVarQueryParameter['advanceUserEmail'] = advanceUserEmail;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OrderCreatedCommand} [orderCreatedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdvanceOrderCreatedPost: async (orderCreatedCommand?: OrderCreatedCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/advance/order-created`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderCreatedCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterAccountCommand} [registerAccountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdvanceRegisterAccountPost: async (registerAccountCommand?: RegisterAccountCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/advance/register-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerAccountCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdvanceApi - functional programming interface
 * @export
 */
export const AdvanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdvanceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [advanceUserEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdvanceGet(advanceUserEmail?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvanceWorkshopViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdvanceGet(advanceUserEmail, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {OrderCreatedCommand} [orderCreatedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdvanceOrderCreatedPost(orderCreatedCommand?: OrderCreatedCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdvanceOrderCreatedPost(orderCreatedCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RegisterAccountCommand} [registerAccountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdvanceRegisterAccountPost(registerAccountCommand?: RegisterAccountCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdvanceRegisterAccountPost(registerAccountCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdvanceApi - factory interface
 * @export
 */
export const AdvanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdvanceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [advanceUserEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdvanceGet(advanceUserEmail?: string, options?: any): AxiosPromise<AdvanceWorkshopViewModel> {
            return localVarFp.apiAdvanceGet(advanceUserEmail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrderCreatedCommand} [orderCreatedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdvanceOrderCreatedPost(orderCreatedCommand?: OrderCreatedCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiAdvanceOrderCreatedPost(orderCreatedCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegisterAccountCommand} [registerAccountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdvanceRegisterAccountPost(registerAccountCommand?: RegisterAccountCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiAdvanceRegisterAccountPost(registerAccountCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdvanceApi - object-oriented interface
 * @export
 * @class AdvanceApi
 * @extends {BaseAPI}
 */
export class AdvanceApi extends BaseAPI {
    /**
     * 
     * @param {string} [advanceUserEmail] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvanceApi
     */
    public apiAdvanceGet(advanceUserEmail?: string, options?: AxiosRequestConfig) {
        return AdvanceApiFp(this.configuration).apiAdvanceGet(advanceUserEmail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrderCreatedCommand} [orderCreatedCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvanceApi
     */
    public apiAdvanceOrderCreatedPost(orderCreatedCommand?: OrderCreatedCommand, options?: AxiosRequestConfig) {
        return AdvanceApiFp(this.configuration).apiAdvanceOrderCreatedPost(orderCreatedCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegisterAccountCommand} [registerAccountCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvanceApi
     */
    public apiAdvanceRegisterAccountPost(registerAccountCommand?: RegisterAccountCommand, options?: AxiosRequestConfig) {
        return AdvanceApiFp(this.configuration).apiAdvanceRegisterAccountPost(registerAccountCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AuditLogsApi - axios parameter creator
 * @export
 */
export const AuditLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AuditTypes} [auditLogTypesId] 
         * @param {string} [workshopId] 
         * @param {string} [searchText] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditLogGet: async (auditLogTypesId?: AuditTypes, workshopId?: string, searchText?: string, pageNumber?: number, pageSize?: number, sortDirection?: SortDirection, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/audit-log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (auditLogTypesId !== undefined) {
                localVarQueryParameter['auditLogTypesId'] = auditLogTypesId;
            }

            if (workshopId !== undefined) {
                localVarQueryParameter['workshopId'] = workshopId;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditLogIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditLogIdGet', 'id', id)
            const localVarPath = `/api/audit-log/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditLogsApi - functional programming interface
 * @export
 */
export const AuditLogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditLogsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AuditTypes} [auditLogTypesId] 
         * @param {string} [workshopId] 
         * @param {string} [searchText] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditLogGet(auditLogTypesId?: AuditTypes, workshopId?: string, searchText?: string, pageNumber?: number, pageSize?: number, sortDirection?: SortDirection, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfAuditLogDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditLogGet(auditLogTypesId, workshopId, searchText, pageNumber, pageSize, sortDirection, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditLogIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditLogDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditLogIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuditLogsApi - factory interface
 * @export
 */
export const AuditLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditLogsApiFp(configuration)
    return {
        /**
         * 
         * @param {AuditTypes} [auditLogTypesId] 
         * @param {string} [workshopId] 
         * @param {string} [searchText] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditLogGet(auditLogTypesId?: AuditTypes, workshopId?: string, searchText?: string, pageNumber?: number, pageSize?: number, sortDirection?: SortDirection, options?: any): AxiosPromise<PagedResultOfAuditLogDto> {
            return localVarFp.apiAuditLogGet(auditLogTypesId, workshopId, searchText, pageNumber, pageSize, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditLogIdGet(id: string, options?: any): AxiosPromise<AuditLogDto> {
            return localVarFp.apiAuditLogIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuditLogsApi - object-oriented interface
 * @export
 * @class AuditLogsApi
 * @extends {BaseAPI}
 */
export class AuditLogsApi extends BaseAPI {
    /**
     * 
     * @param {AuditTypes} [auditLogTypesId] 
     * @param {string} [workshopId] 
     * @param {string} [searchText] 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {SortDirection} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogsApi
     */
    public apiAuditLogGet(auditLogTypesId?: AuditTypes, workshopId?: string, searchText?: string, pageNumber?: number, pageSize?: number, sortDirection?: SortDirection, options?: AxiosRequestConfig) {
        return AuditLogsApiFp(this.configuration).apiAuditLogGet(auditLogTypesId, workshopId, searchText, pageNumber, pageSize, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogsApi
     */
    public apiAuditLogIdGet(id: string, options?: AxiosRequestConfig) {
        return AuditLogsApiFp(this.configuration).apiAuditLogIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BookingReviewsApi - axios parameter creator
 * @export
 */
export const BookingReviewsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {string} [workshopId] 
         * @param {boolean} [hasResponse] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBookingReviewsAdminGet: async (pageNo?: number, pageSize?: number, orderBy?: string, workshopId?: string, hasResponse?: boolean, searchTerm?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/booking-reviews-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['pageNo'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (workshopId !== undefined) {
                localVarQueryParameter['workshopId'] = workshopId;
            }

            if (hasResponse !== undefined) {
                localVarQueryParameter['hasResponse'] = hasResponse;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {string} [workshopId] 
         * @param {boolean} [hasResponse] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBookingReviewsGet: async (pageNo?: number, pageSize?: number, orderBy?: string, workshopId?: string, hasResponse?: boolean, searchTerm?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/booking-reviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['pageNo'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (workshopId !== undefined) {
                localVarQueryParameter['workshopId'] = workshopId;
            }

            if (hasResponse !== undefined) {
                localVarQueryParameter['hasResponse'] = hasResponse;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBookingReviewsIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiBookingReviewsIdDelete', 'id', id)
            const localVarPath = `/api/booking-reviews/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBookingReviewsIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiBookingReviewsIdGet', 'id', id)
            const localVarPath = `/api/booking-reviews/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBookingReviewCommand} [updateBookingReviewCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBookingReviewsIdPut: async (id: string, updateBookingReviewCommand?: UpdateBookingReviewCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiBookingReviewsIdPut', 'id', id)
            const localVarPath = `/api/booking-reviews/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBookingReviewCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateBookingReviewCommand} [createBookingReviewCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBookingReviewsPost: async (createBookingReviewCommand?: CreateBookingReviewCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/booking-reviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBookingReviewCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookingReviewsApi - functional programming interface
 * @export
 */
export const BookingReviewsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookingReviewsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {string} [workshopId] 
         * @param {boolean} [hasResponse] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBookingReviewsAdminGet(pageNo?: number, pageSize?: number, orderBy?: string, workshopId?: string, hasResponse?: boolean, searchTerm?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfBookingReviewViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBookingReviewsAdminGet(pageNo, pageSize, orderBy, workshopId, hasResponse, searchTerm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {string} [workshopId] 
         * @param {boolean} [hasResponse] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBookingReviewsGet(pageNo?: number, pageSize?: number, orderBy?: string, workshopId?: string, hasResponse?: boolean, searchTerm?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfBookingReviewViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBookingReviewsGet(pageNo, pageSize, orderBy, workshopId, hasResponse, searchTerm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBookingReviewsIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBookingReviewsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBookingReviewsIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingReviewViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBookingReviewsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBookingReviewCommand} [updateBookingReviewCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBookingReviewsIdPut(id: string, updateBookingReviewCommand?: UpdateBookingReviewCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBookingReviewsIdPut(id, updateBookingReviewCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateBookingReviewCommand} [createBookingReviewCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBookingReviewsPost(createBookingReviewCommand?: CreateBookingReviewCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBookingReviewsPost(createBookingReviewCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BookingReviewsApi - factory interface
 * @export
 */
export const BookingReviewsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookingReviewsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {string} [workshopId] 
         * @param {boolean} [hasResponse] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBookingReviewsAdminGet(pageNo?: number, pageSize?: number, orderBy?: string, workshopId?: string, hasResponse?: boolean, searchTerm?: string, options?: any): AxiosPromise<PagedResultOfBookingReviewViewModel> {
            return localVarFp.apiBookingReviewsAdminGet(pageNo, pageSize, orderBy, workshopId, hasResponse, searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {string} [workshopId] 
         * @param {boolean} [hasResponse] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBookingReviewsGet(pageNo?: number, pageSize?: number, orderBy?: string, workshopId?: string, hasResponse?: boolean, searchTerm?: string, options?: any): AxiosPromise<PagedResultOfBookingReviewViewModel> {
            return localVarFp.apiBookingReviewsGet(pageNo, pageSize, orderBy, workshopId, hasResponse, searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBookingReviewsIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiBookingReviewsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBookingReviewsIdGet(id: string, options?: any): AxiosPromise<BookingReviewViewModel> {
            return localVarFp.apiBookingReviewsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBookingReviewCommand} [updateBookingReviewCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBookingReviewsIdPut(id: string, updateBookingReviewCommand?: UpdateBookingReviewCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiBookingReviewsIdPut(id, updateBookingReviewCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateBookingReviewCommand} [createBookingReviewCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBookingReviewsPost(createBookingReviewCommand?: CreateBookingReviewCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiBookingReviewsPost(createBookingReviewCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BookingReviewsApi - object-oriented interface
 * @export
 * @class BookingReviewsApi
 * @extends {BaseAPI}
 */
export class BookingReviewsApi extends BaseAPI {
    /**
     * 
     * @param {number} [pageNo] 
     * @param {number} [pageSize] 
     * @param {string} [orderBy] 
     * @param {string} [workshopId] 
     * @param {boolean} [hasResponse] 
     * @param {string} [searchTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApi
     */
    public apiBookingReviewsAdminGet(pageNo?: number, pageSize?: number, orderBy?: string, workshopId?: string, hasResponse?: boolean, searchTerm?: string, options?: AxiosRequestConfig) {
        return BookingReviewsApiFp(this.configuration).apiBookingReviewsAdminGet(pageNo, pageSize, orderBy, workshopId, hasResponse, searchTerm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageNo] 
     * @param {number} [pageSize] 
     * @param {string} [orderBy] 
     * @param {string} [workshopId] 
     * @param {boolean} [hasResponse] 
     * @param {string} [searchTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApi
     */
    public apiBookingReviewsGet(pageNo?: number, pageSize?: number, orderBy?: string, workshopId?: string, hasResponse?: boolean, searchTerm?: string, options?: AxiosRequestConfig) {
        return BookingReviewsApiFp(this.configuration).apiBookingReviewsGet(pageNo, pageSize, orderBy, workshopId, hasResponse, searchTerm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApi
     */
    public apiBookingReviewsIdDelete(id: string, options?: AxiosRequestConfig) {
        return BookingReviewsApiFp(this.configuration).apiBookingReviewsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApi
     */
    public apiBookingReviewsIdGet(id: string, options?: AxiosRequestConfig) {
        return BookingReviewsApiFp(this.configuration).apiBookingReviewsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateBookingReviewCommand} [updateBookingReviewCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApi
     */
    public apiBookingReviewsIdPut(id: string, updateBookingReviewCommand?: UpdateBookingReviewCommand, options?: AxiosRequestConfig) {
        return BookingReviewsApiFp(this.configuration).apiBookingReviewsIdPut(id, updateBookingReviewCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateBookingReviewCommand} [createBookingReviewCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApi
     */
    public apiBookingReviewsPost(createBookingReviewCommand?: CreateBookingReviewCommand, options?: AxiosRequestConfig) {
        return BookingReviewsApiFp(this.configuration).apiBookingReviewsPost(createBookingReviewCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BulletinsApi - axios parameter creator
 * @export
 */
export const BulletinsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBulletinCountsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bulletinCounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulletinType} [bulletinTypesId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBulletinGet: async (bulletinTypesId?: BulletinType, pageNumber?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bulletin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (bulletinTypesId !== undefined) {
                localVarQueryParameter['bulletinTypesId'] = bulletinTypesId;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBulletinIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiBulletinIdGet', 'id', id)
            const localVarPath = `/api/bulletin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BulletinsApi - functional programming interface
 * @export
 */
export const BulletinsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BulletinsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBulletinCountsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulletinTypeCountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBulletinCountsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulletinType} [bulletinTypesId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBulletinGet(bulletinTypesId?: BulletinType, pageNumber?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfBulletinDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBulletinGet(bulletinTypesId, pageNumber, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBulletinIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulletinDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBulletinIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BulletinsApi - factory interface
 * @export
 */
export const BulletinsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BulletinsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBulletinCountsGet(options?: any): AxiosPromise<BulletinTypeCountDto> {
            return localVarFp.apiBulletinCountsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulletinType} [bulletinTypesId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBulletinGet(bulletinTypesId?: BulletinType, pageNumber?: number, pageSize?: number, options?: any): AxiosPromise<PagedResultOfBulletinDto> {
            return localVarFp.apiBulletinGet(bulletinTypesId, pageNumber, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBulletinIdGet(id: string, options?: any): AxiosPromise<BulletinDto> {
            return localVarFp.apiBulletinIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BulletinsApi - object-oriented interface
 * @export
 * @class BulletinsApi
 * @extends {BaseAPI}
 */
export class BulletinsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BulletinsApi
     */
    public apiBulletinCountsGet(options?: AxiosRequestConfig) {
        return BulletinsApiFp(this.configuration).apiBulletinCountsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulletinType} [bulletinTypesId] 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BulletinsApi
     */
    public apiBulletinGet(bulletinTypesId?: BulletinType, pageNumber?: number, pageSize?: number, options?: AxiosRequestConfig) {
        return BulletinsApiFp(this.configuration).apiBulletinGet(bulletinTypesId, pageNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BulletinsApi
     */
    public apiBulletinIdGet(id: string, options?: AxiosRequestConfig) {
        return BulletinsApiFp(this.configuration).apiBulletinIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BulletinsAdminApi - axios parameter creator
 * @export
 */
export const BulletinsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {BulletinType} [bulletinTypesId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBulletinAdminGet: async (bulletinTypesId?: BulletinType, pageNumber?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bulletin/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (bulletinTypesId !== undefined) {
                localVarQueryParameter['bulletinTypesId'] = bulletinTypesId;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBulletinAdminIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiBulletinAdminIdGet', 'id', id)
            const localVarPath = `/api/bulletin/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBulletinCommand} [updateBulletinCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBulletinAdminIdPut: async (id: string, updateBulletinCommand?: UpdateBulletinCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiBulletinAdminIdPut', 'id', id)
            const localVarPath = `/api/bulletin/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBulletinCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateBulletinCommand} [createBulletinCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBulletinAdminPost: async (createBulletinCommand?: CreateBulletinCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bulletin/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBulletinCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBulletinsAdminIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiBulletinsAdminIdDelete', 'id', id)
            const localVarPath = `/api/bulletins/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BulletinsAdminApi - functional programming interface
 * @export
 */
export const BulletinsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BulletinsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {BulletinType} [bulletinTypesId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBulletinAdminGet(bulletinTypesId?: BulletinType, pageNumber?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfBulletinDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBulletinAdminGet(bulletinTypesId, pageNumber, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBulletinAdminIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulletinDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBulletinAdminIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBulletinCommand} [updateBulletinCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBulletinAdminIdPut(id: string, updateBulletinCommand?: UpdateBulletinCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBulletinAdminIdPut(id, updateBulletinCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateBulletinCommand} [createBulletinCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBulletinAdminPost(createBulletinCommand?: CreateBulletinCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonResponseOfGuid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBulletinAdminPost(createBulletinCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBulletinsAdminIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBulletinsAdminIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BulletinsAdminApi - factory interface
 * @export
 */
export const BulletinsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BulletinsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {BulletinType} [bulletinTypesId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBulletinAdminGet(bulletinTypesId?: BulletinType, pageNumber?: number, pageSize?: number, options?: any): AxiosPromise<PagedResultOfBulletinDto> {
            return localVarFp.apiBulletinAdminGet(bulletinTypesId, pageNumber, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBulletinAdminIdGet(id: string, options?: any): AxiosPromise<BulletinDto> {
            return localVarFp.apiBulletinAdminIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBulletinCommand} [updateBulletinCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBulletinAdminIdPut(id: string, updateBulletinCommand?: UpdateBulletinCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiBulletinAdminIdPut(id, updateBulletinCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateBulletinCommand} [createBulletinCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBulletinAdminPost(createBulletinCommand?: CreateBulletinCommand, options?: any): AxiosPromise<JsonResponseOfGuid> {
            return localVarFp.apiBulletinAdminPost(createBulletinCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBulletinsAdminIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiBulletinsAdminIdDelete(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BulletinsAdminApi - object-oriented interface
 * @export
 * @class BulletinsAdminApi
 * @extends {BaseAPI}
 */
export class BulletinsAdminApi extends BaseAPI {
    /**
     * 
     * @param {BulletinType} [bulletinTypesId] 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BulletinsAdminApi
     */
    public apiBulletinAdminGet(bulletinTypesId?: BulletinType, pageNumber?: number, pageSize?: number, options?: AxiosRequestConfig) {
        return BulletinsAdminApiFp(this.configuration).apiBulletinAdminGet(bulletinTypesId, pageNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BulletinsAdminApi
     */
    public apiBulletinAdminIdGet(id: string, options?: AxiosRequestConfig) {
        return BulletinsAdminApiFp(this.configuration).apiBulletinAdminIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateBulletinCommand} [updateBulletinCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BulletinsAdminApi
     */
    public apiBulletinAdminIdPut(id: string, updateBulletinCommand?: UpdateBulletinCommand, options?: AxiosRequestConfig) {
        return BulletinsAdminApiFp(this.configuration).apiBulletinAdminIdPut(id, updateBulletinCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateBulletinCommand} [createBulletinCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BulletinsAdminApi
     */
    public apiBulletinAdminPost(createBulletinCommand?: CreateBulletinCommand, options?: AxiosRequestConfig) {
        return BulletinsAdminApiFp(this.configuration).apiBulletinAdminPost(createBulletinCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BulletinsAdminApi
     */
    public apiBulletinsAdminIdDelete(id: string, options?: AxiosRequestConfig) {
        return BulletinsAdminApiFp(this.configuration).apiBulletinsAdminIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DelinquentWorkshopsApi - axios parameter creator
 * @export
 */
export const DelinquentWorkshopsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDelinquentWorkshopsDelinquentWorkshopsGet: async (pageNo?: number, pageSize?: number, startDate?: string, endDate?: string, searchTerm?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/delinquent-workshops/delinquent-workshops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['pageNo'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [workshopIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDelinquentWorkshopsDelinquentWorkshopsReportGet: async (startDate?: string, endDate?: string, workshopIds?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/delinquent-workshops/delinquent-workshops-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (workshopIds) {
                localVarQueryParameter['workshopIds'] = workshopIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DelinquentWorkshopsApi - functional programming interface
 * @export
 */
export const DelinquentWorkshopsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DelinquentWorkshopsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDelinquentWorkshopsDelinquentWorkshopsGet(pageNo?: number, pageSize?: number, startDate?: string, endDate?: string, searchTerm?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfDelinquentWorkshopListViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDelinquentWorkshopsDelinquentWorkshopsGet(pageNo, pageSize, startDate, endDate, searchTerm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [workshopIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDelinquentWorkshopsDelinquentWorkshopsReportGet(startDate?: string, endDate?: string, workshopIds?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDelinquentWorkshopsDelinquentWorkshopsReportGet(startDate, endDate, workshopIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DelinquentWorkshopsApi - factory interface
 * @export
 */
export const DelinquentWorkshopsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DelinquentWorkshopsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDelinquentWorkshopsDelinquentWorkshopsGet(pageNo?: number, pageSize?: number, startDate?: string, endDate?: string, searchTerm?: string, options?: any): AxiosPromise<PagedResultOfDelinquentWorkshopListViewModel> {
            return localVarFp.apiDelinquentWorkshopsDelinquentWorkshopsGet(pageNo, pageSize, startDate, endDate, searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [workshopIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDelinquentWorkshopsDelinquentWorkshopsReportGet(startDate?: string, endDate?: string, workshopIds?: Array<string>, options?: any): AxiosPromise<string> {
            return localVarFp.apiDelinquentWorkshopsDelinquentWorkshopsReportGet(startDate, endDate, workshopIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DelinquentWorkshopsApi - object-oriented interface
 * @export
 * @class DelinquentWorkshopsApi
 * @extends {BaseAPI}
 */
export class DelinquentWorkshopsApi extends BaseAPI {
    /**
     * 
     * @param {number} [pageNo] 
     * @param {number} [pageSize] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [searchTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DelinquentWorkshopsApi
     */
    public apiDelinquentWorkshopsDelinquentWorkshopsGet(pageNo?: number, pageSize?: number, startDate?: string, endDate?: string, searchTerm?: string, options?: AxiosRequestConfig) {
        return DelinquentWorkshopsApiFp(this.configuration).apiDelinquentWorkshopsDelinquentWorkshopsGet(pageNo, pageSize, startDate, endDate, searchTerm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {Array<string>} [workshopIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DelinquentWorkshopsApi
     */
    public apiDelinquentWorkshopsDelinquentWorkshopsReportGet(startDate?: string, endDate?: string, workshopIds?: Array<string>, options?: AxiosRequestConfig) {
        return DelinquentWorkshopsApiFp(this.configuration).apiDelinquentWorkshopsDelinquentWorkshopsReportGet(startDate, endDate, workshopIds, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FilesApi - axios parameter creator
 * @export
 */
export const FilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesPost: async (file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} relativePath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesRelativePathGet: async (relativePath: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'relativePath' is not null or undefined
            assertParamExists('filesRelativePathGet', 'relativePath', relativePath)
            const localVarPath = `/files/{relativePath}`
                .replace(`{${"relativePath"}}`, encodeURIComponent(String(relativePath)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} relativePath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesViewRelativePathGet: async (relativePath: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'relativePath' is not null or undefined
            assertParamExists('filesViewRelativePathGet', 'relativePath', relativePath)
            const localVarPath = `/files/view/{relativePath}`
                .replace(`{${"relativePath"}}`, encodeURIComponent(String(relativePath)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} relativePath 
         * @param {number} width 
         * @param {number} height 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesWidthHeightRelativePathGet: async (relativePath: string, width: number, height: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'relativePath' is not null or undefined
            assertParamExists('filesWidthHeightRelativePathGet', 'relativePath', relativePath)
            // verify required parameter 'width' is not null or undefined
            assertParamExists('filesWidthHeightRelativePathGet', 'width', width)
            // verify required parameter 'height' is not null or undefined
            assertParamExists('filesWidthHeightRelativePathGet', 'height', height)
            const localVarPath = `/files/{width}/{height}/{relativePath}`
                .replace(`{${"relativePath"}}`, encodeURIComponent(String(relativePath)))
                .replace(`{${"width"}}`, encodeURIComponent(String(width)))
                .replace(`{${"height"}}`, encodeURIComponent(String(height)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilesApi - functional programming interface
 * @export
 */
export const FilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesPost(file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilePath>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesPost(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} relativePath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesRelativePathGet(relativePath: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesRelativePathGet(relativePath, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} relativePath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesViewRelativePathGet(relativePath: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesViewRelativePathGet(relativePath, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} relativePath 
         * @param {number} width 
         * @param {number} height 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesWidthHeightRelativePathGet(relativePath: string, width: number, height: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesWidthHeightRelativePathGet(relativePath, width, height, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FilesApi - factory interface
 * @export
 */
export const FilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FilesApiFp(configuration)
    return {
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesPost(file?: File, options?: any): AxiosPromise<FilePath> {
            return localVarFp.filesPost(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} relativePath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesRelativePathGet(relativePath: string, options?: any): AxiosPromise<string> {
            return localVarFp.filesRelativePathGet(relativePath, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} relativePath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesViewRelativePathGet(relativePath: string, options?: any): AxiosPromise<string> {
            return localVarFp.filesViewRelativePathGet(relativePath, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} relativePath 
         * @param {number} width 
         * @param {number} height 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesWidthHeightRelativePathGet(relativePath: string, width: number, height: number, options?: any): AxiosPromise<string> {
            return localVarFp.filesWidthHeightRelativePathGet(relativePath, width, height, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FilesApi - object-oriented interface
 * @export
 * @class FilesApi
 * @extends {BaseAPI}
 */
export class FilesApi extends BaseAPI {
    /**
     * 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    public filesPost(file?: File, options?: AxiosRequestConfig) {
        return FilesApiFp(this.configuration).filesPost(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} relativePath 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    public filesRelativePathGet(relativePath: string, options?: AxiosRequestConfig) {
        return FilesApiFp(this.configuration).filesRelativePathGet(relativePath, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} relativePath 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    public filesViewRelativePathGet(relativePath: string, options?: AxiosRequestConfig) {
        return FilesApiFp(this.configuration).filesViewRelativePathGet(relativePath, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} relativePath 
     * @param {number} width 
     * @param {number} height 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    public filesWidthHeightRelativePathGet(relativePath: string, width: number, height: number, options?: AxiosRequestConfig) {
        return FilesApiFp(this.configuration).filesWidthHeightRelativePathGet(relativePath, width, height, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ImportsApi - axios parameter creator
 * @export
 */
export const ImportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportGet: async (pageNo?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['pageNo'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImportsApi - functional programming interface
 * @export
 */
export const ImportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiImportGet(pageNo?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiImportGet(pageNo, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ImportsApi - factory interface
 * @export
 */
export const ImportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImportsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportGet(pageNo?: number, pageSize?: number, options?: any): AxiosPromise<PagedResultOfImportDto> {
            return localVarFp.apiImportGet(pageNo, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImportsApi - object-oriented interface
 * @export
 * @class ImportsApi
 * @extends {BaseAPI}
 */
export class ImportsApi extends BaseAPI {
    /**
     * 
     * @param {number} [pageNo] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    public apiImportGet(pageNo?: number, pageSize?: number, options?: AxiosRequestConfig) {
        return ImportsApiFp(this.configuration).apiImportGet(pageNo, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LoyaltyPointTransactionsApi - axios parameter creator
 * @export
 */
export const LoyaltyPointTransactionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [workshopId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointTransactionsBalanceGet: async (workshopId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/loyalty-point-transactions/balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (workshopId !== undefined) {
                localVarQueryParameter['workshopId'] = workshopId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {string} [workshopId] 
         * @param {string} [createdStartDate] 
         * @param {string} [createdEndDate] 
         * @param {string} [expiryStartDate] 
         * @param {string} [expiryEndDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointTransactionsGet: async (pageNumber?: number, pageSize?: number, searchText?: string, workshopId?: string, createdStartDate?: string, createdEndDate?: string, expiryStartDate?: string, expiryEndDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/loyalty-point-transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (workshopId !== undefined) {
                localVarQueryParameter['workshopId'] = workshopId;
            }

            if (createdStartDate !== undefined) {
                localVarQueryParameter['createdStartDate'] = (createdStartDate as any instanceof Date) ?
                    (createdStartDate as any).toISOString() :
                    createdStartDate;
            }

            if (createdEndDate !== undefined) {
                localVarQueryParameter['createdEndDate'] = (createdEndDate as any instanceof Date) ?
                    (createdEndDate as any).toISOString() :
                    createdEndDate;
            }

            if (expiryStartDate !== undefined) {
                localVarQueryParameter['expiryStartDate'] = (expiryStartDate as any instanceof Date) ?
                    (expiryStartDate as any).toISOString() :
                    expiryStartDate;
            }

            if (expiryEndDate !== undefined) {
                localVarQueryParameter['expiryEndDate'] = (expiryEndDate as any instanceof Date) ?
                    (expiryEndDate as any).toISOString() :
                    expiryEndDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointTransactionsIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLoyaltyPointTransactionsIdGet', 'id', id)
            const localVarPath = `/api/loyalty-point-transactions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLoyaltyPointsTransactionTrackingNumber} [updateLoyaltyPointsTransactionTrackingNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointTransactionsIdPut: async (id: string, updateLoyaltyPointsTransactionTrackingNumber?: UpdateLoyaltyPointsTransactionTrackingNumber, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLoyaltyPointTransactionsIdPut', 'id', id)
            const localVarPath = `/api/loyalty-point-transactions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLoyaltyPointsTransactionTrackingNumber, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateLoyaltyPointsManualTransactionCommand} [createLoyaltyPointsManualTransactionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointTransactionsPost: async (createLoyaltyPointsManualTransactionCommand?: CreateLoyaltyPointsManualTransactionCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/loyalty-point-transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLoyaltyPointsManualTransactionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {string} [workshopId] 
         * @param {string} [createdStartDate] 
         * @param {string} [createdEndDate] 
         * @param {string} [expiryStartDate] 
         * @param {string} [expiryEndDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointTransactionsReportGet: async (pageNumber?: number, pageSize?: number, searchText?: string, workshopId?: string, createdStartDate?: string, createdEndDate?: string, expiryStartDate?: string, expiryEndDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/loyalty-point-transactions/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (workshopId !== undefined) {
                localVarQueryParameter['workshopId'] = workshopId;
            }

            if (createdStartDate !== undefined) {
                localVarQueryParameter['createdStartDate'] = (createdStartDate as any instanceof Date) ?
                    (createdStartDate as any).toISOString() :
                    createdStartDate;
            }

            if (createdEndDate !== undefined) {
                localVarQueryParameter['createdEndDate'] = (createdEndDate as any instanceof Date) ?
                    (createdEndDate as any).toISOString() :
                    createdEndDate;
            }

            if (expiryStartDate !== undefined) {
                localVarQueryParameter['expiryStartDate'] = (expiryStartDate as any instanceof Date) ?
                    (expiryStartDate as any).toISOString() :
                    expiryStartDate;
            }

            if (expiryEndDate !== undefined) {
                localVarQueryParameter['expiryEndDate'] = (expiryEndDate as any instanceof Date) ?
                    (expiryEndDate as any).toISOString() :
                    expiryEndDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoyaltyPointTransactionsApi - functional programming interface
 * @export
 */
export const LoyaltyPointTransactionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoyaltyPointTransactionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [workshopId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoyaltyPointTransactionsBalanceGet(workshopId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkshopBalanceViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoyaltyPointTransactionsBalanceGet(workshopId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {string} [workshopId] 
         * @param {string} [createdStartDate] 
         * @param {string} [createdEndDate] 
         * @param {string} [expiryStartDate] 
         * @param {string} [expiryEndDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoyaltyPointTransactionsGet(pageNumber?: number, pageSize?: number, searchText?: string, workshopId?: string, createdStartDate?: string, createdEndDate?: string, expiryStartDate?: string, expiryEndDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfLoyaltyPointTransactionListViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoyaltyPointTransactionsGet(pageNumber, pageSize, searchText, workshopId, createdStartDate, createdEndDate, expiryStartDate, expiryEndDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoyaltyPointTransactionsIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyPointsManualTransactionViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoyaltyPointTransactionsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLoyaltyPointsTransactionTrackingNumber} [updateLoyaltyPointsTransactionTrackingNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoyaltyPointTransactionsIdPut(id: string, updateLoyaltyPointsTransactionTrackingNumber?: UpdateLoyaltyPointsTransactionTrackingNumber, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoyaltyPointTransactionsIdPut(id, updateLoyaltyPointsTransactionTrackingNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateLoyaltyPointsManualTransactionCommand} [createLoyaltyPointsManualTransactionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoyaltyPointTransactionsPost(createLoyaltyPointsManualTransactionCommand?: CreateLoyaltyPointsManualTransactionCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonResponseOfGuid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoyaltyPointTransactionsPost(createLoyaltyPointsManualTransactionCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {string} [workshopId] 
         * @param {string} [createdStartDate] 
         * @param {string} [createdEndDate] 
         * @param {string} [expiryStartDate] 
         * @param {string} [expiryEndDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoyaltyPointTransactionsReportGet(pageNumber?: number, pageSize?: number, searchText?: string, workshopId?: string, createdStartDate?: string, createdEndDate?: string, expiryStartDate?: string, expiryEndDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfLoyaltyPointTransactionListViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoyaltyPointTransactionsReportGet(pageNumber, pageSize, searchText, workshopId, createdStartDate, createdEndDate, expiryStartDate, expiryEndDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoyaltyPointTransactionsApi - factory interface
 * @export
 */
export const LoyaltyPointTransactionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoyaltyPointTransactionsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [workshopId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointTransactionsBalanceGet(workshopId?: string, options?: any): AxiosPromise<WorkshopBalanceViewModel> {
            return localVarFp.apiLoyaltyPointTransactionsBalanceGet(workshopId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {string} [workshopId] 
         * @param {string} [createdStartDate] 
         * @param {string} [createdEndDate] 
         * @param {string} [expiryStartDate] 
         * @param {string} [expiryEndDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointTransactionsGet(pageNumber?: number, pageSize?: number, searchText?: string, workshopId?: string, createdStartDate?: string, createdEndDate?: string, expiryStartDate?: string, expiryEndDate?: string, options?: any): AxiosPromise<PagedResultOfLoyaltyPointTransactionListViewModel> {
            return localVarFp.apiLoyaltyPointTransactionsGet(pageNumber, pageSize, searchText, workshopId, createdStartDate, createdEndDate, expiryStartDate, expiryEndDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointTransactionsIdGet(id: string, options?: any): AxiosPromise<LoyaltyPointsManualTransactionViewModel> {
            return localVarFp.apiLoyaltyPointTransactionsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLoyaltyPointsTransactionTrackingNumber} [updateLoyaltyPointsTransactionTrackingNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointTransactionsIdPut(id: string, updateLoyaltyPointsTransactionTrackingNumber?: UpdateLoyaltyPointsTransactionTrackingNumber, options?: any): AxiosPromise<void> {
            return localVarFp.apiLoyaltyPointTransactionsIdPut(id, updateLoyaltyPointsTransactionTrackingNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateLoyaltyPointsManualTransactionCommand} [createLoyaltyPointsManualTransactionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointTransactionsPost(createLoyaltyPointsManualTransactionCommand?: CreateLoyaltyPointsManualTransactionCommand, options?: any): AxiosPromise<JsonResponseOfGuid> {
            return localVarFp.apiLoyaltyPointTransactionsPost(createLoyaltyPointsManualTransactionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {string} [workshopId] 
         * @param {string} [createdStartDate] 
         * @param {string} [createdEndDate] 
         * @param {string} [expiryStartDate] 
         * @param {string} [expiryEndDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointTransactionsReportGet(pageNumber?: number, pageSize?: number, searchText?: string, workshopId?: string, createdStartDate?: string, createdEndDate?: string, expiryStartDate?: string, expiryEndDate?: string, options?: any): AxiosPromise<PagedResultOfLoyaltyPointTransactionListViewModel> {
            return localVarFp.apiLoyaltyPointTransactionsReportGet(pageNumber, pageSize, searchText, workshopId, createdStartDate, createdEndDate, expiryStartDate, expiryEndDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoyaltyPointTransactionsApi - object-oriented interface
 * @export
 * @class LoyaltyPointTransactionsApi
 * @extends {BaseAPI}
 */
export class LoyaltyPointTransactionsApi extends BaseAPI {
    /**
     * 
     * @param {string} [workshopId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyPointTransactionsApi
     */
    public apiLoyaltyPointTransactionsBalanceGet(workshopId?: string, options?: AxiosRequestConfig) {
        return LoyaltyPointTransactionsApiFp(this.configuration).apiLoyaltyPointTransactionsBalanceGet(workshopId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {string} [searchText] 
     * @param {string} [workshopId] 
     * @param {string} [createdStartDate] 
     * @param {string} [createdEndDate] 
     * @param {string} [expiryStartDate] 
     * @param {string} [expiryEndDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyPointTransactionsApi
     */
    public apiLoyaltyPointTransactionsGet(pageNumber?: number, pageSize?: number, searchText?: string, workshopId?: string, createdStartDate?: string, createdEndDate?: string, expiryStartDate?: string, expiryEndDate?: string, options?: AxiosRequestConfig) {
        return LoyaltyPointTransactionsApiFp(this.configuration).apiLoyaltyPointTransactionsGet(pageNumber, pageSize, searchText, workshopId, createdStartDate, createdEndDate, expiryStartDate, expiryEndDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyPointTransactionsApi
     */
    public apiLoyaltyPointTransactionsIdGet(id: string, options?: AxiosRequestConfig) {
        return LoyaltyPointTransactionsApiFp(this.configuration).apiLoyaltyPointTransactionsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateLoyaltyPointsTransactionTrackingNumber} [updateLoyaltyPointsTransactionTrackingNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyPointTransactionsApi
     */
    public apiLoyaltyPointTransactionsIdPut(id: string, updateLoyaltyPointsTransactionTrackingNumber?: UpdateLoyaltyPointsTransactionTrackingNumber, options?: AxiosRequestConfig) {
        return LoyaltyPointTransactionsApiFp(this.configuration).apiLoyaltyPointTransactionsIdPut(id, updateLoyaltyPointsTransactionTrackingNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateLoyaltyPointsManualTransactionCommand} [createLoyaltyPointsManualTransactionCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyPointTransactionsApi
     */
    public apiLoyaltyPointTransactionsPost(createLoyaltyPointsManualTransactionCommand?: CreateLoyaltyPointsManualTransactionCommand, options?: AxiosRequestConfig) {
        return LoyaltyPointTransactionsApiFp(this.configuration).apiLoyaltyPointTransactionsPost(createLoyaltyPointsManualTransactionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {string} [searchText] 
     * @param {string} [workshopId] 
     * @param {string} [createdStartDate] 
     * @param {string} [createdEndDate] 
     * @param {string} [expiryStartDate] 
     * @param {string} [expiryEndDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyPointTransactionsApi
     */
    public apiLoyaltyPointTransactionsReportGet(pageNumber?: number, pageSize?: number, searchText?: string, workshopId?: string, createdStartDate?: string, createdEndDate?: string, expiryStartDate?: string, expiryEndDate?: string, options?: AxiosRequestConfig) {
        return LoyaltyPointTransactionsApiFp(this.configuration).apiLoyaltyPointTransactionsReportGet(pageNumber, pageSize, searchText, workshopId, createdStartDate, createdEndDate, expiryStartDate, expiryEndDate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LoyaltyPointsClaimsApi - axios parameter creator
 * @export
 */
export const LoyaltyPointsClaimsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {LoyaltyPointClaimStatus} [statusId] 
         * @param {string} [searchText] 
         * @param {string} [workshopId] 
         * @param {SortDirection} [sortDirection] 
         * @param {boolean} [isFullMatch] 
         * @param {string} [dateSubmittedStartDate] 
         * @param {string} [dateSubmittedEndDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsClaimsGet: async (pageNumber?: number, pageSize?: number, statusId?: LoyaltyPointClaimStatus, searchText?: string, workshopId?: string, sortDirection?: SortDirection, isFullMatch?: boolean, dateSubmittedStartDate?: string, dateSubmittedEndDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/loyalty-points-claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (statusId !== undefined) {
                localVarQueryParameter['statusId'] = statusId;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (workshopId !== undefined) {
                localVarQueryParameter['workshopId'] = workshopId;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (isFullMatch !== undefined) {
                localVarQueryParameter['isFullMatch'] = isFullMatch;
            }

            if (dateSubmittedStartDate !== undefined) {
                localVarQueryParameter['dateSubmittedStartDate'] = (dateSubmittedStartDate as any instanceof Date) ?
                    (dateSubmittedStartDate as any).toISOString() :
                    dateSubmittedStartDate;
            }

            if (dateSubmittedEndDate !== undefined) {
                localVarQueryParameter['dateSubmittedEndDate'] = (dateSubmittedEndDate as any instanceof Date) ?
                    (dateSubmittedEndDate as any).toISOString() :
                    dateSubmittedEndDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsClaimsIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLoyaltyPointsClaimsIdGet', 'id', id)
            const localVarPath = `/api/loyalty-points-claims/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ResubmitLoyaltyPointsClaimCommand} [resubmitLoyaltyPointsClaimCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsClaimsIdPut: async (id: string, resubmitLoyaltyPointsClaimCommand?: ResubmitLoyaltyPointsClaimCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLoyaltyPointsClaimsIdPut', 'id', id)
            const localVarPath = `/api/loyalty-points-claims/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resubmitLoyaltyPointsClaimCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubmitLoyaltyPointsClaimCommand} [submitLoyaltyPointsClaimCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsClaimsPost: async (submitLoyaltyPointsClaimCommand?: SubmitLoyaltyPointsClaimCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/loyalty-points-claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitLoyaltyPointsClaimCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoyaltyPointsClaimsApi - functional programming interface
 * @export
 */
export const LoyaltyPointsClaimsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoyaltyPointsClaimsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {LoyaltyPointClaimStatus} [statusId] 
         * @param {string} [searchText] 
         * @param {string} [workshopId] 
         * @param {SortDirection} [sortDirection] 
         * @param {boolean} [isFullMatch] 
         * @param {string} [dateSubmittedStartDate] 
         * @param {string} [dateSubmittedEndDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoyaltyPointsClaimsGet(pageNumber?: number, pageSize?: number, statusId?: LoyaltyPointClaimStatus, searchText?: string, workshopId?: string, sortDirection?: SortDirection, isFullMatch?: boolean, dateSubmittedStartDate?: string, dateSubmittedEndDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfLoyaltyPointClaimListViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoyaltyPointsClaimsGet(pageNumber, pageSize, statusId, searchText, workshopId, sortDirection, isFullMatch, dateSubmittedStartDate, dateSubmittedEndDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoyaltyPointsClaimsIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyPointClaimViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoyaltyPointsClaimsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ResubmitLoyaltyPointsClaimCommand} [resubmitLoyaltyPointsClaimCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoyaltyPointsClaimsIdPut(id: string, resubmitLoyaltyPointsClaimCommand?: ResubmitLoyaltyPointsClaimCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoyaltyPointsClaimsIdPut(id, resubmitLoyaltyPointsClaimCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SubmitLoyaltyPointsClaimCommand} [submitLoyaltyPointsClaimCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoyaltyPointsClaimsPost(submitLoyaltyPointsClaimCommand?: SubmitLoyaltyPointsClaimCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonResponseOfGuid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoyaltyPointsClaimsPost(submitLoyaltyPointsClaimCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoyaltyPointsClaimsApi - factory interface
 * @export
 */
export const LoyaltyPointsClaimsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoyaltyPointsClaimsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {LoyaltyPointClaimStatus} [statusId] 
         * @param {string} [searchText] 
         * @param {string} [workshopId] 
         * @param {SortDirection} [sortDirection] 
         * @param {boolean} [isFullMatch] 
         * @param {string} [dateSubmittedStartDate] 
         * @param {string} [dateSubmittedEndDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsClaimsGet(pageNumber?: number, pageSize?: number, statusId?: LoyaltyPointClaimStatus, searchText?: string, workshopId?: string, sortDirection?: SortDirection, isFullMatch?: boolean, dateSubmittedStartDate?: string, dateSubmittedEndDate?: string, options?: any): AxiosPromise<PagedResultOfLoyaltyPointClaimListViewModel> {
            return localVarFp.apiLoyaltyPointsClaimsGet(pageNumber, pageSize, statusId, searchText, workshopId, sortDirection, isFullMatch, dateSubmittedStartDate, dateSubmittedEndDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsClaimsIdGet(id: string, options?: any): AxiosPromise<LoyaltyPointClaimViewModel> {
            return localVarFp.apiLoyaltyPointsClaimsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ResubmitLoyaltyPointsClaimCommand} [resubmitLoyaltyPointsClaimCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsClaimsIdPut(id: string, resubmitLoyaltyPointsClaimCommand?: ResubmitLoyaltyPointsClaimCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiLoyaltyPointsClaimsIdPut(id, resubmitLoyaltyPointsClaimCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmitLoyaltyPointsClaimCommand} [submitLoyaltyPointsClaimCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsClaimsPost(submitLoyaltyPointsClaimCommand?: SubmitLoyaltyPointsClaimCommand, options?: any): AxiosPromise<JsonResponseOfGuid> {
            return localVarFp.apiLoyaltyPointsClaimsPost(submitLoyaltyPointsClaimCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoyaltyPointsClaimsApi - object-oriented interface
 * @export
 * @class LoyaltyPointsClaimsApi
 * @extends {BaseAPI}
 */
export class LoyaltyPointsClaimsApi extends BaseAPI {
    /**
     * 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {LoyaltyPointClaimStatus} [statusId] 
     * @param {string} [searchText] 
     * @param {string} [workshopId] 
     * @param {SortDirection} [sortDirection] 
     * @param {boolean} [isFullMatch] 
     * @param {string} [dateSubmittedStartDate] 
     * @param {string} [dateSubmittedEndDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyPointsClaimsApi
     */
    public apiLoyaltyPointsClaimsGet(pageNumber?: number, pageSize?: number, statusId?: LoyaltyPointClaimStatus, searchText?: string, workshopId?: string, sortDirection?: SortDirection, isFullMatch?: boolean, dateSubmittedStartDate?: string, dateSubmittedEndDate?: string, options?: AxiosRequestConfig) {
        return LoyaltyPointsClaimsApiFp(this.configuration).apiLoyaltyPointsClaimsGet(pageNumber, pageSize, statusId, searchText, workshopId, sortDirection, isFullMatch, dateSubmittedStartDate, dateSubmittedEndDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyPointsClaimsApi
     */
    public apiLoyaltyPointsClaimsIdGet(id: string, options?: AxiosRequestConfig) {
        return LoyaltyPointsClaimsApiFp(this.configuration).apiLoyaltyPointsClaimsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ResubmitLoyaltyPointsClaimCommand} [resubmitLoyaltyPointsClaimCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyPointsClaimsApi
     */
    public apiLoyaltyPointsClaimsIdPut(id: string, resubmitLoyaltyPointsClaimCommand?: ResubmitLoyaltyPointsClaimCommand, options?: AxiosRequestConfig) {
        return LoyaltyPointsClaimsApiFp(this.configuration).apiLoyaltyPointsClaimsIdPut(id, resubmitLoyaltyPointsClaimCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmitLoyaltyPointsClaimCommand} [submitLoyaltyPointsClaimCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyPointsClaimsApi
     */
    public apiLoyaltyPointsClaimsPost(submitLoyaltyPointsClaimCommand?: SubmitLoyaltyPointsClaimCommand, options?: AxiosRequestConfig) {
        return LoyaltyPointsClaimsApiFp(this.configuration).apiLoyaltyPointsClaimsPost(submitLoyaltyPointsClaimCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LoyaltyPointsClaimsAdminApi - axios parameter creator
 * @export
 */
export const LoyaltyPointsClaimsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {BulkReviewLoyaltyPointsClaimAdminCommand} [bulkReviewLoyaltyPointsClaimAdminCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsClaimsAdminBulkReviewLoyaltyPointsClaimAdminPut: async (bulkReviewLoyaltyPointsClaimAdminCommand?: BulkReviewLoyaltyPointsClaimAdminCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/loyalty-points-claims/admin/bulk-review-loyalty-points-claim-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkReviewLoyaltyPointsClaimAdminCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {LoyaltyPointClaimStatus} [statusId] 
         * @param {string} [searchText] 
         * @param {string} [workshopId] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [dateSubmittedStartDate] 
         * @param {string} [dateSubmittedEndDate] 
         * @param {boolean} [isFullMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsClaimsAdminGet: async (pageNumber?: number, pageSize?: number, statusId?: LoyaltyPointClaimStatus, searchText?: string, workshopId?: string, sortDirection?: SortDirection, dateSubmittedStartDate?: string, dateSubmittedEndDate?: string, isFullMatch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/loyalty-points-claims/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (statusId !== undefined) {
                localVarQueryParameter['statusId'] = statusId;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (workshopId !== undefined) {
                localVarQueryParameter['workshopId'] = workshopId;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (dateSubmittedStartDate !== undefined) {
                localVarQueryParameter['dateSubmittedStartDate'] = (dateSubmittedStartDate as any instanceof Date) ?
                    (dateSubmittedStartDate as any).toISOString() :
                    dateSubmittedStartDate;
            }

            if (dateSubmittedEndDate !== undefined) {
                localVarQueryParameter['dateSubmittedEndDate'] = (dateSubmittedEndDate as any instanceof Date) ?
                    (dateSubmittedEndDate as any).toISOString() :
                    dateSubmittedEndDate;
            }

            if (isFullMatch !== undefined) {
                localVarQueryParameter['isFullMatch'] = isFullMatch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ReviewLoyaltyPointsClaimAdminCommand} [reviewLoyaltyPointsClaimAdminCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsClaimsAdminIdPut: async (id: string, reviewLoyaltyPointsClaimAdminCommand?: ReviewLoyaltyPointsClaimAdminCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLoyaltyPointsClaimsAdminIdPut', 'id', id)
            const localVarPath = `/api/loyalty-points-claims/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewLoyaltyPointsClaimAdminCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubmitLoyaltyPointsClaimAdminCommand} [submitLoyaltyPointsClaimAdminCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsClaimsAdminPost: async (submitLoyaltyPointsClaimAdminCommand?: SubmitLoyaltyPointsClaimAdminCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/loyalty-points-claims/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitLoyaltyPointsClaimAdminCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoyaltyPointsClaimsAdminApi - functional programming interface
 * @export
 */
export const LoyaltyPointsClaimsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoyaltyPointsClaimsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {BulkReviewLoyaltyPointsClaimAdminCommand} [bulkReviewLoyaltyPointsClaimAdminCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoyaltyPointsClaimsAdminBulkReviewLoyaltyPointsClaimAdminPut(bulkReviewLoyaltyPointsClaimAdminCommand?: BulkReviewLoyaltyPointsClaimAdminCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoyaltyPointsClaimsAdminBulkReviewLoyaltyPointsClaimAdminPut(bulkReviewLoyaltyPointsClaimAdminCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {LoyaltyPointClaimStatus} [statusId] 
         * @param {string} [searchText] 
         * @param {string} [workshopId] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [dateSubmittedStartDate] 
         * @param {string} [dateSubmittedEndDate] 
         * @param {boolean} [isFullMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoyaltyPointsClaimsAdminGet(pageNumber?: number, pageSize?: number, statusId?: LoyaltyPointClaimStatus, searchText?: string, workshopId?: string, sortDirection?: SortDirection, dateSubmittedStartDate?: string, dateSubmittedEndDate?: string, isFullMatch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfLoyaltyPointClaimListViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoyaltyPointsClaimsAdminGet(pageNumber, pageSize, statusId, searchText, workshopId, sortDirection, dateSubmittedStartDate, dateSubmittedEndDate, isFullMatch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ReviewLoyaltyPointsClaimAdminCommand} [reviewLoyaltyPointsClaimAdminCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoyaltyPointsClaimsAdminIdPut(id: string, reviewLoyaltyPointsClaimAdminCommand?: ReviewLoyaltyPointsClaimAdminCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoyaltyPointsClaimsAdminIdPut(id, reviewLoyaltyPointsClaimAdminCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SubmitLoyaltyPointsClaimAdminCommand} [submitLoyaltyPointsClaimAdminCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoyaltyPointsClaimsAdminPost(submitLoyaltyPointsClaimAdminCommand?: SubmitLoyaltyPointsClaimAdminCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonResponseOfGuid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoyaltyPointsClaimsAdminPost(submitLoyaltyPointsClaimAdminCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoyaltyPointsClaimsAdminApi - factory interface
 * @export
 */
export const LoyaltyPointsClaimsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoyaltyPointsClaimsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {BulkReviewLoyaltyPointsClaimAdminCommand} [bulkReviewLoyaltyPointsClaimAdminCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsClaimsAdminBulkReviewLoyaltyPointsClaimAdminPut(bulkReviewLoyaltyPointsClaimAdminCommand?: BulkReviewLoyaltyPointsClaimAdminCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiLoyaltyPointsClaimsAdminBulkReviewLoyaltyPointsClaimAdminPut(bulkReviewLoyaltyPointsClaimAdminCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {LoyaltyPointClaimStatus} [statusId] 
         * @param {string} [searchText] 
         * @param {string} [workshopId] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [dateSubmittedStartDate] 
         * @param {string} [dateSubmittedEndDate] 
         * @param {boolean} [isFullMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsClaimsAdminGet(pageNumber?: number, pageSize?: number, statusId?: LoyaltyPointClaimStatus, searchText?: string, workshopId?: string, sortDirection?: SortDirection, dateSubmittedStartDate?: string, dateSubmittedEndDate?: string, isFullMatch?: boolean, options?: any): AxiosPromise<PagedResultOfLoyaltyPointClaimListViewModel> {
            return localVarFp.apiLoyaltyPointsClaimsAdminGet(pageNumber, pageSize, statusId, searchText, workshopId, sortDirection, dateSubmittedStartDate, dateSubmittedEndDate, isFullMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ReviewLoyaltyPointsClaimAdminCommand} [reviewLoyaltyPointsClaimAdminCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsClaimsAdminIdPut(id: string, reviewLoyaltyPointsClaimAdminCommand?: ReviewLoyaltyPointsClaimAdminCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiLoyaltyPointsClaimsAdminIdPut(id, reviewLoyaltyPointsClaimAdminCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmitLoyaltyPointsClaimAdminCommand} [submitLoyaltyPointsClaimAdminCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsClaimsAdminPost(submitLoyaltyPointsClaimAdminCommand?: SubmitLoyaltyPointsClaimAdminCommand, options?: any): AxiosPromise<JsonResponseOfGuid> {
            return localVarFp.apiLoyaltyPointsClaimsAdminPost(submitLoyaltyPointsClaimAdminCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoyaltyPointsClaimsAdminApi - object-oriented interface
 * @export
 * @class LoyaltyPointsClaimsAdminApi
 * @extends {BaseAPI}
 */
export class LoyaltyPointsClaimsAdminApi extends BaseAPI {
    /**
     * 
     * @param {BulkReviewLoyaltyPointsClaimAdminCommand} [bulkReviewLoyaltyPointsClaimAdminCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyPointsClaimsAdminApi
     */
    public apiLoyaltyPointsClaimsAdminBulkReviewLoyaltyPointsClaimAdminPut(bulkReviewLoyaltyPointsClaimAdminCommand?: BulkReviewLoyaltyPointsClaimAdminCommand, options?: AxiosRequestConfig) {
        return LoyaltyPointsClaimsAdminApiFp(this.configuration).apiLoyaltyPointsClaimsAdminBulkReviewLoyaltyPointsClaimAdminPut(bulkReviewLoyaltyPointsClaimAdminCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {LoyaltyPointClaimStatus} [statusId] 
     * @param {string} [searchText] 
     * @param {string} [workshopId] 
     * @param {SortDirection} [sortDirection] 
     * @param {string} [dateSubmittedStartDate] 
     * @param {string} [dateSubmittedEndDate] 
     * @param {boolean} [isFullMatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyPointsClaimsAdminApi
     */
    public apiLoyaltyPointsClaimsAdminGet(pageNumber?: number, pageSize?: number, statusId?: LoyaltyPointClaimStatus, searchText?: string, workshopId?: string, sortDirection?: SortDirection, dateSubmittedStartDate?: string, dateSubmittedEndDate?: string, isFullMatch?: boolean, options?: AxiosRequestConfig) {
        return LoyaltyPointsClaimsAdminApiFp(this.configuration).apiLoyaltyPointsClaimsAdminGet(pageNumber, pageSize, statusId, searchText, workshopId, sortDirection, dateSubmittedStartDate, dateSubmittedEndDate, isFullMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ReviewLoyaltyPointsClaimAdminCommand} [reviewLoyaltyPointsClaimAdminCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyPointsClaimsAdminApi
     */
    public apiLoyaltyPointsClaimsAdminIdPut(id: string, reviewLoyaltyPointsClaimAdminCommand?: ReviewLoyaltyPointsClaimAdminCommand, options?: AxiosRequestConfig) {
        return LoyaltyPointsClaimsAdminApiFp(this.configuration).apiLoyaltyPointsClaimsAdminIdPut(id, reviewLoyaltyPointsClaimAdminCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmitLoyaltyPointsClaimAdminCommand} [submitLoyaltyPointsClaimAdminCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyPointsClaimsAdminApi
     */
    public apiLoyaltyPointsClaimsAdminPost(submitLoyaltyPointsClaimAdminCommand?: SubmitLoyaltyPointsClaimAdminCommand, options?: AxiosRequestConfig) {
        return LoyaltyPointsClaimsAdminApiFp(this.configuration).apiLoyaltyPointsClaimsAdminPost(submitLoyaltyPointsClaimAdminCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LoyaltyPointsTranactionReturnsApi - axios parameter creator
 * @export
 */
export const LoyaltyPointsTranactionReturnsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SubmitLoyaltyPointsReturnCommand} [submitLoyaltyPointsReturnCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsReturnPost: async (submitLoyaltyPointsReturnCommand?: SubmitLoyaltyPointsReturnCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/loyalty-points-return`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitLoyaltyPointsReturnCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoyaltyPointsTranactionReturnsApi - functional programming interface
 * @export
 */
export const LoyaltyPointsTranactionReturnsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoyaltyPointsTranactionReturnsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SubmitLoyaltyPointsReturnCommand} [submitLoyaltyPointsReturnCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoyaltyPointsReturnPost(submitLoyaltyPointsReturnCommand?: SubmitLoyaltyPointsReturnCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonResponseOfGuid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoyaltyPointsReturnPost(submitLoyaltyPointsReturnCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoyaltyPointsTranactionReturnsApi - factory interface
 * @export
 */
export const LoyaltyPointsTranactionReturnsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoyaltyPointsTranactionReturnsApiFp(configuration)
    return {
        /**
         * 
         * @param {SubmitLoyaltyPointsReturnCommand} [submitLoyaltyPointsReturnCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsReturnPost(submitLoyaltyPointsReturnCommand?: SubmitLoyaltyPointsReturnCommand, options?: any): AxiosPromise<JsonResponseOfGuid> {
            return localVarFp.apiLoyaltyPointsReturnPost(submitLoyaltyPointsReturnCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoyaltyPointsTranactionReturnsApi - object-oriented interface
 * @export
 * @class LoyaltyPointsTranactionReturnsApi
 * @extends {BaseAPI}
 */
export class LoyaltyPointsTranactionReturnsApi extends BaseAPI {
    /**
     * 
     * @param {SubmitLoyaltyPointsReturnCommand} [submitLoyaltyPointsReturnCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyPointsTranactionReturnsApi
     */
    public apiLoyaltyPointsReturnPost(submitLoyaltyPointsReturnCommand?: SubmitLoyaltyPointsReturnCommand, options?: AxiosRequestConfig) {
        return LoyaltyPointsTranactionReturnsApiFp(this.configuration).apiLoyaltyPointsReturnPost(submitLoyaltyPointsReturnCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LoyaltyPointsTranactionReturnsAdminApi - axios parameter creator
 * @export
 */
export const LoyaltyPointsTranactionReturnsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [workshopId] 
         * @param {string} [searchText] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsReturnsAdminGet: async (pageNumber?: number, pageSize?: number, workshopId?: string, searchText?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/loyalty-points-returns/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (workshopId !== undefined) {
                localVarQueryParameter['workshopId'] = workshopId;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsReturnsAdminIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLoyaltyPointsReturnsAdminIdGet', 'id', id)
            const localVarPath = `/api/loyalty-points-returns/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLoyaltyPointsTranactionReturnCommand} [updateLoyaltyPointsTranactionReturnCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsReturnsAdminIdPut: async (id: string, updateLoyaltyPointsTranactionReturnCommand?: UpdateLoyaltyPointsTranactionReturnCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLoyaltyPointsReturnsAdminIdPut', 'id', id)
            const localVarPath = `/api/loyalty-points-returns/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLoyaltyPointsTranactionReturnCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoyaltyPointsTranactionReturnsAdminApi - functional programming interface
 * @export
 */
export const LoyaltyPointsTranactionReturnsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoyaltyPointsTranactionReturnsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [workshopId] 
         * @param {string} [searchText] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoyaltyPointsReturnsAdminGet(pageNumber?: number, pageSize?: number, workshopId?: string, searchText?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfLoyaltyPointsTranactionReturnDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoyaltyPointsReturnsAdminGet(pageNumber, pageSize, workshopId, searchText, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoyaltyPointsReturnsAdminIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoyaltyPointsTranactionReturnDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoyaltyPointsReturnsAdminIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLoyaltyPointsTranactionReturnCommand} [updateLoyaltyPointsTranactionReturnCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoyaltyPointsReturnsAdminIdPut(id: string, updateLoyaltyPointsTranactionReturnCommand?: UpdateLoyaltyPointsTranactionReturnCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoyaltyPointsReturnsAdminIdPut(id, updateLoyaltyPointsTranactionReturnCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoyaltyPointsTranactionReturnsAdminApi - factory interface
 * @export
 */
export const LoyaltyPointsTranactionReturnsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoyaltyPointsTranactionReturnsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [workshopId] 
         * @param {string} [searchText] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsReturnsAdminGet(pageNumber?: number, pageSize?: number, workshopId?: string, searchText?: string, options?: any): AxiosPromise<PagedResultOfLoyaltyPointsTranactionReturnDto> {
            return localVarFp.apiLoyaltyPointsReturnsAdminGet(pageNumber, pageSize, workshopId, searchText, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsReturnsAdminIdGet(id: string, options?: any): AxiosPromise<LoyaltyPointsTranactionReturnDto> {
            return localVarFp.apiLoyaltyPointsReturnsAdminIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLoyaltyPointsTranactionReturnCommand} [updateLoyaltyPointsTranactionReturnCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoyaltyPointsReturnsAdminIdPut(id: string, updateLoyaltyPointsTranactionReturnCommand?: UpdateLoyaltyPointsTranactionReturnCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiLoyaltyPointsReturnsAdminIdPut(id, updateLoyaltyPointsTranactionReturnCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoyaltyPointsTranactionReturnsAdminApi - object-oriented interface
 * @export
 * @class LoyaltyPointsTranactionReturnsAdminApi
 * @extends {BaseAPI}
 */
export class LoyaltyPointsTranactionReturnsAdminApi extends BaseAPI {
    /**
     * 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {string} [workshopId] 
     * @param {string} [searchText] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyPointsTranactionReturnsAdminApi
     */
    public apiLoyaltyPointsReturnsAdminGet(pageNumber?: number, pageSize?: number, workshopId?: string, searchText?: string, options?: AxiosRequestConfig) {
        return LoyaltyPointsTranactionReturnsAdminApiFp(this.configuration).apiLoyaltyPointsReturnsAdminGet(pageNumber, pageSize, workshopId, searchText, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyPointsTranactionReturnsAdminApi
     */
    public apiLoyaltyPointsReturnsAdminIdGet(id: string, options?: AxiosRequestConfig) {
        return LoyaltyPointsTranactionReturnsAdminApiFp(this.configuration).apiLoyaltyPointsReturnsAdminIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateLoyaltyPointsTranactionReturnCommand} [updateLoyaltyPointsTranactionReturnCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyPointsTranactionReturnsAdminApi
     */
    public apiLoyaltyPointsReturnsAdminIdPut(id: string, updateLoyaltyPointsTranactionReturnCommand?: UpdateLoyaltyPointsTranactionReturnCommand, options?: AxiosRequestConfig) {
        return LoyaltyPointsTranactionReturnsAdminApiFp(this.configuration).apiLoyaltyPointsReturnsAdminIdPut(id, updateLoyaltyPointsTranactionReturnCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {string} [sku] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsGet: async (pageNumber?: number, pageSize?: number, searchText?: string, sku?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (sku !== undefined) {
                localVarQueryParameter['sku'] = sku;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductsIdDelete', 'id', id)
            const localVarPath = `/api/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductsIdGet', 'id', id)
            const localVarPath = `/api/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProductCommand} [updateProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsIdPut: async (id: string, updateProductCommand?: UpdateProductCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductsIdPut', 'id', id)
            const localVarPath = `/api/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkImportProductsCommand} [bulkImportProductsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsImportPost: async (bulkImportProductsCommand?: BulkImportProductsCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/products/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkImportProductsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateProductCommand} [createProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsPost: async (createProductCommand?: CreateProductCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkImportProductsSkuAliasesCommand} [bulkImportProductsSkuAliasesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsSkuAliasesImportPost: async (bulkImportProductsSkuAliasesCommand?: BulkImportProductsSkuAliasesCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/products/skuAliases/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkImportProductsSkuAliasesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsValueGet: async (id?: string, date?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/products/value`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {string} [sku] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductsGet(pageNumber?: number, pageSize?: number, searchText?: string, sku?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfProductListViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductsGet(pageNumber, pageSize, searchText, sku, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductsIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductsIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProductCommand} [updateProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductsIdPut(id: string, updateProductCommand?: UpdateProductCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductsIdPut(id, updateProductCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkImportProductsCommand} [bulkImportProductsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductsImportPost(bulkImportProductsCommand?: BulkImportProductsCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonResponseOfListOfString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductsImportPost(bulkImportProductsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateProductCommand} [createProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductsPost(createProductCommand?: CreateProductCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonResponseOfGuid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductsPost(createProductCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkImportProductsSkuAliasesCommand} [bulkImportProductsSkuAliasesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductsSkuAliasesImportPost(bulkImportProductsSkuAliasesCommand?: BulkImportProductsSkuAliasesCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonResponseOfListOfString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductsSkuAliasesImportPost(bulkImportProductsSkuAliasesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductsValueGet(id?: string, date?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductsValueGet(id, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {string} [sku] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsGet(pageNumber?: number, pageSize?: number, searchText?: string, sku?: string, options?: any): AxiosPromise<PagedResultOfProductListViewModel> {
            return localVarFp.apiProductsGet(pageNumber, pageSize, searchText, sku, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiProductsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsIdGet(id: string, options?: any): AxiosPromise<ProductViewModel> {
            return localVarFp.apiProductsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProductCommand} [updateProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsIdPut(id: string, updateProductCommand?: UpdateProductCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiProductsIdPut(id, updateProductCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkImportProductsCommand} [bulkImportProductsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsImportPost(bulkImportProductsCommand?: BulkImportProductsCommand, options?: any): AxiosPromise<JsonResponseOfListOfString> {
            return localVarFp.apiProductsImportPost(bulkImportProductsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateProductCommand} [createProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsPost(createProductCommand?: CreateProductCommand, options?: any): AxiosPromise<JsonResponseOfGuid> {
            return localVarFp.apiProductsPost(createProductCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkImportProductsSkuAliasesCommand} [bulkImportProductsSkuAliasesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsSkuAliasesImportPost(bulkImportProductsSkuAliasesCommand?: BulkImportProductsSkuAliasesCommand, options?: any): AxiosPromise<JsonResponseOfListOfString> {
            return localVarFp.apiProductsSkuAliasesImportPost(bulkImportProductsSkuAliasesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsValueGet(id?: string, date?: string, options?: any): AxiosPromise<number> {
            return localVarFp.apiProductsValueGet(id, date, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {string} [searchText] 
     * @param {string} [sku] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiProductsGet(pageNumber?: number, pageSize?: number, searchText?: string, sku?: string, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).apiProductsGet(pageNumber, pageSize, searchText, sku, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiProductsIdDelete(id: string, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).apiProductsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiProductsIdGet(id: string, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).apiProductsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateProductCommand} [updateProductCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiProductsIdPut(id: string, updateProductCommand?: UpdateProductCommand, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).apiProductsIdPut(id, updateProductCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkImportProductsCommand} [bulkImportProductsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiProductsImportPost(bulkImportProductsCommand?: BulkImportProductsCommand, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).apiProductsImportPost(bulkImportProductsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateProductCommand} [createProductCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiProductsPost(createProductCommand?: CreateProductCommand, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).apiProductsPost(createProductCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkImportProductsSkuAliasesCommand} [bulkImportProductsSkuAliasesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiProductsSkuAliasesImportPost(bulkImportProductsSkuAliasesCommand?: BulkImportProductsSkuAliasesCommand, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).apiProductsSkuAliasesImportPost(bulkImportProductsSkuAliasesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiProductsValueGet(id?: string, date?: string, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).apiProductsValueGet(id, date, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PublicHolidaysApi - axios parameter creator
 * @export
 */
export const PublicHolidaysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPublicHolidaysGet: async (startDate?: string, endDate?: string, pageNo?: number, pageSize?: number, orderBy?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/public-holidays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substr(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substr(0,10) :
                    endDate;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['pageNo'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPublicHolidaysIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiPublicHolidaysIdDelete', 'id', id)
            const localVarPath = `/api/public-holidays/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPublicHolidaysIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiPublicHolidaysIdGet', 'id', id)
            const localVarPath = `/api/public-holidays/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdatePublicHolidayCommand} [updatePublicHolidayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPublicHolidaysIdPut: async (id: string, updatePublicHolidayCommand?: UpdatePublicHolidayCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiPublicHolidaysIdPut', 'id', id)
            const localVarPath = `/api/public-holidays/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePublicHolidayCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePublicHolidayCommand} [createPublicHolidayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPublicHolidaysPost: async (createPublicHolidayCommand?: CreatePublicHolidayCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/public-holidays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPublicHolidayCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicHolidaysApi - functional programming interface
 * @export
 */
export const PublicHolidaysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicHolidaysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPublicHolidaysGet(startDate?: string, endDate?: string, pageNo?: number, pageSize?: number, orderBy?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfPublicHolidayViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPublicHolidaysGet(startDate, endDate, pageNo, pageSize, orderBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPublicHolidaysIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPublicHolidaysIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPublicHolidaysIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicHolidayViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPublicHolidaysIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdatePublicHolidayCommand} [updatePublicHolidayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPublicHolidaysIdPut(id: string, updatePublicHolidayCommand?: UpdatePublicHolidayCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPublicHolidaysIdPut(id, updatePublicHolidayCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreatePublicHolidayCommand} [createPublicHolidayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPublicHolidaysPost(createPublicHolidayCommand?: CreatePublicHolidayCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPublicHolidaysPost(createPublicHolidayCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicHolidaysApi - factory interface
 * @export
 */
export const PublicHolidaysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicHolidaysApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPublicHolidaysGet(startDate?: string, endDate?: string, pageNo?: number, pageSize?: number, orderBy?: string, options?: any): AxiosPromise<PagedResultOfPublicHolidayViewModel> {
            return localVarFp.apiPublicHolidaysGet(startDate, endDate, pageNo, pageSize, orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPublicHolidaysIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiPublicHolidaysIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPublicHolidaysIdGet(id: string, options?: any): AxiosPromise<PublicHolidayViewModel> {
            return localVarFp.apiPublicHolidaysIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdatePublicHolidayCommand} [updatePublicHolidayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPublicHolidaysIdPut(id: string, updatePublicHolidayCommand?: UpdatePublicHolidayCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiPublicHolidaysIdPut(id, updatePublicHolidayCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePublicHolidayCommand} [createPublicHolidayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPublicHolidaysPost(createPublicHolidayCommand?: CreatePublicHolidayCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiPublicHolidaysPost(createPublicHolidayCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicHolidaysApi - object-oriented interface
 * @export
 * @class PublicHolidaysApi
 * @extends {BaseAPI}
 */
export class PublicHolidaysApi extends BaseAPI {
    /**
     * 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {number} [pageNo] 
     * @param {number} [pageSize] 
     * @param {string} [orderBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidaysApi
     */
    public apiPublicHolidaysGet(startDate?: string, endDate?: string, pageNo?: number, pageSize?: number, orderBy?: string, options?: AxiosRequestConfig) {
        return PublicHolidaysApiFp(this.configuration).apiPublicHolidaysGet(startDate, endDate, pageNo, pageSize, orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidaysApi
     */
    public apiPublicHolidaysIdDelete(id: string, options?: AxiosRequestConfig) {
        return PublicHolidaysApiFp(this.configuration).apiPublicHolidaysIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidaysApi
     */
    public apiPublicHolidaysIdGet(id: string, options?: AxiosRequestConfig) {
        return PublicHolidaysApiFp(this.configuration).apiPublicHolidaysIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdatePublicHolidayCommand} [updatePublicHolidayCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidaysApi
     */
    public apiPublicHolidaysIdPut(id: string, updatePublicHolidayCommand?: UpdatePublicHolidayCommand, options?: AxiosRequestConfig) {
        return PublicHolidaysApiFp(this.configuration).apiPublicHolidaysIdPut(id, updatePublicHolidayCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePublicHolidayCommand} [createPublicHolidayCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidaysApi
     */
    public apiPublicHolidaysPost(createPublicHolidayCommand?: CreatePublicHolidayCommand, options?: AxiosRequestConfig) {
        return PublicHolidaysApiFp(this.configuration).apiPublicHolidaysPost(createPublicHolidayCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * QuoteOfferedServicesApi - axios parameter creator
 * @export
 */
export const QuoteOfferedServicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuoteOfferedServiceTypesGet: async (pageNo?: number, pageSize?: number, orderBy?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quote-offered-service-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['pageNo'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuoteOfferedServicesGet: async (pageNo?: number, pageSize?: number, orderBy?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quote-offered-services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['pageNo'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuoteOfferedServicesIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuoteOfferedServicesIdDelete', 'id', id)
            const localVarPath = `/api/quote-offered-services/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuoteOfferedServicesIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuoteOfferedServicesIdGet', 'id', id)
            const localVarPath = `/api/quote-offered-services/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateQuoteOfferedServiceCommand} [updateQuoteOfferedServiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuoteOfferedServicesIdPut: async (id: string, updateQuoteOfferedServiceCommand?: UpdateQuoteOfferedServiceCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuoteOfferedServicesIdPut', 'id', id)
            const localVarPath = `/api/quote-offered-services/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuoteOfferedServiceCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateQuoteOfferedServiceCommand} [createQuoteOfferedServiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuoteOfferedServicesPost: async (createQuoteOfferedServiceCommand?: CreateQuoteOfferedServiceCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quote-offered-services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuoteOfferedServiceCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuoteOfferedServicesApi - functional programming interface
 * @export
 */
export const QuoteOfferedServicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuoteOfferedServicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuoteOfferedServiceTypesGet(pageNo?: number, pageSize?: number, orderBy?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfQuoteOfferedServiceTypeViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuoteOfferedServiceTypesGet(pageNo, pageSize, orderBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuoteOfferedServicesGet(pageNo?: number, pageSize?: number, orderBy?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfQuoteOfferedServiceViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuoteOfferedServicesGet(pageNo, pageSize, orderBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuoteOfferedServicesIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuoteOfferedServicesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuoteOfferedServicesIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuoteOfferedServiceViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuoteOfferedServicesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateQuoteOfferedServiceCommand} [updateQuoteOfferedServiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuoteOfferedServicesIdPut(id: string, updateQuoteOfferedServiceCommand?: UpdateQuoteOfferedServiceCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuoteOfferedServicesIdPut(id, updateQuoteOfferedServiceCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateQuoteOfferedServiceCommand} [createQuoteOfferedServiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuoteOfferedServicesPost(createQuoteOfferedServiceCommand?: CreateQuoteOfferedServiceCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuoteOfferedServicesPost(createQuoteOfferedServiceCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QuoteOfferedServicesApi - factory interface
 * @export
 */
export const QuoteOfferedServicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuoteOfferedServicesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuoteOfferedServiceTypesGet(pageNo?: number, pageSize?: number, orderBy?: string, options?: any): AxiosPromise<PagedResultOfQuoteOfferedServiceTypeViewModel> {
            return localVarFp.apiQuoteOfferedServiceTypesGet(pageNo, pageSize, orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuoteOfferedServicesGet(pageNo?: number, pageSize?: number, orderBy?: string, options?: any): AxiosPromise<PagedResultOfQuoteOfferedServiceViewModel> {
            return localVarFp.apiQuoteOfferedServicesGet(pageNo, pageSize, orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuoteOfferedServicesIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiQuoteOfferedServicesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuoteOfferedServicesIdGet(id: string, options?: any): AxiosPromise<QuoteOfferedServiceViewModel> {
            return localVarFp.apiQuoteOfferedServicesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateQuoteOfferedServiceCommand} [updateQuoteOfferedServiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuoteOfferedServicesIdPut(id: string, updateQuoteOfferedServiceCommand?: UpdateQuoteOfferedServiceCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiQuoteOfferedServicesIdPut(id, updateQuoteOfferedServiceCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateQuoteOfferedServiceCommand} [createQuoteOfferedServiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuoteOfferedServicesPost(createQuoteOfferedServiceCommand?: CreateQuoteOfferedServiceCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiQuoteOfferedServicesPost(createQuoteOfferedServiceCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuoteOfferedServicesApi - object-oriented interface
 * @export
 * @class QuoteOfferedServicesApi
 * @extends {BaseAPI}
 */
export class QuoteOfferedServicesApi extends BaseAPI {
    /**
     * 
     * @param {number} [pageNo] 
     * @param {number} [pageSize] 
     * @param {string} [orderBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteOfferedServicesApi
     */
    public apiQuoteOfferedServiceTypesGet(pageNo?: number, pageSize?: number, orderBy?: string, options?: AxiosRequestConfig) {
        return QuoteOfferedServicesApiFp(this.configuration).apiQuoteOfferedServiceTypesGet(pageNo, pageSize, orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageNo] 
     * @param {number} [pageSize] 
     * @param {string} [orderBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteOfferedServicesApi
     */
    public apiQuoteOfferedServicesGet(pageNo?: number, pageSize?: number, orderBy?: string, options?: AxiosRequestConfig) {
        return QuoteOfferedServicesApiFp(this.configuration).apiQuoteOfferedServicesGet(pageNo, pageSize, orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteOfferedServicesApi
     */
    public apiQuoteOfferedServicesIdDelete(id: string, options?: AxiosRequestConfig) {
        return QuoteOfferedServicesApiFp(this.configuration).apiQuoteOfferedServicesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteOfferedServicesApi
     */
    public apiQuoteOfferedServicesIdGet(id: string, options?: AxiosRequestConfig) {
        return QuoteOfferedServicesApiFp(this.configuration).apiQuoteOfferedServicesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateQuoteOfferedServiceCommand} [updateQuoteOfferedServiceCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteOfferedServicesApi
     */
    public apiQuoteOfferedServicesIdPut(id: string, updateQuoteOfferedServiceCommand?: UpdateQuoteOfferedServiceCommand, options?: AxiosRequestConfig) {
        return QuoteOfferedServicesApiFp(this.configuration).apiQuoteOfferedServicesIdPut(id, updateQuoteOfferedServiceCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateQuoteOfferedServiceCommand} [createQuoteOfferedServiceCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteOfferedServicesApi
     */
    public apiQuoteOfferedServicesPost(createQuoteOfferedServiceCommand?: CreateQuoteOfferedServiceCommand, options?: AxiosRequestConfig) {
        return QuoteOfferedServicesApiFp(this.configuration).apiQuoteOfferedServicesPost(createQuoteOfferedServiceCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * QuotesApi - axios parameter creator
 * @export
 */
export const QuotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchTerm] 
         * @param {QuoteRequestStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesAdminOpenRequestsGet: async (pageNo?: number, pageSize?: number, startDate?: string, endDate?: string, searchTerm?: string, status?: QuoteRequestStatusEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/admin-open-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['pageNo'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateBookingCommand} [createBookingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesBookingPost: async (createBookingCommand?: CreateBookingCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/booking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBookingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CancelBookingPublicCommand} [cancelBookingPublicCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesCancelBookingPublicPut: async (cancelBookingPublicCommand?: CancelBookingPublicCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/cancel-booking-public`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelBookingPublicCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CancelBookingCommand} [cancelBookingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesCancelBookingPut: async (cancelBookingCommand?: CancelBookingCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/cancel-booking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelBookingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteBookingBulkCommand} [completeBookingBulkCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesCompleteBookingBulkPut: async (completeBookingBulkCommand?: CompleteBookingBulkCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/complete-booking-bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeBookingBulkCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteBookingCommand} [completeBookingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesCompleteBookingPut: async (completeBookingCommand?: CompleteBookingCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/complete-booking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeBookingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {string} [workshopId] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesCustomersGet: async (pageNo?: number, pageSize?: number, orderBy?: string, workshopId?: string, searchTerm?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['pageNo'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (workshopId !== undefined) {
                localVarQueryParameter['workshopId'] = workshopId;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {string} [workshopId] 
         * @param {boolean} [responseSent] 
         * @param {boolean} [customerHasBooked] 
         * @param {string} [bookingStartDate] 
         * @param {string} [bookingEndDate] 
         * @param {string} [searchTerm] 
         * @param {boolean} [bookingRescheduleInProgress] 
         * @param {string} [customerFirstName] 
         * @param {string} [customerLastName] 
         * @param {string} [customerEmail] 
         * @param {string} [customerPhoneNumber]
         * @param {boolean} [responseUnsuccessfulOrExpired]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesGet: async (pageNo?: number, pageSize?: number, orderBy?: string, workshopId?: string, responseSent?: boolean, customerHasBooked?: boolean, bookingStartDate?: string, bookingEndDate?: string, searchTerm?: string, bookingRescheduleInProgress?: boolean, customerFirstName?: string, customerLastName?: string, customerEmail?: string, customerPhoneNumber?: string, responseUnsuccessfulOrExpired?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['pageNo'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (workshopId !== undefined) {
                localVarQueryParameter['workshopId'] = workshopId;
            }

            if (responseSent !== undefined) {
                localVarQueryParameter['responseSent'] = responseSent;
            }

            if (customerHasBooked !== undefined) {
                localVarQueryParameter['customerHasBooked'] = customerHasBooked;
            }

            if (bookingStartDate !== undefined) {
                localVarQueryParameter['bookingStartDate'] = (bookingStartDate as any instanceof Date) ?
                    (bookingStartDate as any).toISOString() :
                    bookingStartDate;
            }

            if (bookingEndDate !== undefined) {
                localVarQueryParameter['bookingEndDate'] = (bookingEndDate as any instanceof Date) ?
                    (bookingEndDate as any).toISOString() :
                    bookingEndDate;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (bookingRescheduleInProgress !== undefined) {
                localVarQueryParameter['bookingRescheduleInProgress'] = bookingRescheduleInProgress;
            }

            if (customerFirstName !== undefined) {
                localVarQueryParameter['customerFirstName'] = customerFirstName;
            }

            if (customerLastName !== undefined) {
                localVarQueryParameter['customerLastName'] = customerLastName;
            }

            if (customerEmail !== undefined) {
                localVarQueryParameter['customerEmail'] = customerEmail;
            }

            if (customerPhoneNumber !== undefined) {
                localVarQueryParameter['customerPhoneNumber'] = customerPhoneNumber;
            }

            if (responseUnsuccessfulOrExpired !== undefined) {
                localVarQueryParameter['responseUnsuccessfulOrExpired'] = responseUnsuccessfulOrExpired;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [referenceNumber]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesGetGet: async (referenceNumber?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (referenceNumber !== undefined) {
                localVarQueryParameter['referenceNumber'] = referenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesGetPublicGet: async (id?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/get-public`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesIdDeclinePut: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuotesIdDeclinePut', 'id', id)
            const localVarPath = `/api/quotes/{id}/decline`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuotesIdGet', 'id', id)
            const localVarPath = `/api/quotes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SubmitQuoteResponse} [submitQuoteResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesIdSubmitPut: async (id: string, submitQuoteResponse?: SubmitQuoteResponse, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuotesIdSubmitPut', 'id', id)
            const localVarPath = `/api/quotes/{id}/submit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitQuoteResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RescheduleBookingPublicCommand} [rescheduleBookingPublicCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesRescheduleBookingPublicPut: async (rescheduleBookingPublicCommand?: RescheduleBookingPublicCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/reschedule-booking-public`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rescheduleBookingPublicCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RescheduleBookingCommand} [rescheduleBookingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesRescheduleBookingPut: async (rescheduleBookingCommand?: RescheduleBookingCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/reschedule-booking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rescheduleBookingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReselectQuoteCommand} [reselectQuoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesReselectPut: async (reselectQuoteCommand?: ReselectQuoteCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/reselect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reselectQuoteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RestartQuoteRequestCommand} [restartQuoteRequestCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesRestartPut: async (restartQuoteRequestCommand?: RestartQuoteRequestCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/restart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(restartQuoteRequestCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesSettingsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateQuoteSettingsCommand} [updateQuoteSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesSettingsPut: async (updateQuoteSettingsCommand?: UpdateQuoteSettingsCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuoteSettingsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [workshopId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesStatisticsGet: async (workshopId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (workshopId !== undefined) {
                localVarQueryParameter['workshopId'] = workshopId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubmitAdhocQuoteRequest} [submitAdhocQuoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesSubmitAdhocPost: async (submitAdhocQuoteRequest?: SubmitAdhocQuoteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/submit-adhoc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitAdhocQuoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubmitQuoteRequest} [submitQuoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesSubmitPost: async (submitQuoteRequest?: SubmitQuoteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitQuoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesVatGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quotes/vat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuotesApi - functional programming interface
 * @export
 */
export const QuotesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuotesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchTerm] 
         * @param {QuoteRequestStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesAdminOpenRequestsGet(pageNo?: number, pageSize?: number, startDate?: string, endDate?: string, searchTerm?: string, status?: QuoteRequestStatusEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfQuoteRequestListViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesAdminOpenRequestsGet(pageNo, pageSize, startDate, endDate, searchTerm, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateBookingCommand} [createBookingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesBookingPost(createBookingCommand?: CreateBookingCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesBookingPost(createBookingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CancelBookingPublicCommand} [cancelBookingPublicCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesCancelBookingPublicPut(cancelBookingPublicCommand?: CancelBookingPublicCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesCancelBookingPublicPut(cancelBookingPublicCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CancelBookingCommand} [cancelBookingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesCancelBookingPut(cancelBookingCommand?: CancelBookingCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesCancelBookingPut(cancelBookingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteBookingBulkCommand} [completeBookingBulkCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesCompleteBookingBulkPut(completeBookingBulkCommand?: CompleteBookingBulkCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesCompleteBookingBulkPut(completeBookingBulkCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteBookingCommand} [completeBookingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesCompleteBookingPut(completeBookingCommand?: CompleteBookingCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesCompleteBookingPut(completeBookingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {string} [workshopId] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesCustomersGet(pageNo?: number, pageSize?: number, orderBy?: string, workshopId?: string, searchTerm?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfCustomerListViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesCustomersGet(pageNo, pageSize, orderBy, workshopId, searchTerm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {string} [workshopId] 
         * @param {boolean} [responseSent] 
         * @param {boolean} [customerHasBooked] 
         * @param {string} [bookingStartDate] 
         * @param {string} [bookingEndDate] 
         * @param {string} [searchTerm] 
         * @param {boolean} [bookingRescheduleInProgress] 
         * @param {string} [customerFirstName] 
         * @param {string} [customerLastName] 
         * @param {string} [customerEmail] 
         * @param {string} [customerPhoneNumber]
         * @param {boolean} [responseUnsuccessfulOrExpired]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesGet(pageNo?: number, pageSize?: number, orderBy?: string, workshopId?: string, responseSent?: boolean, customerHasBooked?: boolean, bookingStartDate?: string, bookingEndDate?: string, searchTerm?: string, bookingRescheduleInProgress?: boolean, customerFirstName?: string, customerLastName?: string, customerEmail?: string, customerPhoneNumber?: string, responseUnsuccessfulOrExpired?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfQuoteResponseWorkshopViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesGet(pageNo, pageSize, orderBy, workshopId, responseSent, customerHasBooked, bookingStartDate, bookingEndDate, searchTerm, bookingRescheduleInProgress, customerFirstName, customerLastName, customerEmail, customerPhoneNumber, responseUnsuccessfulOrExpired, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesGetGet(referenceNumber?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuoteRequestAdminViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesGetGet(referenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesGetPublicGet(id?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuoteRequestPublicViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesGetPublicGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesIdDeclinePut(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesIdDeclinePut(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuoteResponseWorkshopViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {SubmitQuoteResponse} [submitQuoteResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesIdSubmitPut(id: string, submitQuoteResponse?: SubmitQuoteResponse, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmitQuoteResponseResultModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesIdSubmitPut(id, submitQuoteResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RescheduleBookingPublicCommand} [rescheduleBookingPublicCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesRescheduleBookingPublicPut(rescheduleBookingPublicCommand?: RescheduleBookingPublicCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesRescheduleBookingPublicPut(rescheduleBookingPublicCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RescheduleBookingCommand} [rescheduleBookingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesRescheduleBookingPut(rescheduleBookingCommand?: RescheduleBookingCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesRescheduleBookingPut(rescheduleBookingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReselectQuoteCommand} [reselectQuoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesReselectPut(reselectQuoteCommand?: ReselectQuoteCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesReselectPut(reselectQuoteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RestartQuoteRequestCommand} [restartQuoteRequestCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesRestartPut(restartQuoteRequestCommand?: RestartQuoteRequestCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuoteRequestPublicViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesRestartPut(restartQuoteRequestCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesSettingsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuoteSettingsViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesSettingsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateQuoteSettingsCommand} [updateQuoteSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesSettingsPut(updateQuoteSettingsCommand?: UpdateQuoteSettingsCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesSettingsPut(updateQuoteSettingsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [workshopId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesStatisticsGet(workshopId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkshopQuoteStatisticsViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesStatisticsGet(workshopId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SubmitAdhocQuoteRequest} [submitAdhocQuoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesSubmitAdhocPost(submitAdhocQuoteRequest?: SubmitAdhocQuoteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesSubmitAdhocPost(submitAdhocQuoteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SubmitQuoteRequest} [submitQuoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesSubmitPost(submitQuoteRequest?: SubmitQuoteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuoteRequestPublicViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesSubmitPost(submitQuoteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuotesVatGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonResponseOfDecimal>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotesVatGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QuotesApi - factory interface
 * @export
 */
export const QuotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuotesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchTerm] 
         * @param {QuoteRequestStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesAdminOpenRequestsGet(pageNo?: number, pageSize?: number, startDate?: string, endDate?: string, searchTerm?: string, status?: QuoteRequestStatusEnum, options?: any): AxiosPromise<PagedResultOfQuoteRequestListViewModel> {
            return localVarFp.apiQuotesAdminOpenRequestsGet(pageNo, pageSize, startDate, endDate, searchTerm, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateBookingCommand} [createBookingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesBookingPost(createBookingCommand?: CreateBookingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiQuotesBookingPost(createBookingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CancelBookingPublicCommand} [cancelBookingPublicCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesCancelBookingPublicPut(cancelBookingPublicCommand?: CancelBookingPublicCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiQuotesCancelBookingPublicPut(cancelBookingPublicCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CancelBookingCommand} [cancelBookingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesCancelBookingPut(cancelBookingCommand?: CancelBookingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiQuotesCancelBookingPut(cancelBookingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteBookingBulkCommand} [completeBookingBulkCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesCompleteBookingBulkPut(completeBookingBulkCommand?: CompleteBookingBulkCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiQuotesCompleteBookingBulkPut(completeBookingBulkCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteBookingCommand} [completeBookingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesCompleteBookingPut(completeBookingCommand?: CompleteBookingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiQuotesCompleteBookingPut(completeBookingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {string} [workshopId] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesCustomersGet(pageNo?: number, pageSize?: number, orderBy?: string, workshopId?: string, searchTerm?: string, options?: any): AxiosPromise<PagedResultOfCustomerListViewModel> {
            return localVarFp.apiQuotesCustomersGet(pageNo, pageSize, orderBy, workshopId, searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [orderBy] 
         * @param {string} [workshopId] 
         * @param {boolean} [responseSent] 
         * @param {boolean} [customerHasBooked] 
         * @param {string} [bookingStartDate] 
         * @param {string} [bookingEndDate] 
         * @param {string} [searchTerm] 
         * @param {boolean} [bookingRescheduleInProgress] 
         * @param {string} [customerFirstName] 
         * @param {string} [customerLastName] 
         * @param {string} [customerEmail] 
         * @param {string} [customerPhoneNumber]
         * @param {boolean} [responseUnsuccessfulOrExpired]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesGet(pageNo?: number, pageSize?: number, orderBy?: string, workshopId?: string, responseSent?: boolean, customerHasBooked?: boolean, bookingStartDate?: string, bookingEndDate?: string, searchTerm?: string, bookingRescheduleInProgress?: boolean, customerFirstName?: string, customerLastName?: string, customerEmail?: string, customerPhoneNumber?: string, responseUnsuccessfulOrExpired?: boolean, options?: any): AxiosPromise<PagedResultOfQuoteResponseWorkshopViewModel> {
            return localVarFp.apiQuotesGet(pageNo, pageSize, orderBy, workshopId, responseSent, customerHasBooked, bookingStartDate, bookingEndDate, searchTerm, bookingRescheduleInProgress, customerFirstName, customerLastName, customerEmail, customerPhoneNumber, responseUnsuccessfulOrExpired, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesGetGet(referenceNumber?: string, options?: any): AxiosPromise<QuoteRequestAdminViewModel> {
            return localVarFp.apiQuotesGetGet(referenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesGetPublicGet(id?: string, options?: any): AxiosPromise<QuoteRequestPublicViewModel> {
            return localVarFp.apiQuotesGetPublicGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesIdDeclinePut(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiQuotesIdDeclinePut(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesIdGet(id: string, options?: any): AxiosPromise<QuoteResponseWorkshopViewModel> {
            return localVarFp.apiQuotesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {SubmitQuoteResponse} [submitQuoteResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesIdSubmitPut(id: string, submitQuoteResponse?: SubmitQuoteResponse, options?: any): AxiosPromise<SubmitQuoteResponseResultModel> {
            return localVarFp.apiQuotesIdSubmitPut(id, submitQuoteResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RescheduleBookingPublicCommand} [rescheduleBookingPublicCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesRescheduleBookingPublicPut(rescheduleBookingPublicCommand?: RescheduleBookingPublicCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiQuotesRescheduleBookingPublicPut(rescheduleBookingPublicCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RescheduleBookingCommand} [rescheduleBookingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesRescheduleBookingPut(rescheduleBookingCommand?: RescheduleBookingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiQuotesRescheduleBookingPut(rescheduleBookingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReselectQuoteCommand} [reselectQuoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesReselectPut(reselectQuoteCommand?: ReselectQuoteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiQuotesReselectPut(reselectQuoteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RestartQuoteRequestCommand} [restartQuoteRequestCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesRestartPut(restartQuoteRequestCommand?: RestartQuoteRequestCommand, options?: any): AxiosPromise<QuoteRequestPublicViewModel> {
            return localVarFp.apiQuotesRestartPut(restartQuoteRequestCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesSettingsGet(options?: any): AxiosPromise<QuoteSettingsViewModel> {
            return localVarFp.apiQuotesSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateQuoteSettingsCommand} [updateQuoteSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesSettingsPut(updateQuoteSettingsCommand?: UpdateQuoteSettingsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiQuotesSettingsPut(updateQuoteSettingsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [workshopId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesStatisticsGet(workshopId?: string, options?: any): AxiosPromise<WorkshopQuoteStatisticsViewModel> {
            return localVarFp.apiQuotesStatisticsGet(workshopId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmitAdhocQuoteRequest} [submitAdhocQuoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesSubmitAdhocPost(submitAdhocQuoteRequest?: SubmitAdhocQuoteRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiQuotesSubmitAdhocPost(submitAdhocQuoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmitQuoteRequest} [submitQuoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesSubmitPost(submitQuoteRequest?: SubmitQuoteRequest, options?: any): AxiosPromise<QuoteRequestPublicViewModel> {
            return localVarFp.apiQuotesSubmitPost(submitQuoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuotesVatGet(options?: any): AxiosPromise<JsonResponseOfDecimal> {
            return localVarFp.apiQuotesVatGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuotesApi - object-oriented interface
 * @export
 * @class QuotesApi
 * @extends {BaseAPI}
 */
export class QuotesApi extends BaseAPI {
    /**
     * 
     * @param {number} [pageNo] 
     * @param {number} [pageSize] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [searchTerm] 
     * @param {QuoteRequestStatusEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesAdminOpenRequestsGet(pageNo?: number, pageSize?: number, startDate?: string, endDate?: string, searchTerm?: string, status?: QuoteRequestStatusEnum, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesAdminOpenRequestsGet(pageNo, pageSize, startDate, endDate, searchTerm, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateBookingCommand} [createBookingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesBookingPost(createBookingCommand?: CreateBookingCommand, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesBookingPost(createBookingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CancelBookingPublicCommand} [cancelBookingPublicCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesCancelBookingPublicPut(cancelBookingPublicCommand?: CancelBookingPublicCommand, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesCancelBookingPublicPut(cancelBookingPublicCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CancelBookingCommand} [cancelBookingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesCancelBookingPut(cancelBookingCommand?: CancelBookingCommand, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesCancelBookingPut(cancelBookingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteBookingBulkCommand} [completeBookingBulkCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesCompleteBookingBulkPut(completeBookingBulkCommand?: CompleteBookingBulkCommand, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesCompleteBookingBulkPut(completeBookingBulkCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteBookingCommand} [completeBookingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesCompleteBookingPut(completeBookingCommand?: CompleteBookingCommand, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesCompleteBookingPut(completeBookingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageNo] 
     * @param {number} [pageSize] 
     * @param {string} [orderBy] 
     * @param {string} [workshopId] 
     * @param {string} [searchTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesCustomersGet(pageNo?: number, pageSize?: number, orderBy?: string, workshopId?: string, searchTerm?: string, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesCustomersGet(pageNo, pageSize, orderBy, workshopId, searchTerm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageNo] 
     * @param {number} [pageSize] 
     * @param {string} [orderBy] 
     * @param {string} [workshopId] 
     * @param {boolean} [responseSent] 
     * @param {boolean} [customerHasBooked] 
     * @param {string} [bookingStartDate] 
     * @param {string} [bookingEndDate] 
     * @param {string} [searchTerm] 
     * @param {boolean} [bookingRescheduleInProgress] 
     * @param {string} [customerFirstName] 
     * @param {string} [customerLastName] 
     * @param {string} [customerEmail] 
     * @param {string} [customerPhoneNumber]
     * @param {boolean} [responseUnsuccessfulOrExpired]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesGet(pageNo?: number, pageSize?: number, orderBy?: string, workshopId?: string, responseSent?: boolean, customerHasBooked?: boolean, bookingStartDate?: string, bookingEndDate?: string, searchTerm?: string, bookingRescheduleInProgress?: boolean, customerFirstName?: string, customerLastName?: string, customerEmail?: string, customerPhoneNumber?: string, responseUnsuccessfulOrExpired?: boolean, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesGet(pageNo, pageSize, orderBy, workshopId, responseSent, customerHasBooked, bookingStartDate, bookingEndDate, searchTerm, bookingRescheduleInProgress, customerFirstName, customerLastName, customerEmail, customerPhoneNumber, responseUnsuccessfulOrExpired, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [referenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesGetGet(referenceNumber?: string, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesGetGet(referenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesGetPublicGet(id?: string, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesGetPublicGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesIdDeclinePut(id: string, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesIdDeclinePut(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesIdGet(id: string, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {SubmitQuoteResponse} [submitQuoteResponse] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesIdSubmitPut(id: string, submitQuoteResponse?: SubmitQuoteResponse, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesIdSubmitPut(id, submitQuoteResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RescheduleBookingPublicCommand} [rescheduleBookingPublicCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesRescheduleBookingPublicPut(rescheduleBookingPublicCommand?: RescheduleBookingPublicCommand, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesRescheduleBookingPublicPut(rescheduleBookingPublicCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RescheduleBookingCommand} [rescheduleBookingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesRescheduleBookingPut(rescheduleBookingCommand?: RescheduleBookingCommand, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesRescheduleBookingPut(rescheduleBookingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReselectQuoteCommand} [reselectQuoteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesReselectPut(reselectQuoteCommand?: ReselectQuoteCommand, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesReselectPut(reselectQuoteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RestartQuoteRequestCommand} [restartQuoteRequestCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesRestartPut(restartQuoteRequestCommand?: RestartQuoteRequestCommand, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesRestartPut(restartQuoteRequestCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesSettingsGet(options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateQuoteSettingsCommand} [updateQuoteSettingsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesSettingsPut(updateQuoteSettingsCommand?: UpdateQuoteSettingsCommand, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesSettingsPut(updateQuoteSettingsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [workshopId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesStatisticsGet(workshopId?: string, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesStatisticsGet(workshopId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmitAdhocQuoteRequest} [submitAdhocQuoteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesSubmitAdhocPost(submitAdhocQuoteRequest?: SubmitAdhocQuoteRequest, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesSubmitAdhocPost(submitAdhocQuoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmitQuoteRequest} [submitQuoteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesSubmitPost(submitQuoteRequest?: SubmitQuoteRequest, options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesSubmitPost(submitQuoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public apiQuotesVatGet(options?: AxiosRequestConfig) {
        return QuotesApiFp(this.configuration).apiQuotesVatGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RolesApi - axios parameter creator
 * @export
 */
export const RolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClaimsGet: async (pageNumber?: number, pageSize?: number, searchText?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {boolean} [isWorkshopRole] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRolesGet: async (pageNumber?: number, pageSize?: number, searchText?: string, isWorkshopRole?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (isWorkshopRole !== undefined) {
                localVarQueryParameter['isWorkshopRole'] = isWorkshopRole;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRolesIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiRolesIdDelete', 'id', id)
            const localVarPath = `/api/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRolesIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiRolesIdGet', 'id', id)
            const localVarPath = `/api/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateRoleCommand} [updateRoleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRolesIdPut: async (id: string, updateRoleCommand?: UpdateRoleCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiRolesIdPut', 'id', id)
            const localVarPath = `/api/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoleCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRoleCommand} [createRoleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRolesPost: async (createRoleCommand?: CreateRoleCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRoleCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RolesApi - functional programming interface
 * @export
 */
export const RolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClaimsGet(pageNumber?: number, pageSize?: number, searchText?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfClaimListViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClaimsGet(pageNumber, pageSize, searchText, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {boolean} [isWorkshopRole] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRolesGet(pageNumber?: number, pageSize?: number, searchText?: string, isWorkshopRole?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfRoleListViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRolesGet(pageNumber, pageSize, searchText, isWorkshopRole, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRolesIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRolesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRolesIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRolesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateRoleCommand} [updateRoleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRolesIdPut(id: string, updateRoleCommand?: UpdateRoleCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRolesIdPut(id, updateRoleCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateRoleCommand} [createRoleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRolesPost(createRoleCommand?: CreateRoleCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonResponseOfString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRolesPost(createRoleCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RolesApi - factory interface
 * @export
 */
export const RolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RolesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClaimsGet(pageNumber?: number, pageSize?: number, searchText?: string, options?: any): AxiosPromise<PagedResultOfClaimListViewModel> {
            return localVarFp.apiClaimsGet(pageNumber, pageSize, searchText, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {boolean} [isWorkshopRole] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRolesGet(pageNumber?: number, pageSize?: number, searchText?: string, isWorkshopRole?: boolean, options?: any): AxiosPromise<PagedResultOfRoleListViewModel> {
            return localVarFp.apiRolesGet(pageNumber, pageSize, searchText, isWorkshopRole, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRolesIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiRolesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRolesIdGet(id: string, options?: any): AxiosPromise<RoleViewModel> {
            return localVarFp.apiRolesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateRoleCommand} [updateRoleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRolesIdPut(id: string, updateRoleCommand?: UpdateRoleCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiRolesIdPut(id, updateRoleCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRoleCommand} [createRoleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRolesPost(createRoleCommand?: CreateRoleCommand, options?: any): AxiosPromise<JsonResponseOfString> {
            return localVarFp.apiRolesPost(createRoleCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
export class RolesApi extends BaseAPI {
    /**
     * 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {string} [searchText] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public apiClaimsGet(pageNumber?: number, pageSize?: number, searchText?: string, options?: AxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiClaimsGet(pageNumber, pageSize, searchText, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {string} [searchText] 
     * @param {boolean} [isWorkshopRole] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public apiRolesGet(pageNumber?: number, pageSize?: number, searchText?: string, isWorkshopRole?: boolean, options?: AxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiRolesGet(pageNumber, pageSize, searchText, isWorkshopRole, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public apiRolesIdDelete(id: string, options?: AxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiRolesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public apiRolesIdGet(id: string, options?: AxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiRolesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateRoleCommand} [updateRoleCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public apiRolesIdPut(id: string, updateRoleCommand?: UpdateRoleCommand, options?: AxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiRolesIdPut(id, updateRoleCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRoleCommand} [createRoleCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public apiRolesPost(createRoleCommand?: CreateRoleCommand, options?: AxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiRolesPost(createRoleCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ServiceAuditLogsApi - axios parameter creator
 * @export
 */
export const ServiceAuditLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {ServiceAuditTypesEnum} [auditLogType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceAuditLogsServiceAuditLogsGet: async (pageNo?: number, pageSize?: number, searchTerm?: string, auditLogType?: ServiceAuditTypesEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/service-audit-logs/service-audit-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['pageNo'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (auditLogType !== undefined) {
                localVarQueryParameter['auditLogType'] = auditLogType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceAuditLogsApi - functional programming interface
 * @export
 */
export const ServiceAuditLogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceAuditLogsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {ServiceAuditTypesEnum} [auditLogType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceAuditLogsServiceAuditLogsGet(pageNo?: number, pageSize?: number, searchTerm?: string, auditLogType?: ServiceAuditTypesEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfServiceAuditLogListViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceAuditLogsServiceAuditLogsGet(pageNo, pageSize, searchTerm, auditLogType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ServiceAuditLogsApi - factory interface
 * @export
 */
export const ServiceAuditLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceAuditLogsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {ServiceAuditTypesEnum} [auditLogType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceAuditLogsServiceAuditLogsGet(pageNo?: number, pageSize?: number, searchTerm?: string, auditLogType?: ServiceAuditTypesEnum, options?: any): AxiosPromise<PagedResultOfServiceAuditLogListViewModel> {
            return localVarFp.apiServiceAuditLogsServiceAuditLogsGet(pageNo, pageSize, searchTerm, auditLogType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceAuditLogsApi - object-oriented interface
 * @export
 * @class ServiceAuditLogsApi
 * @extends {BaseAPI}
 */
export class ServiceAuditLogsApi extends BaseAPI {
    /**
     * 
     * @param {number} [pageNo] 
     * @param {number} [pageSize] 
     * @param {string} [searchTerm] 
     * @param {ServiceAuditTypesEnum} [auditLogType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceAuditLogsApi
     */
    public apiServiceAuditLogsServiceAuditLogsGet(pageNo?: number, pageSize?: number, searchTerm?: string, auditLogType?: ServiceAuditTypesEnum, options?: AxiosRequestConfig) {
        return ServiceAuditLogsApiFp(this.configuration).apiServiceAuditLogsServiceAuditLogsGet(pageNo, pageSize, searchTerm, auditLogType, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserSettingsApi - axios parameter creator
 * @export
 */
export const UserSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSettingNameDelete: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiUserSettingNameDelete', 'name', name)
            const localVarPath = `/api/user-setting/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSettingNameGet: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiUserSettingNameGet', 'name', name)
            const localVarPath = `/api/user-setting/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSettingNamePost: async (name: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiUserSettingNamePost', 'name', name)
            const localVarPath = `/api/user-setting/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserSettingsApi - functional programming interface
 * @export
 */
export const UserSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserSettingNameDelete(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserSettingNameDelete(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserSettingNameGet(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserSettingNameGet(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} name 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserSettingNamePost(name: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserSettingNamePost(name, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserSettingsApi - factory interface
 * @export
 */
export const UserSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserSettingsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSettingNameDelete(name: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiUserSettingNameDelete(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSettingNameGet(name: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiUserSettingNameGet(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSettingNamePost(name: string, body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiUserSettingNamePost(name, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserSettingsApi - object-oriented interface
 * @export
 * @class UserSettingsApi
 * @extends {BaseAPI}
 */
export class UserSettingsApi extends BaseAPI {
    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsApi
     */
    public apiUserSettingNameDelete(name: string, options?: AxiosRequestConfig) {
        return UserSettingsApiFp(this.configuration).apiUserSettingNameDelete(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsApi
     */
    public apiUserSettingNameGet(name: string, options?: AxiosRequestConfig) {
        return UserSettingsApiFp(this.configuration).apiUserSettingNameGet(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsApi
     */
    public apiUserSettingNamePost(name: string, body?: string, options?: AxiosRequestConfig) {
        return UserSettingsApiFp(this.configuration).apiUserSettingNamePost(name, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {Array<string>} [roleIds] 
         * @param {boolean} [isWorkshopUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersGet: async (pageNumber?: number, pageSize?: number, searchText?: string, roleIds?: Array<string>, isWorkshopUser?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (roleIds) {
                localVarQueryParameter['roleIds'] = roleIds;
            }

            if (isWorkshopUser !== undefined) {
                localVarQueryParameter['isWorkshopUser'] = isWorkshopUser;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdGet', 'id', id)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateUserCommand} [updateUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPut: async (id: string, updateUserCommand?: UpdateUserCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdPut', 'id', id)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateUserCommand} [createUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersPost: async (createUserCommand?: CreateUserCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {Array<string>} [roleIds] 
         * @param {boolean} [isWorkshopUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersGet(pageNumber?: number, pageSize?: number, searchText?: string, roleIds?: Array<string>, isWorkshopUser?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfUserViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersGet(pageNumber, pageSize, searchText, roleIds, isWorkshopUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateUserCommand} [updateUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdPut(id: string, updateUserCommand?: UpdateUserCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdPut(id, updateUserCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateUserCommand} [createUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersPost(createUserCommand?: CreateUserCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonResponseOfString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersPost(createUserCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {Array<string>} [roleIds] 
         * @param {boolean} [isWorkshopUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersGet(pageNumber?: number, pageSize?: number, searchText?: string, roleIds?: Array<string>, isWorkshopUser?: boolean, options?: any): AxiosPromise<PagedResultOfUserViewModel> {
            return localVarFp.apiUsersGet(pageNumber, pageSize, searchText, roleIds, isWorkshopUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdGet(id: string, options?: any): AxiosPromise<UserViewModel> {
            return localVarFp.apiUsersIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateUserCommand} [updateUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPut(id: string, updateUserCommand?: UpdateUserCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiUsersIdPut(id, updateUserCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateUserCommand} [createUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersPost(createUserCommand?: CreateUserCommand, options?: any): AxiosPromise<JsonResponseOfString> {
            return localVarFp.apiUsersPost(createUserCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {string} [searchText] 
     * @param {Array<string>} [roleIds] 
     * @param {boolean} [isWorkshopUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersGet(pageNumber?: number, pageSize?: number, searchText?: string, roleIds?: Array<string>, isWorkshopUser?: boolean, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersGet(pageNumber, pageSize, searchText, roleIds, isWorkshopUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersIdGet(id: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateUserCommand} [updateUserCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersIdPut(id: string, updateUserCommand?: UpdateUserCommand, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdPut(id, updateUserCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateUserCommand} [createUserCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersPost(createUserCommand?: CreateUserCommand, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersPost(createUserCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VehiclesApi - axios parameter creator
 * @export
 */
export const VehiclesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesManufacturersGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/vehicles/manufacturers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [manufacturer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesModelsGet: async (manufacturer?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/vehicles/models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [model] 
         * @param {string} [manufacturer] 
         * @param {string} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesSpecificationsGet: async (model?: string, manufacturer?: string, year?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/vehicles/specifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [model] 
         * @param {string} [manufacturer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesYearsGet: async (model?: string, manufacturer?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/vehicles/years`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehiclesApi - functional programming interface
 * @export
 */
export const VehiclesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehiclesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVehiclesManufacturersGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonResponseOfListOfString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVehiclesManufacturersGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [manufacturer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVehiclesModelsGet(manufacturer?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonResponseOfListOfString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVehiclesModelsGet(manufacturer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [model] 
         * @param {string} [manufacturer] 
         * @param {string} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVehiclesSpecificationsGet(model?: string, manufacturer?: string, year?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonResponseOfListOfString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVehiclesSpecificationsGet(model, manufacturer, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [model] 
         * @param {string} [manufacturer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVehiclesYearsGet(model?: string, manufacturer?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonResponseOfListOfString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVehiclesYearsGet(model, manufacturer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VehiclesApi - factory interface
 * @export
 */
export const VehiclesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehiclesApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesManufacturersGet(options?: any): AxiosPromise<JsonResponseOfListOfString> {
            return localVarFp.apiVehiclesManufacturersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [manufacturer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesModelsGet(manufacturer?: string, options?: any): AxiosPromise<JsonResponseOfListOfString> {
            return localVarFp.apiVehiclesModelsGet(manufacturer, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [model] 
         * @param {string} [manufacturer] 
         * @param {string} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesSpecificationsGet(model?: string, manufacturer?: string, year?: string, options?: any): AxiosPromise<JsonResponseOfListOfString> {
            return localVarFp.apiVehiclesSpecificationsGet(model, manufacturer, year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [model] 
         * @param {string} [manufacturer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVehiclesYearsGet(model?: string, manufacturer?: string, options?: any): AxiosPromise<JsonResponseOfListOfString> {
            return localVarFp.apiVehiclesYearsGet(model, manufacturer, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VehiclesApi - object-oriented interface
 * @export
 * @class VehiclesApi
 * @extends {BaseAPI}
 */
export class VehiclesApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiVehiclesManufacturersGet(options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiVehiclesManufacturersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [manufacturer] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiVehiclesModelsGet(manufacturer?: string, options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiVehiclesModelsGet(manufacturer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [model] 
     * @param {string} [manufacturer] 
     * @param {string} [year] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiVehiclesSpecificationsGet(model?: string, manufacturer?: string, year?: string, options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiVehiclesSpecificationsGet(model, manufacturer, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [model] 
     * @param {string} [manufacturer] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiVehiclesYearsGet(model?: string, manufacturer?: string, options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiVehiclesYearsGet(model, manufacturer, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WorkshopUsersApi - axios parameter creator
 * @export
 */
export const WorkshopUsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {Array<string>} [roleIds] 
         * @param {string} [workshopId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopusersGet: async (pageNumber?: number, pageSize?: number, searchText?: string, roleIds?: Array<string>, workshopId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workshopusers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (roleIds) {
                localVarQueryParameter['roleIds'] = roleIds;
            }

            if (workshopId !== undefined) {
                localVarQueryParameter['workshopId'] = workshopId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [workshopId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopusersIdGet: async (id: string, workshopId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiWorkshopusersIdGet', 'id', id)
            const localVarPath = `/api/workshopusers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (workshopId !== undefined) {
                localVarQueryParameter['workshopId'] = workshopId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateWorkshopUserCommand} [updateWorkshopUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopusersPut: async (updateWorkshopUserCommand?: UpdateWorkshopUserCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workshopusers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkshopUserCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkshopUsersApi - functional programming interface
 * @export
 */
export const WorkshopUsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkshopUsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {Array<string>} [roleIds] 
         * @param {string} [workshopId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkshopusersGet(pageNumber?: number, pageSize?: number, searchText?: string, roleIds?: Array<string>, workshopId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfWorkshopUserViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkshopusersGet(pageNumber, pageSize, searchText, roleIds, workshopId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [workshopId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkshopusersIdGet(id: string, workshopId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkshopUserViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkshopusersIdGet(id, workshopId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateWorkshopUserCommand} [updateWorkshopUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkshopusersPut(updateWorkshopUserCommand?: UpdateWorkshopUserCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkshopusersPut(updateWorkshopUserCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WorkshopUsersApi - factory interface
 * @export
 */
export const WorkshopUsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkshopUsersApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {Array<string>} [roleIds] 
         * @param {string} [workshopId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopusersGet(pageNumber?: number, pageSize?: number, searchText?: string, roleIds?: Array<string>, workshopId?: string, options?: any): AxiosPromise<PagedResultOfWorkshopUserViewModel> {
            return localVarFp.apiWorkshopusersGet(pageNumber, pageSize, searchText, roleIds, workshopId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [workshopId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopusersIdGet(id: string, workshopId?: string, options?: any): AxiosPromise<WorkshopUserViewModel> {
            return localVarFp.apiWorkshopusersIdGet(id, workshopId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateWorkshopUserCommand} [updateWorkshopUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopusersPut(updateWorkshopUserCommand?: UpdateWorkshopUserCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiWorkshopusersPut(updateWorkshopUserCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkshopUsersApi - object-oriented interface
 * @export
 * @class WorkshopUsersApi
 * @extends {BaseAPI}
 */
export class WorkshopUsersApi extends BaseAPI {
    /**
     * 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {string} [searchText] 
     * @param {Array<string>} [roleIds] 
     * @param {string} [workshopId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopUsersApi
     */
    public apiWorkshopusersGet(pageNumber?: number, pageSize?: number, searchText?: string, roleIds?: Array<string>, workshopId?: string, options?: AxiosRequestConfig) {
        return WorkshopUsersApiFp(this.configuration).apiWorkshopusersGet(pageNumber, pageSize, searchText, roleIds, workshopId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} [workshopId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopUsersApi
     */
    public apiWorkshopusersIdGet(id: string, workshopId?: string, options?: AxiosRequestConfig) {
        return WorkshopUsersApiFp(this.configuration).apiWorkshopusersIdGet(id, workshopId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateWorkshopUserCommand} [updateWorkshopUserCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopUsersApi
     */
    public apiWorkshopusersPut(updateWorkshopUserCommand?: UpdateWorkshopUserCommand, options?: AxiosRequestConfig) {
        return WorkshopUsersApiFp(this.configuration).apiWorkshopusersPut(updateWorkshopUserCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WorkshopsApi - axios parameter creator
 * @export
 */
export const WorkshopsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsForUserGet: async (pageNumber?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workshops/for-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {number} [statusId] 
         * @param {string} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsGet: async (pageNumber?: number, pageSize?: number, searchText?: string, statusId?: number, orderBy?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workshops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (statusId !== undefined) {
                localVarQueryParameter['statusId'] = statusId;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiWorkshopsIdDelete', 'id', id)
            const localVarPath = `/api/workshops/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiWorkshopsIdGet', 'id', id)
            const localVarPath = `/api/workshops/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateWorkshopCommand} [updateWorkshopCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsIdPut: async (id: string, updateWorkshopCommand?: UpdateWorkshopCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiWorkshopsIdPut', 'id', id)
            const localVarPath = `/api/workshops/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkshopCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsIdQuoteSettingsGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiWorkshopsIdQuoteSettingsGet', 'id', id)
            const localVarPath = `/api/workshops/{id}/quote-settings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateWorkshopQuoteSettingsCommand} [updateWorkshopQuoteSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsIdQuoteSettingsPut: async (id: string, updateWorkshopQuoteSettingsCommand?: UpdateWorkshopQuoteSettingsCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiWorkshopsIdQuoteSettingsPut', 'id', id)
            const localVarPath = `/api/workshops/{id}/quote-settings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkshopQuoteSettingsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ImportWorkshopsCommand} [importWorkshopsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsImportPost: async (importWorkshopsCommand?: ImportWorkshopsCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workshops/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importWorkshopsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateWorkshopCommand} [createWorkshopCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsPost: async (createWorkshopCommand?: CreateWorkshopCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workshops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWorkshopCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [address] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsPublicGet: async (address?: string, name?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workshops/public`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkshopsApi - functional programming interface
 * @export
 */
export const WorkshopsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkshopsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkshopsForUserGet(pageNumber?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfWorkshopViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkshopsForUserGet(pageNumber, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {number} [statusId] 
         * @param {string} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkshopsGet(pageNumber?: number, pageSize?: number, searchText?: string, statusId?: number, orderBy?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfWorkshopViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkshopsGet(pageNumber, pageSize, searchText, statusId, orderBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkshopsIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkshopsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkshopsIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkshopViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkshopsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateWorkshopCommand} [updateWorkshopCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkshopsIdPut(id: string, updateWorkshopCommand?: UpdateWorkshopCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkshopsIdPut(id, updateWorkshopCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkshopsIdQuoteSettingsGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkshopQuoteSettingsViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkshopsIdQuoteSettingsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateWorkshopQuoteSettingsCommand} [updateWorkshopQuoteSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkshopsIdQuoteSettingsPut(id: string, updateWorkshopQuoteSettingsCommand?: UpdateWorkshopQuoteSettingsCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkshopsIdQuoteSettingsPut(id, updateWorkshopQuoteSettingsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ImportWorkshopsCommand} [importWorkshopsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkshopsImportPost(importWorkshopsCommand?: ImportWorkshopsCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonResponseOfListOfString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkshopsImportPost(importWorkshopsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateWorkshopCommand} [createWorkshopCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkshopsPost(createWorkshopCommand?: CreateWorkshopCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JsonResponseOfGuid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkshopsPost(createWorkshopCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [address] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkshopsPublicGet(address?: string, name?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkshopPublicViewModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkshopsPublicGet(address, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WorkshopsApi - factory interface
 * @export
 */
export const WorkshopsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkshopsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsForUserGet(pageNumber?: number, pageSize?: number, options?: any): AxiosPromise<PagedResultOfWorkshopViewModel> {
            return localVarFp.apiWorkshopsForUserGet(pageNumber, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {number} [statusId] 
         * @param {string} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsGet(pageNumber?: number, pageSize?: number, searchText?: string, statusId?: number, orderBy?: string, options?: any): AxiosPromise<PagedResultOfWorkshopViewModel> {
            return localVarFp.apiWorkshopsGet(pageNumber, pageSize, searchText, statusId, orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiWorkshopsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsIdGet(id: string, options?: any): AxiosPromise<WorkshopViewModel> {
            return localVarFp.apiWorkshopsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateWorkshopCommand} [updateWorkshopCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsIdPut(id: string, updateWorkshopCommand?: UpdateWorkshopCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiWorkshopsIdPut(id, updateWorkshopCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsIdQuoteSettingsGet(id: string, options?: any): AxiosPromise<WorkshopQuoteSettingsViewModel> {
            return localVarFp.apiWorkshopsIdQuoteSettingsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateWorkshopQuoteSettingsCommand} [updateWorkshopQuoteSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsIdQuoteSettingsPut(id: string, updateWorkshopQuoteSettingsCommand?: UpdateWorkshopQuoteSettingsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiWorkshopsIdQuoteSettingsPut(id, updateWorkshopQuoteSettingsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ImportWorkshopsCommand} [importWorkshopsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsImportPost(importWorkshopsCommand?: ImportWorkshopsCommand, options?: any): AxiosPromise<JsonResponseOfListOfString> {
            return localVarFp.apiWorkshopsImportPost(importWorkshopsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateWorkshopCommand} [createWorkshopCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsPost(createWorkshopCommand?: CreateWorkshopCommand, options?: any): AxiosPromise<JsonResponseOfGuid> {
            return localVarFp.apiWorkshopsPost(createWorkshopCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [address] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkshopsPublicGet(address?: string, name?: string, options?: any): AxiosPromise<Array<WorkshopPublicViewModel>> {
            return localVarFp.apiWorkshopsPublicGet(address, name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkshopsApi - object-oriented interface
 * @export
 * @class WorkshopsApi
 * @extends {BaseAPI}
 */
export class WorkshopsApi extends BaseAPI {
    /**
     * 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopsApi
     */
    public apiWorkshopsForUserGet(pageNumber?: number, pageSize?: number, options?: AxiosRequestConfig) {
        return WorkshopsApiFp(this.configuration).apiWorkshopsForUserGet(pageNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {string} [searchText] 
     * @param {number} [statusId] 
     * @param {string} [orderBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopsApi
     */
    public apiWorkshopsGet(pageNumber?: number, pageSize?: number, searchText?: string, statusId?: number, orderBy?: string, options?: AxiosRequestConfig) {
        return WorkshopsApiFp(this.configuration).apiWorkshopsGet(pageNumber, pageSize, searchText, statusId, orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopsApi
     */
    public apiWorkshopsIdDelete(id: string, options?: AxiosRequestConfig) {
        return WorkshopsApiFp(this.configuration).apiWorkshopsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopsApi
     */
    public apiWorkshopsIdGet(id: string, options?: AxiosRequestConfig) {
        return WorkshopsApiFp(this.configuration).apiWorkshopsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateWorkshopCommand} [updateWorkshopCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopsApi
     */
    public apiWorkshopsIdPut(id: string, updateWorkshopCommand?: UpdateWorkshopCommand, options?: AxiosRequestConfig) {
        return WorkshopsApiFp(this.configuration).apiWorkshopsIdPut(id, updateWorkshopCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopsApi
     */
    public apiWorkshopsIdQuoteSettingsGet(id: string, options?: AxiosRequestConfig) {
        return WorkshopsApiFp(this.configuration).apiWorkshopsIdQuoteSettingsGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateWorkshopQuoteSettingsCommand} [updateWorkshopQuoteSettingsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopsApi
     */
    public apiWorkshopsIdQuoteSettingsPut(id: string, updateWorkshopQuoteSettingsCommand?: UpdateWorkshopQuoteSettingsCommand, options?: AxiosRequestConfig) {
        return WorkshopsApiFp(this.configuration).apiWorkshopsIdQuoteSettingsPut(id, updateWorkshopQuoteSettingsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ImportWorkshopsCommand} [importWorkshopsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopsApi
     */
    public apiWorkshopsImportPost(importWorkshopsCommand?: ImportWorkshopsCommand, options?: AxiosRequestConfig) {
        return WorkshopsApiFp(this.configuration).apiWorkshopsImportPost(importWorkshopsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateWorkshopCommand} [createWorkshopCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopsApi
     */
    public apiWorkshopsPost(createWorkshopCommand?: CreateWorkshopCommand, options?: AxiosRequestConfig) {
        return WorkshopsApiFp(this.configuration).apiWorkshopsPost(createWorkshopCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [address] 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopsApi
     */
    public apiWorkshopsPublicGet(address?: string, name?: string, options?: AxiosRequestConfig) {
        return WorkshopsApiFp(this.configuration).apiWorkshopsPublicGet(address, name, options).then((request) => request(this.axios, this.basePath));
    }
}


